import { useState } from 'react'
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"

const SchoolBadgeHolder = () => {
    const homeMenu = [ 
        { label: "Awards & Achievements", link: "/awardsAcheivements" },
        {
            label: "Gallery", link: "", subMenu: [
                { label: "Photo Gallery", link: "/gallery" },
                { label: "Video Gallery", link: "/VideoGallery" },
            ]
        },

        { label: "Careers", link: "/careers-openings", subMenu: [
            { label: "Philosophy", link: "/philosophy" }, 
        ]},
        { label: "School Calendar", link: "/calender" },
        {
            label: "Alumni", link: "", subMenu: [
                { label: "Admissions", link: "/admission" },
               { label: "Admissions IIT", link: "/admissionIIT" },
            ]
        },

        { label: "eMagazine", link: "/magazine" },
        { label: "CUET", link: "https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/CUET.pdf" },
    ]
    const [filterData, setFilterData] = useState("0")
    const filterYear = (value) => {
        setFilterData(value);
    }
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/admissions-banner.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Scholar Badge Holders" breadEnd="Scholar Badge Holders" breadMid="Scholar Badge Holders" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="selection_list mb-4 float-end">
                                <select onChange={(e) => filterYear(e.target.value)} className='p-2'>
                                    <option value="0">Year 2023-2024</option>
                                    <option value="1">Year 2022-2023</option>
                                    <option value="2">Year 2021-2022</option>
                                    <option value="3">Year 2020-2021</option>
                                    <option value="4">Year 2019-2020</option>
                                </select>
                            </div>
                            {filterData === "0" && (
                                <div class="">
                                    <div class="heading2 text-center">
                                        <h4>Scholar Badge Holders 2023-24</h4>
                                    </div>
                                    <div class="table">
                                        <table className='table-view' cellspacing="0" cellpadding="0">

                                            <tbody><tr>
                                                <th colspan="7">DETAILS    FOR THE SCHOLAR CERTIFICATES : GRADE V (2023-24)</th>
                                            </tr>
                                                <tr>
                                                    <th colspan="7">Aggregate 90% &amp; Above</th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAMES</th>
                                                    <th rowspan="2">GRADE -    V<br />
                                                        (2023-24)</th>
                                                    <th rowspan="2">%</th>
                                                    <th rowspan="2">SESSION</th>
                                                    <th colspan="2">SCHOLAR STATUS</th>
                                                </tr>
                                                <tr>
                                                    <td>BADGE</td>
                                                    <td>POCKET</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>ADVAY BANSAL</td>
                                                    <td rowspan="12">BIRCHES</td>
                                                    <td>95.48</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>AHAAN SHIVHARE</td>
                                                    <td>92.5</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>ANYA BISHT</td>
                                                    <td>95.48</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>ARAV MEHROTRA</td>
                                                    <td>93.02</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>ATHARV KHANNA</td>
                                                    <td>94.7</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>ATIKSHA SHARMA</td>
                                                    <td>94.06</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>HARSHVARDHAN AGARWAL</td>
                                                    <td>92.9</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>PRISHA GUPTA</td>
                                                    <td>90.34</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>PRISHA SINDHWANI</td>
                                                    <td>89.98</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>RIDIT SINGLA</td>
                                                    <td>94.42</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>YASHVARDHAN KALRA</td>
                                                    <td>97.58</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>YUVAAN RANJAN</td>
                                                    <td>94.68</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>AIRA GOYLE</td>
                                                    <td rowspan="13">BURANS</td>
                                                    <td>89.88</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>DHRUV SARIN</td>
                                                    <td>91.86</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>HANNA DALAL</td>
                                                    <td>92.76</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>INAYA ABBI</td>
                                                    <td>94.56</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>KRIDAY SHARMA</td>
                                                    <td>90.4</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>LEYSHA MALIK</td>
                                                    <td>90.68</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>MANVIK SINGH</td>
                                                    <td>90.1</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>MYRA KHURANA</td>
                                                    <td>96.42</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>PRISHA BATRA</td>
                                                    <td>90.9</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>SAMAIRA MISRA</td>
                                                    <td>90.84</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>SANVI CHAUDHARY</td>
                                                    <td>92.22</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>SHREYASI SINGH</td>
                                                    <td>91.74</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>VIHAAN GUPTA</td>
                                                    <td>94.3</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>AARNAV ARORA</td>
                                                    <td rowspan="11">CEDARS</td>
                                                    <td>91.2</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>ARSH KAUSHAL</td>
                                                    <td>89.76</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>BHOMYA SHARMA</td>
                                                    <td>91.17</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>KAYAAN SAXENA</td>
                                                    <td>91.84</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>NAVISHA GOYAL</td>
                                                    <td>91.01</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>RISHAAN GUPTA</td>
                                                    <td>93.52</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>SAIYAM NAGPAL</td>
                                                    <td>94.72</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>SARUCHI GULATI</td>
                                                    <td>94.08</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>SIDDHI MANOCHA</td>
                                                    <td>95.28</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>SPARSH MITTAL</td>
                                                    <td>89.92</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>VANSHIKA BALLABH</td>
                                                    <td>94.56</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>AARUSH JAIN</td>
                                                    <td rowspan="12">MAPLES</td>
                                                    <td>90.62</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>IVANA AGARWAL</td>
                                                    <td>95.8</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>MAAN THAPLIYAL</td>
                                                    <td>92.72</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>PARTH AGARWAL</td>
                                                    <td>90.72</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>PARTH JAIN</td>
                                                    <td>90.96</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>REYANSHI AGARWAL</td>
                                                    <td>92.46</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>RIAAN CHUGH</td>
                                                    <td>90.4</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>SARTHAK BAKSHI</td>
                                                    <td>90.04</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>SHTAKSHI AGNIHOTRI</td>
                                                    <td>93.34</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>SIBANI JAIN</td>
                                                    <td>94.86</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>SIDHART NAMBIAR</td>
                                                    <td>90.12</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>YASHIKA SINGH</td>
                                                    <td>91.28</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>ALYSHA SHARMA</td>
                                                    <td rowspan="10">NEEMS</td>
                                                    <td>96.72</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>ARTHAK SHUKLA</td>
                                                    <td>91.3</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>ARYAMAN GUPTA</td>
                                                    <td>91.11</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>ATHARV SHARMA</td>
                                                    <td>92.04</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>AYUSH MAJUMDAR</td>
                                                    <td>91.28</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>AZALEA CHELLANI KUMAR</td>
                                                    <td>90.78</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>DHRUV BABBAR</td>
                                                    <td>95.04</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>DIA KAPUR</td>
                                                    <td>94.94</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>NAISHA KAPOOR</td>
                                                    <td>91.08</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>TOSHANNIE SUMIT SETIA</td>
                                                    <td>92.96</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>AGASTYA SAXENA</td>
                                                    <td rowspan="10">OAKS</td>
                                                    <td>92.38</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>60</td>
                                                    <td>ARADHYA MIGLANI</td>
                                                    <td>91.66</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>61</td>
                                                    <td>GEETANSHI CHOPRA</td>
                                                    <td>90.54</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>62</td>
                                                    <td>IDHA SACHDEVA</td>
                                                    <td>90.74</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>63</td>
                                                    <td>LAVANYA AGARWAL</td>
                                                    <td>94.52</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>64</td>
                                                    <td>MYRA KHANDELWAL</td>
                                                    <td>93.52</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>65</td>
                                                    <td>SANVI SHARMA</td>
                                                    <td>90.84</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>66</td>
                                                    <td>SHAURYA CHADHA</td>
                                                    <td>95.52</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>67</td>
                                                    <td>TAISHA BATRA</td>
                                                    <td>92.4</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>68</td>
                                                    <td>ZENA CHAUHAN</td>
                                                    <td>93.08</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>69</td>
                                                    <td>ADVAITH ADARSH KURUP</td>
                                                    <td rowspan="14">OLIVES</td>
                                                    <td>95.16</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>70</td>
                                                    <td>ADVAY GUPTA</td>
                                                    <td>91.84</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>71</td>
                                                    <td>ANVAY GOYAL</td>
                                                    <td>94.8</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>72</td>
                                                    <td>ANYA KAPOOR</td>
                                                    <td>91.26</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>73</td>
                                                    <td>ASAD SALROO</td>
                                                    <td>93.64</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>74</td>
                                                    <td>AVNI MITTAL</td>
                                                    <td>94.7</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>75</td>
                                                    <td>AYAAN KAPOOR</td>
                                                    <td>93.24</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>76</td>
                                                    <td>MYRA GUPTA</td>
                                                    <td>91.08</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>77</td>
                                                    <td>NAYSHA SATIJA</td>
                                                    <td>92.74</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>78</td>
                                                    <td>REYANSH GUPTA</td>
                                                    <td>90.18</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>79</td>
                                                    <td>RIDIT SHAH</td>
                                                    <td>93.42</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>80</td>
                                                    <td>RUDRAKSH SINGH</td>
                                                    <td>92.08</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>81</td>
                                                    <td>TARINI BANERJEE</td>
                                                    <td>90.58</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>82</td>
                                                    <td>VIDHI HAMIRWASIA</td>
                                                    <td>94.28</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>CERTIFICATES</td>
                                                    <td>82</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Pink Badges</td>
                                                    <td>82</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Grey Pockets</td>
                                                    <td>82</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>COMPARATIVE ANALYSIS</td>
                                                    <td>2023-24</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Total Strength</td>
                                                    <td>213</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Scholars</td>
                                                    <td>82</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>%</td>
                                                    <td>39%</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody></table>
                                        <table className='table-view' border="1" width="100%">
                                            <tbody><tr>
                                                <th colspan="8">DETAILS FOR THE SCHOLAR    CERTIFICATES : GRADE VI (2023-24)</th>
                                            </tr>
                                                <tr>
                                                    <th colspan="8">Aggregate 90% &amp; Above</th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAMES</th>
                                                    <th rowspan="2">GRADE - VI <br />
                                                        (2023-24)</th>
                                                    <th rowspan="2">GRADE - VII (2024-25)</th>
                                                    <th rowspan="2">%</th>
                                                    <th rowspan="2">SESSION</th>
                                                    <th colspan="2">SCHOLAR STATUS</th>
                                                </tr>
                                                <tr>
                                                    <td>BADGE</td>
                                                    <td>POCKET</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AARAV ARORA</td>
                                                    <td rowspan="9">BEAS</td>
                                                    <td rowspan="9">CHENAB</td>
                                                    <td>90.48</td>
                                                    <td>2022-23, 2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>AMAIRA VERMA</td>
                                                    <td>89.62</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>ANAHIT KAUR ISHER</td>
                                                    <td>94.28</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>ARHAN JAIN</td>
                                                    <td>91.04</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>IRA AWASTHI</td>
                                                    <td>89.66</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>KRISHNAV CHAUDHRY</td>
                                                    <td>89.94</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>MD ADYAN RIZVI</td>
                                                    <td>97.12</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>SHAY LAL</td>
                                                    <td>90.46</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>SPARSH JAIN</td>
                                                    <td>95</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>AARADHYA NEGI</td>
                                                    <td rowspan="5">BRAHMAPUTRA</td>
                                                    <td rowspan="5">DAMODAR</td>
                                                    <td>90.72</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>OM GUPTA</td>
                                                    <td>91.18</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>PALAK AGGARWAL</td>
                                                    <td>93.47</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>SHANAYA AGGARWAL</td>
                                                    <td>92.7</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>VANYA YADAV</td>
                                                    <td>89.56</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>AARAV SHARMA</td>
                                                    <td rowspan="7">GANGES</td>
                                                    <td rowspan="7">INDUS</td>
                                                    <td>92.7</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>ATHARVA SINGH</td>
                                                    <td>94.26</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>JAINEIL VERMA</td>
                                                    <td>92.06</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>NIKITA MEMANI</td>
                                                    <td>91.1</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>PRAKRITI</td>
                                                    <td>91.4</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>RIDDHI JOSHI</td>
                                                    <td>93.36</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>SAANVI KHAMESRA</td>
                                                    <td>92.68</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>ADVAY GUPTA</td>
                                                    <td rowspan="13">GODAVARI</td>
                                                    <td rowspan="13">JHELUM</td>
                                                    <td>91.58</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>ALAINA KOHLI</td>
                                                    <td>95.08</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>AMYRA SINGH</td>
                                                    <td>91.92</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>AVYA JINDAL</td>
                                                    <td>89.88</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>DARSH JANGRA</td>
                                                    <td>89.76</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>MUGDHA WALIA</td>
                                                    <td>89.64</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>NAVYA GERA</td>
                                                    <td>90.68</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>RAYAANSH JAIN</td>
                                                    <td>92.58</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>SHAAN SETHI BAHL</td>
                                                    <td>89.62</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>SHAURYA PALIWAL</td>
                                                    <td>93.84</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>TANUSHI GUPTA</td>
                                                    <td>90.1</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>VIHAAN SINGH (W/D)</td>
                                                    <td>93.26</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>VIVAAN ARORA</td>
                                                    <td>91.04</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>AADVIK GUPTA</td>
                                                    <td rowspan="10">KAVERI</td>
                                                    <td rowspan="10">MAHANADI</td>
                                                    <td>96.18</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>AARTI MIGLANI</td>
                                                    <td>92.12</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>AMAIRA KHANNA</td>
                                                    <td>89.62</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>ARADHYA BATRA</td>
                                                    <td>90.88</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>GYANVI JHAMB</td>
                                                    <td>90.42</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>LAKSHYA BHANSALI</td>
                                                    <td>89.96</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>RABHYA SHARMA</td>
                                                    <td>93.62</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>SHAURYA BANSAL</td>
                                                    <td>90.62</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>SIDDHANT JAIN</td>
                                                    <td>93.42</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>VIVAAN ARORA</td>
                                                    <td>89.84</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>ANUSHA SHRIVASTAVA</td>
                                                    <td rowspan="6">NARMADA</td>
                                                    <td rowspan="6">RAVI</td>
                                                    <td>92.04</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>AROHI BEEJAWAT</td>
                                                    <td>91.76</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>KIARA JAI PRAKASH</td>
                                                    <td>92.62</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>MAHI KAPOOR</td>
                                                    <td>92.05</td>
                                                    <td>2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>RIYANT BANSAL</td>
                                                    <td>91.1</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>VISHIST BAJPAI (W/D)</td>
                                                    <td>91.24</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>AADIT SINGH</td>
                                                    <td rowspan="8">SUTLEJ</td>
                                                    <td rowspan="8">TAPTI</td>
                                                    <td>97.26</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>AANYA SHARMA</td>
                                                    <td>92.3</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>ALAINA SALUJA</td>
                                                    <td>90.04</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>GIANNA SINGH</td>
                                                    <td>90.52</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>JIVITESH YADAV</td>
                                                    <td>91.88</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>KRITIKA VASHISHTH</td>
                                                    <td>93.6</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>PRITIKA GUPTA</td>
                                                    <td>93.96</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>RONAV PANDEY</td>
                                                    <td>95.52</td>
                                                    <td>2022-23,2023-24</td>
                                                    <td>Pink</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="5">TOTAL SCHOLARS IN GRADE VI (2023-24) = 58 (W/D) = 2</td>
                                                    <td>&nbsp;</td>
                                                    <td>56</td>
                                                    <td>56</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>CERTIFICATES</td>
                                                    <td>58</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Pink Badges</td>
                                                    <td>56</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Grey Pockets</td>
                                                    <td>56</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>COMPARATIVE ANALYSIS</td>
                                                    <td>2022-23</td>
                                                    <td>2023-24</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Total Strength</td>
                                                    <td>208</td>
                                                    <td>203</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Scholars</td>
                                                    <td>97</td>
                                                    <td>58</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>%</td>
                                                    <td>46.63%</td>
                                                    <td>29%</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody></table>
                                        <table className='table-view' border="1" width="100%">
                                            <tbody>
                                                <tr>
                                                <th colspan="9">DETAILS FOR THE    SCHOLAR CERTIFICATES : GRADE VII (2023-24)</th>
                                            </tr>
                                                <tr>
                                                    <th colspan="9">Aggregate 90% &amp; Above</th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAMES</th>
                                                    <th rowspan="2">GRADE - VII (2023-24)</th>
                                                    <th rowspan="2">GRADE - VIII (2024-25)</th>
                                                    <th rowspan="2">% (GRADE    VII) <br />
                                                        2023-24</th>
                                                    <th rowspan="2">SESSION</th>
                                                    <th rowspan="2">BADGE</th>
                                                    <th rowspan="2">POCKET</th>
                                                    <th rowspan="2">BLAZER</th>
                                                </tr>
                                                <tr> </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AMAIRA WADHWA</td>
                                                    <td rowspan="8">CHENAB</td>
                                                    <td rowspan="8">AMAZON</td>
                                                    <td>93.04</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>ANISHA SHARMA (NEW ADMISSION)</td>
                                                    <td>92.86</td>
                                                    <td>2023-24</td>
                                                    <td>PINK</td>
                                                    <td>GREY</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>ARNAV GARG</td>
                                                    <td>93.2</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>ATHARV GUPTA</td>
                                                    <td>92.22</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>DIVIT RASTOGI</td>
                                                    <td>95.8</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>MANIT BHASIN</td>
                                                    <td>87.72</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>RED BLAZER FOR SPORTS</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>SAANVI KUKREJA</td>
                                                    <td>96.96</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>VEDANJALI SHAH</td>
                                                    <td>92.88</td>
                                                    <td>2023-24, 2022-23</td>
                                                    <td>PINK</td>
                                                    <td>GREY</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>AADVIK SOOD</td>
                                                    <td rowspan="7">DAMODAR</td>
                                                    <td rowspan="7">COLORADO</td>
                                                    <td>89.7</td>
                                                    <td>2023-24</td>
                                                    <td>PINK</td>
                                                    <td>GREY</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>CHAITANYA SRIVASTAVA</td>
                                                    <td>91.5</td>
                                                    <td>2023-24</td>
                                                    <td>PINK</td>
                                                    <td>GREY</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>KIAAN GARG</td>
                                                    <td>90.08</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>NAUNIDH SETTHEE</td>
                                                    <td>90.12</td>
                                                    <td>2023-24</td>
                                                    <td>PINK</td>
                                                    <td>GREY</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>RAIZEL TANEJA</td>
                                                    <td>91.92</td>
                                                    <td>2023-24, 2022-23</td>
                                                    <td>PINK</td>
                                                    <td>GREY</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>SHREYASH KANODIA</td>
                                                    <td>90.74</td>
                                                    <td>2023-24</td>
                                                    <td>PINK</td>
                                                    <td>GREY</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>YUVRAJ CHAUDHARY</td>
                                                    <td>93.3</td>
                                                    <td>2023-24, 2022-23,2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>AVIRAT CHOPRA</td>
                                                    <td rowspan="8">INDUS</td>
                                                    <td rowspan="8">CONGO</td>
                                                    <td>95.1</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>DHRUV BHARTI</td>
                                                    <td>92.3</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>INIKA MALIK</td>
                                                    <td>90.26</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>ISHIKA AGGARWAL</td>
                                                    <td>91.88</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>JIVANSH NANGRU</td>
                                                    <td>93.42</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>NIMISHA SINGH</td>
                                                    <td>90</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>VIHAAN VIDWANS</td>
                                                    <td>89.72</td>
                                                    <td>2023-24</td>
                                                    <td>PINK</td>
                                                    <td>GREY</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>YAJUR MEHRA</td>
                                                    <td>91.74</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>AANYA SHARMA</td>
                                                    <td rowspan="8">JHELUM</td>
                                                    <td rowspan="8">DANUBE</td>
                                                    <td>90.8</td>
                                                    <td>2023-24,2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>ARSHIYA GARG</td>
                                                    <td>96.28</td>
                                                    <td>2023-24,2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>JAYANTIKA BHATTACHARJYA</td>
                                                    <td>90.32</td>
                                                    <td>2023-24,2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>NAVIKA ARORA</td>
                                                    <td>94.88</td>
                                                    <td>2023-24,2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>NISHKA SHARMA</td>
                                                    <td>94.26</td>
                                                    <td>2023-24,2022-23</td>
                                                    <td>PINK</td>
                                                    <td>GREY</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>PRISHA AHUJA</td>
                                                    <td>92.24</td>
                                                    <td>2023-24,2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>SAKSHAM MITTAL</td>
                                                    <td>93.26</td>
                                                    <td>2023-24,2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>SUMANYU SHARMA</td>
                                                    <td>96.7</td>
                                                    <td>2023-24,2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>AANYA VERMA</td>
                                                    <td rowspan="9">MAHANADI</td>
                                                    <td rowspan="9">MISSISSIPPI</td>
                                                    <td>94.4</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>MAYRA NAGPAL</td>
                                                    <td>96.06</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>MYRA GANDHI</td>
                                                    <td>93.8</td>
                                                    <td>2023-24</td>
                                                    <td>PINK</td>
                                                    <td>GREY</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>PAVNI MEHTA</td>
                                                    <td>92.46</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>VEDAGYA SINGHAL</td>
                                                    <td>90.22</td>
                                                    <td>2023-24</td>
                                                    <td>PINK</td>
                                                    <td>GREY</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>VIHAAN BANSAL</td>
                                                    <td>95.28</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>VIHAAN JAIN</td>
                                                    <td>93.4</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>VIVAAN CHANDNA</td>
                                                    <td>89.84</td>
                                                    <td>2023-24, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>GREY</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>VIVAAN KUNAL RANGOLE</td>
                                                    <td>95.82</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>ADIT DEWAN</td>
                                                    <td rowspan="11">RAVI</td>
                                                    <td rowspan="11">NILE</td>
                                                    <td>90.74</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>AMBAR VASHISTH</td>
                                                    <td>95.06</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>ARNAV CHOPRA</td>
                                                    <td>91.6</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>ARYAVEER PRABHAKAR</td>
                                                    <td>89.58</td>
                                                    <td>2023-24, 2022-23</td>
                                                    <td>PINK</td>
                                                    <td>GREY</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>DEVARSH MADAN</td>
                                                    <td>92.54</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>DIVIJ ARORA</td>
                                                    <td>96.44</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>EKAANSH AGARWAL</td>
                                                    <td>98.1</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>RITWICK AGARWAL</td>
                                                    <td>93.94</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>VEDANG BHARDWAJ</td>
                                                    <td>94.04</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>VIHAN KHURANA</td>
                                                    <td>91.66</td>
                                                    <td>2023-24, 2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>YAGN GUPTA</td>
                                                    <td>94.88</td>
                                                    <td>2023-24,2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>AAHANA MALHOTRA</td>
                                                    <td rowspan="8">TAPTI</td>
                                                    <td rowspan="8">RHINE</td>
                                                    <td>89.6</td>
                                                    <td>2023-24</td>
                                                    <td>PINK</td>
                                                    <td>GREY</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>AARAV KHANDPUR</td>
                                                    <td>94.48</td>
                                                    <td>2023-24,2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>AKARSHI BHATTACHARYA</td>
                                                    <td>91.46</td>
                                                    <td>2023-24,2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>AMAIRA GARG</td>
                                                    <td>97.04</td>
                                                    <td>2023-24,2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>ARAV AGGARWAL</td>
                                                    <td>89.84</td>
                                                    <td>2023-24,2022-23</td>
                                                    <td>PINK</td>
                                                    <td>GREY</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>ASYA BANSAL</td>
                                                    <td>93.24</td>
                                                    <td>2023-24,2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>NAVYA JAIN</td>
                                                    <td>94.88</td>
                                                    <td>2023-24,2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>RACHIT RUSTAGI</td>
                                                    <td>93.46</td>
                                                    <td>2023-24,2022-23, 2021-22</td>
                                                    <td>PINK</td>
                                                    <td>&nbsp;</td>
                                                    <td>BLAZER</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="6">&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>15</td>
                                                    <td>43 (Blue) + 1(Maroon)</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td rowspan="2"></td>
                                                    <td></td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td colspan="2">TOTAL    REQUIREMENT<br />
                                                        GRADE VII (2023-24)</td>
                                                    <td>GRADE-VII</td>
                                                    <td>2023-24</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>43</td>
                                                    <td>Blue blazers</td>
                                                    <td>Total Strength</td>
                                                    <td>205</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>1</td>
                                                    <td>Red blazer</td>
                                                    <td>Scholars</td>
                                                    <td>58</td>
                                                    <td>1 FOR SPORTS</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>15</td>
                                                    <td>Grey pockets</td>
                                                    <td>%</td>
                                                    <td>28.29%</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>58</td>
                                                    <td>Scholar badges</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>58</td>
                                                    <td>Certificates</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody></table>
                                        <table className='table-view' border="1" width="100%">
                                            <tbody><tr>
                                                <th>S.NO.</th>
                                                <th>NAME</th>
                                                <th>SECTION</th>
                                            </tr>
                                                <tr>
                                                    <th colspan="3">GRADE V</th>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>ADVAY BANSAL</td>
                                                    <td rowspan="12">BIRCHES</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>AHAAN SHIVHARE</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>ANYA BISHT</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>ARAV MEHROTRA</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>ATHARV KHANNA</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>ATIKSHA SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>HARSHVARDHAN AGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>PRISHA GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>PRISHA SINDHWANI</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>RIDIT SINGLA</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>YASHVARDHAN KALRA</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>YUVAAN RANJAN</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>AIRA GOYLE</td>
                                                    <td rowspan="13">BURANS</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>DHRUV SARIN</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>HANNA DALAL</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>INAYA ABBI</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>KRIDAY SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>LEYSHA MALIK</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>MANVIK SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>MYRA KHURANA</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>PRISHA BATRA</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>SAMAIRA MISRA</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>SANVI CHAUDHARY</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>SHREYASI SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>VIHAAN GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>AARNAV ARORA</td>
                                                    <td rowspan="11">CEDARS</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>ARSH KAUSHAL</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>BHOMYA SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>KAYAAN SAXENA</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>NAVISHA GOYAL</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>RISHAAN GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>SAIYAM NAGPAL</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>SARUCHI GULATI</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>SIDDHI MANOCHA</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>SPARSH MITTAL</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>VANSHIKA BALLABH</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>AARUSH JAIN</td>
                                                    <td rowspan="12">MAPLES</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>IVANA AGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>MAAN THAPLIYAL</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>PARTH AGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>PARTH JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>REYANSHI AGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>RIAAN CHUGH</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>SARTHAK BAKSHI</td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>SHTAKSHI AGNIHOTRI</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>SIBANI JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>SIDHART NAMBIAR</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>YASHIKA SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>ALYSHA SHARMA</td>
                                                    <td rowspan="10">NEEMS</td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>ARTHAK SHUKLA</td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>ARYAMAN GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>ATHARV SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>AYUSH MAJUMDAR</td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>AZALEA CHELLANI KUMAR</td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>DHRUV BABBAR</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>DIA KAPUR</td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>NAISHA KAPOOR</td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>TOSHANNIE S SETIA</td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>AGASTYA SAXENA</td>
                                                    <td rowspan="10">OAKS</td>
                                                </tr>
                                                <tr>
                                                    <td>60</td>
                                                    <td>ARADHYA MIGLANI</td>
                                                </tr>
                                                <tr>
                                                    <td>61</td>
                                                    <td>GEETANSHI CHOPRA</td>
                                                </tr>
                                                <tr>
                                                    <td>62</td>
                                                    <td>IDHA SACHDEVA</td>
                                                </tr>
                                                <tr>
                                                    <td>63</td>
                                                    <td>LAVANYA AGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>64</td>
                                                    <td>MYRA KHANDELWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>65</td>
                                                    <td>SANVI SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>66</td>
                                                    <td>SHAURYA CHADHA</td>
                                                </tr>
                                                <tr>
                                                    <td>67</td>
                                                    <td>TAISHA BATRA</td>
                                                </tr>
                                                <tr>
                                                    <td>68</td>
                                                    <td>ZENA CHAUHAN</td>
                                                </tr>
                                                <tr>
                                                    <td>69</td>
                                                    <td>ADVAITH ADARSH KURUP</td>
                                                    <td rowspan="14">OLIVES</td>
                                                </tr>
                                                <tr>
                                                    <td>70</td>
                                                    <td>ADVAY GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>71</td>
                                                    <td>ANVAY GOYAL</td>
                                                </tr>
                                                <tr>
                                                    <td>72</td>
                                                    <td>ANYA KAPOOR</td>
                                                </tr>
                                                <tr>
                                                    <td>73</td>
                                                    <td>ASAD SALROO</td>
                                                </tr>
                                                <tr>
                                                    <td>74</td>
                                                    <td>AVNI MITTAL</td>
                                                </tr>
                                                <tr>
                                                    <td>75</td>
                                                    <td>AYAAN KAPOOR</td>
                                                </tr>
                                                <tr>
                                                    <td>76</td>
                                                    <td>MYRA GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>77</td>
                                                    <td>NAYSHA SATIJA</td>
                                                </tr>
                                                <tr>
                                                    <td>78</td>
                                                    <td>REYANSH GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>79</td>
                                                    <td>RIDIT SHAH</td>
                                                </tr>
                                                <tr>
                                                    <td>80</td>
                                                    <td>RUDRAKSH SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>81</td>
                                                    <td>TARINI BANERJEE</td>
                                                </tr>
                                                <tr>
                                                    <td>82</td>
                                                    <td>VIDHI HAMIRWASIA</td>
                                                </tr>
                                                <tr>
                                                    <th colspan="3">GRADE VI</th>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AARAV ARORA</td>
                                                    <td rowspan="9">BEAS</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>AMAIRA VERMA</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>ANAHIT KAUR ISHER</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>ARHAN JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>IRA AWASTHI</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>KRISHNAV CHAUDHRY</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>MD ADYAN RIZVI</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>SHAY LAL</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>SPARSH JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>AARADHYA NEGI</td>
                                                    <td rowspan="5">BRAHMAPUTRA</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>OM GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>PALAK AGGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>SHANAYA AGGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>VANYA YADAV</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>AARAV SHARMA</td>
                                                    <td rowspan="7">GANGES</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>ATHARVA SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>JAINEIL VERMA</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>NIKITA MEMANI</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>PRAKRITI</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>RIDDHI JOSHI</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>SAANVI KHAMESRA</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>ADVAY GUPTA</td>
                                                    <td rowspan="13">GODAVARI</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>ALAINA KOHLI</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>AMYRA SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>AVYA JINDAL</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>DARSH JANGRA</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>MUGDHA WALIA</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>NAVYA GERA</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>RAYAANSH JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>SHAAN SETHI BAHL</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>SHAURYA PALIWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>TANUSHI GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>VIHAAN SINGH (W/D)</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>VIVAAN ARORA</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>AADVIK GUPTA</td>
                                                    <td rowspan="10">KAVERI</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>AARTI MIGLANI</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>AMAIRA KHANNA</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>ARADHYA BATRA</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>GYANVI JHAMB</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>LAKSHYA BHANSALI</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>RABHYA SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>SHAURYA BANSAL</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>SIDDHANT JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>VIVAAN ARORA</td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>ANUSHA SHRIVASTAVA</td>
                                                    <td rowspan="6">NARMADA</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>AROHI BEEJAWAT</td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>KIARA JAI PRAKASH</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>MAHI KAPOOR</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>RIYANT BANSAL</td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>VISHIST BAJPAI (W/D)</td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>AADIT SINGH</td>
                                                    <td rowspan="8">SUTLEJ</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>AANYA SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>ALAINA SALUJA</td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>GIANNA SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>JIVITESH YADAV</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>KRITIKA VASHISHTH</td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>PRITIKA GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>RONAV PANDEY</td>
                                                </tr>
                                                <tr>
                                                    <th colspan="3">GRADE VII</th>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AMAIRA WADHWA</td>
                                                    <td rowspan="8">CHENAB</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>ANISHA SHARMA (NEW ADMISSION)</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>ARNAV GARG</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>ATHARV GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>DIVIT RASTOGI</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>MANIT BHASIN</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>SAANVI KUKREJA</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>VEDANJALI SHAH</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>AADVIK SOOD</td>
                                                    <td rowspan="7">DAMODAR</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>CHAITANYA SRIVASTAVA</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>KIAAN GARG</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>NAUNIDH SETTHEE</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>RAIZEL TANEJA</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>SHREYASH KANODIA</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>YUVRAJ CHAUDHARY</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>AVIRAT CHOPRA</td>
                                                    <td rowspan="8">INDUS</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>DHRUV BHARTI</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>INIKA MALIK</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>ISHIKA AGGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>JIVANSH NANGRU</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>NIMISHA SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>VIHAAN VIDWANS</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>YAJUR MEHRA</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>AANYA SHARMA</td>
                                                    <td rowspan="8">JHELUM</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>ARSHIYA GARG</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>JAYANTIKA BHATTACHARJYA</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>NAVIKA ARORA</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>NISHKA SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>PRISHA AHUJA</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>SAKSHAM MITTAL</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>SUMANYU SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>AANYA VERMA</td>
                                                    <td rowspan="9">MAHANADI</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>MAYRA NAGPAL</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>MYRA GANDHI</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>PAVNI MEHTA</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>VEDAGYA SINGHAL</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>VIHAAN BANSAL</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>VIHAAN JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>VIVAAN CHANDNA</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>VIVAAN KUNAL RANGOLE</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>ADIT DEWAN</td>
                                                    <td rowspan="11">RAVI</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>AMBAR VASHISTH</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>ARNAV CHOPRA</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>ARYAVEER PRABHAKAR</td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>DEVARSH MADAN</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>DIVIJ ARORA</td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>EKAANSH AGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>RITWICK AGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>VEDANG BHARDWAJ</td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>VIHAN KHURANA</td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>YAGN GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>AAHANA MALHOTRA</td>
                                                    <td rowspan="8">TAPTI</td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>AARAV KHANDPUR</td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>AKARSHI BHATTACHARYA</td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>AMAIRA GARG</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>ARAV AGGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>ASYA BANSAL</td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>NAVYA JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>RACHIT RUSTAGI</td>
                                                </tr>
                                                <tr>
                                                    <th colspan="3">GRADE VIII</th>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AASHVI THAKUR</td>
                                                    <td rowspan="9">AMAZON</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>DEVYANSH MALIK</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>GARVITA JAIN (W/D)</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>GIA VERMA</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>KABIR GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>MEHAK JINDAL</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>PRISHA VERMA</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>SONAL MITTAL</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>VIRAJH AGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>AMOGH DOSHI</td>
                                                    <td rowspan="10">COLORADO</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>ANANYA KAPOOR</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>ATHARV MALHOTRA</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>AVNI JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>SANA BUGALIA</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>SARANYA SINGHAL</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>SUHANA SINDHWANI</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>YASHITA MAHESHWARI</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>PRISHA KUMAR</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>GURSIMRAT SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>AAROHI GARG</td>
                                                    <td rowspan="7">CONGO</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>ADVIKA BANERJEE</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>SHREYA MAMTANI</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>SHRISHTI BANSAL</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>HIBAH I CHAGLANI</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>ADVIK MALIK</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>ANUSHKA CHOUBEY</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>ANAY GARG</td>
                                                    <td rowspan="6">DANUBE</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>KAVNEER KAUR THUKRAL</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>MAHIKA YADAV</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>PRIYANSH CHATTERJEE</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>RUHAAN GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>ADITYA ASISH MAHANTA</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>AARAV RANGRAJ</td>
                                                    <td rowspan="8">MISSISSIPPI</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>AHAAN GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>ANYA MUNDRA</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>ARYAMAN GULATI W/D</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>DHWANI MADAN</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>PRANEY GUGLANI W/D</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>AVANI JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>AARYAVEER KAPOOR</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>AADYA PROOTHI</td>
                                                    <td rowspan="9">NILE</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>AARAV DURANI (W/D)</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>AARNAV SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>ARJUN WALIA</td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>KAAVYA JOSHI</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>NEEL DHODY</td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>VIR NIJHAWAN</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>YUVAKSHI CHOPRA</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>SANAH SUTHIN</td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>AMAIRA VOHRA</td>
                                                    <td rowspan="9">RHINE</td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>ARJUN KHETERPAL</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>AVANTIKA PANDE</td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>MANIT ANGIRAS</td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>SHANAYA SURI</td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>VAIGA P. NAIR</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>VEDANT GROVER</td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>ADAM SALROO</td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>AVNI PANDEY</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3">GRADE IX</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AVICHAL GUPTA</td>
                                                    <td rowspan="5">ARAVALLIS</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>DIVIT KAUSHIK</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>NAVBIR SINGH GUJRAL</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>SANVI NANDA</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>SHREYANSH KANOTRA</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>ADYA ARYA</td>
                                                    <td rowspan="3">EVEREST</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>ANIRUDH SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>IDHIKA SRIVASTAVA</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>AKANKSHA BANSAL</td>
                                                    <td rowspan="4">HIMALAYAS</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>ANANYA LAKARA</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>ANYA AGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>JIVITESH VERMA</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>ANEESH GUPTA</td>
                                                    <td rowspan="8">KAMET</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>ARNAV GOYAL</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>CHARVI YAADAV</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>DIVYANSH KAPOOR</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>IVANYA DAYAL</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>MYRA SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>RASHI VANIDANI</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>SAESHHA ADHANA</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>AARSHIA PAHUJA</td>
                                                    <td rowspan="8">KANCHENJUNGA</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>ARJUN ARORA</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>ARYAVEER SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>MAYAN BHASKAR</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>PAVANI CHOPRA</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>SIDHANSH GARG</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>VASUDHA SINGHAL</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>VRINDA MITTAL</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>AAHANA JAIN</td>
                                                    <td rowspan="7">NILGIRIS</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>AMI AGGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>ARNAV NAGPAL</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>ARYAN GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>DISHA AGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>PRISHA SATIJA</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>SHREYA ARORA</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>ANAYA JAIN</td>
                                                    <td rowspan="3">SHIVALIKS</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>KRISHANG GROVER</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>SHAURYA ARORA</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>ANUSHKA MUKHOPADHYAY</td>
                                                    <td rowspan="6">VINDHYAS</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>AVIRAJ AGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>GIANAA MALIK</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>KAYAAN JAI PRAKASH</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>NAISHA KHANNA</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>TANISHA GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3">GRADE X</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AADYAA SAXENA</td>
                                                    <td rowspan="23">ALPS</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>AAHNA GULATI</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>AASHNA GOYAL</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>AGAM BHANSWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>AHAAN PORWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>AKSHADHA THAKUR</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>ARHAN ATTRI</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>ARNAV ARORA</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>ARYAN GULATI</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>ATHARV VISHWAS GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>AVNI SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>DIYA GERA</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>KARTIK BHAGIA</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>PRAJOT SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>PRIYANSH GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>RYAN GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>SAARVIN SINGHAL</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>SABHYA AGGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>SACHIN SOOD</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>SHREYA DHAKA</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>SRISHTI BAKLIWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>TAASHVI KAPOOR</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>VAASVI JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>AAIRIYA JAIN</td>
                                                    <td rowspan="18">ANDES</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>ABHIMANYU BHARDWAJ</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>AHAAN MISRA</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>AYANNA MUNJAL</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>DHRUV SRIVASTAVA</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>DITI BHATIA</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>KEYA NAGPAL</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>MANVIT BANDHU</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>NAVYA CHOPRA</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>NAVYA JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>NISHKA SAXENA</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>RONIT MENDIRATTA</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>RUDRANSH SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>SAINA JINDAL</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>SARTHAK JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>SHAURYA SEHRA</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>SIDDHANT MENON</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>TANVI WASON</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>AANYA PANDEY</td>
                                                    <td rowspan="18">ELBERT</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>ANGEL GOMEZ</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>ANIRUDDHA BHATTACHARYA</td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>ANUSHKA JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>ANUSHREE GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>ARCHIT SAHNI</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>ARYAN VOHRA</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>ATHARVA MEHRA</td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>HARLEEN KAUR</td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>JOSH KAPOOR</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>KRISHNA DHAWAN</td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>NAVNOOR KAUR</td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>PRAGNAY SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>PRATEEK SINHA</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>RIDDHI MANOCHA</td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>RITHIKA TALLURI</td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>SHUBH JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>VIVAAN BANERJEE</td>
                                                </tr>
                                                <tr>
                                                    <td>60</td>
                                                    <td>AARAV ANAND</td>
                                                    <td rowspan="15">ELBRUS</td>
                                                </tr>
                                                <tr>
                                                    <td>61</td>
                                                    <td>AGASTYA TRIKHA</td>
                                                </tr>
                                                <tr>
                                                    <td>62</td>
                                                    <td>ARMAAN NAGPAL</td>
                                                </tr>
                                                <tr>
                                                    <td>63</td>
                                                    <td>DHRITI SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>64</td>
                                                    <td>DISHA BUDHIRAJA</td>
                                                </tr>
                                                <tr>
                                                    <td>65</td>
                                                    <td>EKLAVYA MUKHERJI</td>
                                                </tr>
                                                <tr>
                                                    <td>66</td>
                                                    <td>KRISHIV KHANNA</td>
                                                </tr>
                                                <tr>
                                                    <td>67</td>
                                                    <td>MEHER SETIA</td>
                                                </tr>
                                                <tr>
                                                    <td>68</td>
                                                    <td>REYNA UPADHYAY</td>
                                                </tr>
                                                <tr>
                                                    <td>69</td>
                                                    <td>SAANVI JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>70</td>
                                                    <td>SURYA KHURANA</td>
                                                </tr>
                                                <tr>
                                                    <td>71</td>
                                                    <td>SVASTI BORA</td>
                                                </tr>
                                                <tr>
                                                    <td>72</td>
                                                    <td>TASHVI VIRMANI</td>
                                                </tr>
                                                <tr>
                                                    <td>73</td>
                                                    <td>TOSHANI GAUR</td>
                                                </tr>
                                                <tr>
                                                    <td>74</td>
                                                    <td>VATSAL SARAOGI</td>
                                                </tr>
                                                <tr>
                                                    <td>75</td>
                                                    <td>ADVIK MEHTA</td>
                                                    <td rowspan="18">FUJI</td>
                                                </tr>
                                                <tr>
                                                    <td>76</td>
                                                    <td>ADVIKA JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>77</td>
                                                    <td>ADWAY GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>78</td>
                                                    <td>ANAV SHAH</td>
                                                </tr>
                                                <tr>
                                                    <td>79</td>
                                                    <td>ARJUN MITTAL</td>
                                                </tr>
                                                <tr>
                                                    <td>80</td>
                                                    <td>ARYAV MATHUR</td>
                                                </tr>
                                                <tr>
                                                    <td>81</td>
                                                    <td>ATHARV KUMAR</td>
                                                </tr>
                                                <tr>
                                                    <td>82</td>
                                                    <td>CHESTHA</td>
                                                </tr>
                                                <tr>
                                                    <td>83</td>
                                                    <td>KAASHVI GARHWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>84</td>
                                                    <td>KARTIK TANDON</td>
                                                </tr>
                                                <tr>
                                                    <td>85</td>
                                                    <td>KYESHA DEORANI</td>
                                                </tr>
                                                <tr>
                                                    <td>86</td>
                                                    <td>LEISHA KAPIL</td>
                                                </tr>
                                                <tr>
                                                    <td>87</td>
                                                    <td>NIKHIL DABAS</td>
                                                </tr>
                                                <tr>
                                                    <td>88</td>
                                                    <td>PALAK BHANDARI</td>
                                                </tr>
                                                <tr>
                                                    <td>89</td>
                                                    <td>PARTHAV SARIN</td>
                                                </tr>
                                                <tr>
                                                    <td>90</td>
                                                    <td>PRATIVINDHYA SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>91</td>
                                                    <td>TVESHA YADAV</td>
                                                </tr>
                                                <tr>
                                                    <td>92</td>
                                                    <td>VADANYA CHATURVEDI</td>
                                                </tr>
                                                <tr>
                                                    <td>93</td>
                                                    <td>ADITYA KUMAR</td>
                                                    <td rowspan="21">MONARCH</td>
                                                </tr>
                                                <tr>
                                                    <td>94</td>
                                                    <td>ANAY DEB</td>
                                                </tr>
                                                <tr>
                                                    <td>95</td>
                                                    <td>AYANNA VAIDYA</td>
                                                </tr>
                                                <tr>
                                                    <td>96</td>
                                                    <td>AYUSHI MOOLCHANDANI</td>
                                                </tr>
                                                <tr>
                                                    <td>97</td>
                                                    <td>DHANYA SRIVASTAVA</td>
                                                </tr>
                                                <tr>
                                                    <td>98</td>
                                                    <td>GRISHA MAULIN GANDHI</td>
                                                </tr>
                                                <tr>
                                                    <td>99</td>
                                                    <td>HARSHIT HANDA</td>
                                                </tr>
                                                <tr>
                                                    <td>100</td>
                                                    <td>HARSHITA YADAV</td>
                                                </tr>
                                                <tr>
                                                    <td>101</td>
                                                    <td>JAYANA MOUDGIL</td>
                                                </tr>
                                                <tr>
                                                    <td>102</td>
                                                    <td>MAUNIK PARY OBEROI</td>
                                                </tr>
                                                <tr>
                                                    <td>103</td>
                                                    <td>PRABAL TANWAR</td>
                                                </tr>
                                                <tr>
                                                    <td>104</td>
                                                    <td>PRAGYA YADAV</td>
                                                </tr>
                                                <tr>
                                                    <td>105</td>
                                                    <td>PURAB SWARUP</td>
                                                </tr>
                                                <tr>
                                                    <td>106</td>
                                                    <td>REVA KHANNA</td>
                                                </tr>
                                                <tr>
                                                    <td>107</td>
                                                    <td>RISHA AGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>108</td>
                                                    <td>SAKSHAM ARORA</td>
                                                </tr>
                                                <tr>
                                                    <td>109</td>
                                                    <td>SARANYA JAGGI</td>
                                                </tr>
                                                <tr>
                                                    <td>110</td>
                                                    <td>SHAYNA RAMANI</td>
                                                </tr>
                                                <tr>
                                                    <td>111</td>
                                                    <td>SIMAR KAUR</td>
                                                </tr>
                                                <tr>
                                                    <td>112</td>
                                                    <td>TAVISHI SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>113</td>
                                                    <td>VIDHI MALHOTRA</td>
                                                </tr>
                                                <tr>
                                                    <td>114</td>
                                                    <td>AANYA MITTAL</td>
                                                    <td rowspan="21">OLYMPUS</td>
                                                </tr>
                                                <tr>
                                                    <td>115</td>
                                                    <td>ANNANYA BAJAJ</td>
                                                </tr>
                                                <tr>
                                                    <td>116</td>
                                                    <td>BHAVIK JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>117</td>
                                                    <td>DIVA JOHN</td>
                                                </tr>
                                                <tr>
                                                    <td>118</td>
                                                    <td>HANEEKA MODI</td>
                                                </tr>
                                                <tr>
                                                    <td>119</td>
                                                    <td>JAY SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>120</td>
                                                    <td>JESSICA SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>121</td>
                                                    <td>KAAVYA SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>122</td>
                                                    <td>NISHIKA MANINI</td>
                                                </tr>
                                                <tr>
                                                    <td>123</td>
                                                    <td>SAANVI GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>124</td>
                                                    <td>SANIL GORAWARA</td>
                                                </tr>
                                                <tr>
                                                    <td>125</td>
                                                    <td>SHIVANK NOHWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>126</td>
                                                    <td>SHOBIT GALHOTRA</td>
                                                </tr>
                                                <tr>
                                                    <td>127</td>
                                                    <td>SHUBHAM BHASIN</td>
                                                </tr>
                                                <tr>
                                                    <td>128</td>
                                                    <td>SIDH KHATTAR</td>
                                                </tr>
                                                <tr>
                                                    <td>129</td>
                                                    <td>SIMONE KAUR MAKKUR</td>
                                                </tr>
                                                <tr>
                                                    <td>130</td>
                                                    <td>STAVYA KHURANA</td>
                                                </tr>
                                                <tr>
                                                    <td>131</td>
                                                    <td>TANAY GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>132</td>
                                                    <td>TANVI BHAMBHANI</td>
                                                </tr>
                                                <tr>
                                                    <td>133</td>
                                                    <td>VIDHI VASHISTH</td>
                                                </tr>
                                                <tr>
                                                    <td>134</td>
                                                    <td>VYOM VIJ</td>
                                                </tr>
                                                <tr>
                                                    <td>135</td>
                                                    <td>AADHYA GUPTA</td>
                                                    <td rowspan="18">WHITNEY</td>
                                                </tr>
                                                <tr>
                                                    <td>136</td>
                                                    <td>AANYA SAHANI</td>
                                                </tr>
                                                <tr>
                                                    <td>137</td>
                                                    <td>AARAV SINHA</td>
                                                </tr>
                                                <tr>
                                                    <td>138</td>
                                                    <td>AFRAAZ ALAM</td>
                                                </tr>
                                                <tr>
                                                    <td>139</td>
                                                    <td>ANANYA GOEL</td>
                                                </tr>
                                                <tr>
                                                    <td>140</td>
                                                    <td>ANNIKA MATHUR</td>
                                                </tr>
                                                <tr>
                                                    <td>141</td>
                                                    <td>ARMAAN SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>142</td>
                                                    <td>ASHMI MONGA</td>
                                                </tr>
                                                <tr>
                                                    <td>143</td>
                                                    <td>CHARVI CHATURVEDI</td>
                                                </tr>
                                                <tr>
                                                    <td>144</td>
                                                    <td>DISHIETA HOTA</td>
                                                </tr>
                                                <tr>
                                                    <td>145</td>
                                                    <td>DIVYANSHI GILL</td>
                                                </tr>
                                                <tr>
                                                    <td>146</td>
                                                    <td>KASHIKA GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>147</td>
                                                    <td>KENISHA DAWAR</td>
                                                </tr>
                                                <tr>
                                                    <td>148</td>
                                                    <td>KHUSHI JOSHI</td>
                                                </tr>
                                                <tr>
                                                    <td>149</td>
                                                    <td>NIKITA JUNEJA</td>
                                                </tr>
                                                <tr>
                                                    <td>150</td>
                                                    <td>SAANVI RANJAN</td>
                                                </tr>
                                                <tr>
                                                    <td>151</td>
                                                    <td>SPANDANA SANJOY BUJAR BARUA</td>
                                                </tr>
                                                <tr>
                                                    <td>152</td>
                                                    <td>VIHAAN ARORA</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3">GRADE XI</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>ADITYA PRAKASH</td>
                                                    <td rowspan="4">EINSTEIN</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>KESHAVA PIYUSH PRASAD</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>MRRIDUL SESHADRI</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>NISHKA CHOPRA</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>MANASVI AGARWAL</td>
                                                    <td rowspan="3">EDISON</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>RISHI GANDHI</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>SANA YADAV</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>MAANYA RAJPUT</td>
                                                    <td rowspan="3">ARISTOTLE</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>PARIDHI GARG</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>VANSH SRIVASTAVA</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>ARMAAN VIJAYVERGIYA</td>
                                                    <td rowspan="4">KEYNES</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>MAANSI SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>MIHIKAA SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>SHREYA SETHI</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>ANJANA SRIRAM</td>
                                                    <td rowspan="8">SHAKESPEARE</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>ARSHIYA JOSHI</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>AYATI SHOBNIM SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>DISHITA MAHESHWARI</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>JUNIYALI PANWAR</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>SANA MEHTA</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>TANISHA BIRLA</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>TURVISHI ARORA</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>BHAVYA GUPTA</td>
                                                    <td>ARISTOTLE</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>AAKRITI DEWAN</td>
                                                    <td>EINSTEIN</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>TANUSHREE NONGTHOMBAM</td>
                                                    <td>DALTON</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>ANIKA RANAUT</td>
                                                    <td>KEYNES</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3">GRADE XII</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>KYNA CHAUDHARY</td>
                                                    <td rowspan="15">ARCHIMEDES</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>RAMDAS SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>AARAV GARG</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>MANNAN RANA</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>GAUTAM BHATTACHARYA</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>LAKSHYA AGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>NAVYA LAKHOTIA</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>SAANVI DAS</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>PRISHA KHANNA</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>GITANJALI SINGH ATRI</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>NAVYA NANDINI DHODY</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>DHRUV SHARMA</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>SNEHAL SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>AAHANA KUUMARESH RATHOR</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>VIDHRAJ SINGH</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>ARAV MATHUR</td>
                                                    <td rowspan="15">GALILEO</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>RYAN PURI</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>NAVYA AGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>ANIRUDH GOVINDAN</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>DHRUV KUMAR</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>SHAURYA GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>NIA RANJAN</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>CHAITANYA GUPTA</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>AARAV NAVANI</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>APURV BHUSHAN</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>AADEESH JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>AADIT BAHL</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>SARA KHURANA</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>ADITI PANT</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>JAIADITYA RATHORE</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>ANANYA SIROHI</td>
                                                    <td rowspan="13">LEONARDO</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>VINAYAK MALHOTRA</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>VANSHIKA JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>ANAYA BANSAL</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>PRITHVI SUBHASH JANGID</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>VIVAAN BATTISH</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>ADITYA MARWAH</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>DIYA BHATNAGAR</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>RITISHA MEHROTRA</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>SHOURYA KAPOOR</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>MRINALINI CHITARA</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>TANISH SHARAN</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>MEHR GAHARWAR</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>DEEPTI KHETAN</td>
                                                    <td rowspan="5">MARSHALL</td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>AMULYAA KASHYAP</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>TANMAY SURI</td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>ISHAAN CHHABRA</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>DIVYAM CHAWLA</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>TEJAL DOSHI</td>
                                                    <td rowspan="10">THOMSON</td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>NAVYA KASERA</td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>GARV MULLICK</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>KRIPA KAUR</td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>MADHAV MALHAN</td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>KATYA SOOD</td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>AHAD TARIQ</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>ERIN THOMAS</td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>YATEE KAUSHIK</td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>AARNAA BATRA</td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>HIYA DHADWAL</td>
                                                    <td rowspan="17">WORDSWORTH</td>
                                                </tr>
                                                <tr>
                                                    <td>60</td>
                                                    <td>ADVAY DANGI</td>
                                                </tr>
                                                <tr>
                                                    <td>61</td>
                                                    <td>LAVANYA SRIVASTAVA</td>
                                                </tr>
                                                <tr>
                                                    <td>62</td>
                                                    <td>NYESA JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>63</td>
                                                    <td>DITYA BHUTTAN</td>
                                                </tr>
                                                <tr>
                                                    <td>64</td>
                                                    <td>MARUSHIKA ARORA</td>
                                                </tr>
                                                <tr>
                                                    <td>65</td>
                                                    <td>JIYA MAHAJAN</td>
                                                </tr>
                                                <tr>
                                                    <td>66</td>
                                                    <td>KAINA MALIK</td>
                                                </tr>
                                                <tr>
                                                    <td>67</td>
                                                    <td>SAUMYA BABBAR</td>
                                                </tr>
                                                <tr>
                                                    <td>68</td>
                                                    <td>ANANYA SALUJA</td>
                                                </tr>
                                                <tr>
                                                    <td>69</td>
                                                    <td>YANA JAIN</td>
                                                </tr>
                                                <tr>
                                                    <td>70</td>
                                                    <td>SHAURYA AGARWAL</td>
                                                </tr>
                                                <tr>
                                                    <td>71</td>
                                                    <td>AKSHAT RAMPAL</td>
                                                </tr>
                                                <tr>
                                                    <td>72</td>
                                                    <td>YATEE NAGPAL</td>
                                                </tr>
                                                <tr>
                                                    <td>73</td>
                                                    <td>NIEEL PRAVEEN</td>
                                                </tr>
                                                <tr>
                                                    <td>74</td>
                                                    <td>GAYATRI VEER</td>
                                                </tr>
                                                <tr>
                                                    <td>75</td>
                                                    <td>NAINA MAHAK TANDON</td>
                                                </tr>
                                            </tbody></table>
                                        <table className='table-view' border="1" width="100%">
                                            <tbody><tr>
                                            </tr>
                                            </tbody></table>
                                    </div>
                                </div>
                            )
                            }
                            {filterData === "1" && (
                                <div class="">
                                    <div class="heading2 text-center">
                                        <h4>Scholar Badge Holders 2022-23</h4>
                                    </div>
                                    <div class="table">
                                        <table className='table-view' border="1" width="100%">
                                            <tbody><tr>
                                                <th colspan="8">DETAILS FOR THE SCHOLAR CERTIFICATES : GRADE V (2022-23)</th>
                                                <th></th>
                                            </tr>
                                                <tr>
                                                    <th colspan="8">Aggregate 90% &amp; Above</th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAMES</th>
                                                    <th rowspan="2">GRADE - V (2022-23)</th>
                                                    <th rowspan="2">GRADE - VI (2023-24)</th>
                                                    <th rowspan="2">%</th>
                                                    <th rowspan="2">SESSION</th>
                                                    <th colspan="2">SCHOLAR STATUS</th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th>BADGE</th>
                                                    <th>POCKET</th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AADYA WADHWA (withdrawn)</td>
                                                    <td rowspan="13">BIRCHES</td>
                                                    <td>&nbsp;</td>
                                                    <td>89.72</td>
                                                    <td>2022-23</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>AARAV ARORA</td>
                                                    <td>&nbsp;</td>
                                                    <td>94</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>AMAIRA VERMA</td>
                                                    <td>&nbsp;</td>
                                                    <td>94.92</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>ANAHIT KAUR ISHER</td>
                                                    <td>&nbsp;</td>
                                                    <td>94.26</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>ARHAN JAIN</td>
                                                    <td>&nbsp;</td>
                                                    <td>95.34</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>IRA AWASTHI</td>
                                                    <td>&nbsp;</td>
                                                    <td>93.28</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>MD ADYAN RIZVI</td>
                                                    <td>BEAS</td>
                                                    <td>98.62</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>NAISHA SINGH</td>
                                                    <td>&nbsp;</td>
                                                    <td>91.48</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>NOYA IMAM</td>
                                                    <td>&nbsp;</td>
                                                    <td>89.78</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>SHAY LAL</td>
                                                    <td>&nbsp;</td>
                                                    <td>95.84</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>SIMLEEN KAUR</td>
                                                    <td>&nbsp;</td>
                                                    <td>94.16</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>SPARSH JAIN</td>
                                                    <td>&nbsp;</td>
                                                    <td>96.5</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>VATSAL JAIN (withdrawn)</td>
                                                    <td>&nbsp;</td>
                                                    <td>96.88</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=12</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>AARADHYA NEGI</td>
                                                    <td rowspan="11">BURANS</td>
                                                    <td rowspan="11">BRAHMAPUTRA</td>
                                                    <td>94.55</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>AVIKA KHURANA</td>
                                                    <td>93.53</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>OM GUPTA</td>
                                                    <td>92.22</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>PARTH JOSHI</td>
                                                    <td>92.32</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>SANVI SAWHNEY</td>
                                                    <td>89.55</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>SHANAYA AGGARWAL</td>
                                                    <td>96.63</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>TANISHKA BANSAL</td>
                                                    <td>96.47</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>VANYA YADAV</td>
                                                    <td>93.48</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>VARENYA KUTHILAL</td>
                                                    <td>90.22</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>VIVAAN GUPTA</td>
                                                    <td>92.7</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>ZAISHA SIBBIQUI</td>
                                                    <td>96.18</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=11</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>AAKARSH DUA</td>
                                                    <td rowspan="11">CEDARS</td>
                                                    <td rowspan="11">GANGES</td>
                                                    <td>91.72</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>AARAV SHARMA</td>
                                                    <td>94.52</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>ATHRAVA SINGH</td>
                                                    <td>96.8</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>GAURI KHANNA</td>
                                                    <td>89.5</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>JAINIEL VERMA</td>
                                                    <td>92.04</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>MAIRA SINGAL</td>
                                                    <td>94.6</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>MISHKA SAWHNEY</td>
                                                    <td>90.5</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>NIKITA MEMANI</td>
                                                    <td>93.6</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>PRAKRTI SINGH</td>
                                                    <td>93.56</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>RIDDHI JOSHI&nbsp;</td>
                                                    <td>96.4</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>SAANVI KHAMESRA</td>
                                                    <td>96.12</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=11</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>AAROHI SINHA</td>
                                                    <td rowspan="16">MAPLES</td>
                                                    <td rowspan="16">GODAVARI</td>
                                                    <td>90.96</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>ADVAY GUPTA</td>
                                                    <td>95.24</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>AMYRA SINGH</td>
                                                    <td>95.06</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>ANYA RATTAN(withdrawl)</td>
                                                    <td>91.84</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>ARJUNVEER SINGH</td>
                                                    <td>95.36</td>
                                                    <td>2022-23</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>AVYA JINDAL</td>
                                                    <td>94.12</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>DARSH JANGRA</td>
                                                    <td>94.54</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>MUGDHA WALIA</td>
                                                    <td>91.5</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>NAVYA GERA</td>
                                                    <td>91.06</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>PADMANABH CHAND GOTHIA</td>
                                                    <td>89.88</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>RAYAANSH JAIN</td>
                                                    <td>96.48</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>SHAAN SETHI BAHL</td>
                                                    <td>93.28</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>SHAURYA PALIWAL</td>
                                                    <td>95.52</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>SIYA BHATIA</td>
                                                    <td>91.74</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>TANUSHI GUPTA</td>
                                                    <td>93.36</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>VIHAAN SINGH</td>
                                                    <td>95.18</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=15</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>AADVIK GUPTA</td>
                                                    <td rowspan="17">NEEMS</td>
                                                    <td rowspan="17">KAVERI</td>
                                                    <td>99.32</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>AARADHYA VOHRA</td>
                                                    <td>91.12</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>AARAV KHETAN</td>
                                                    <td>90.98</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>AARTI MIGLANI</td>
                                                    <td>94.32</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>AARYAN ANAND</td>
                                                    <td>91.66</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>AMAIRA KHANNA</td>
                                                    <td>93.7</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>ARADHYA BATRA</td>
                                                    <td>95.88</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>LAKSHYA BHANSALI</td>
                                                    <td>96.6</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>60</td>
                                                    <td>MANEET JABBAL</td>
                                                    <td>95.04</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>61</td>
                                                    <td>MIHIRA DAS</td>
                                                    <td>91.48</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>62</td>
                                                    <td>NAISHA BOTHRA</td>
                                                    <td>93.9</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>63</td>
                                                    <td>RABHYA SHARMA</td>
                                                    <td>95.36</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>64</td>
                                                    <td>RUDRAKSH CHANDRA&nbsp;</td>
                                                    <td>94.16</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>65</td>
                                                    <td>SHAURYA BANSAL</td>
                                                    <td>95.1</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>66</td>
                                                    <td>SIDDHANT JAIN</td>
                                                    <td>95.64</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>67</td>
                                                    <td>VARTIKA GARG</td>
                                                    <td>91.34</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>68</td>
                                                    <td>VIVAAN ARORA</td>
                                                    <td>94.52</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=17</td>
                                                </tr>
                                                <tr>
                                                    <td>69</td>
                                                    <td>ABHIRAJ KAPOOR</td>
                                                    <td rowspan="13">OAKS</td>
                                                    <td rowspan="13">NARMADA</td>
                                                    <td>92.82</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>70</td>
                                                    <td>ANANYA SINGH&nbsp;</td>
                                                    <td>95.16</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>71</td>
                                                    <td>ANTARA INDRAYAN&nbsp;</td>
                                                    <td>95.3</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>72</td>
                                                    <td>ANUSHA SRIVASTAVA&nbsp;</td>
                                                    <td>91.88</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>73</td>
                                                    <td>ARNAV BHATT</td>
                                                    <td>93.86</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>74</td>
                                                    <td>AROHI BEEJAWAT&nbsp;</td>
                                                    <td>95.98</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>75</td>
                                                    <td>ARUNIMA SHARMA&nbsp;</td>
                                                    <td>95.02</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>76</td>
                                                    <td>KIARA JAI PRAKASH&nbsp;</td>
                                                    <td>91.54</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>77</td>
                                                    <td>RIYANT BANSAL</td>
                                                    <td>94.82</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>78</td>
                                                    <td>VISHISHT BAJPAI&nbsp;</td>
                                                    <td>94.28</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>79</td>
                                                    <td>VATSALA BAJPAI&nbsp;</td>
                                                    <td>92.04</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>80</td>
                                                    <td>AMAIRA GHAI&nbsp;</td>
                                                    <td>91.3</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>81</td>
                                                    <td>ARNAV JAIN</td>
                                                    <td>91.1</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=13</td>
                                                </tr>
                                                <tr>
                                                    <td>82</td>
                                                    <td>AADIT SINGH</td>
                                                    <td rowspan="14">OLIVES</td>
                                                    <td rowspan="14">SUTLEJ</td>
                                                    <td>98.4</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>83</td>
                                                    <td>AANYA ARYA</td>
                                                    <td>97.76</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>84</td>
                                                    <td>AANYA SHARMA</td>
                                                    <td>97.56</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>85</td>
                                                    <td>AARYA SINGH</td>
                                                    <td>92.02</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>86</td>
                                                    <td>AGRAJ SINGH</td>
                                                    <td>94.16</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>87</td>
                                                    <td>ALAINA SALUJA</td>
                                                    <td>94.6</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>88</td>
                                                    <td>GIANNA SINGH</td>
                                                    <td>92.68</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>89</td>
                                                    <td>JIVITESH YADAV</td>
                                                    <td>94.06</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>90</td>
                                                    <td>KRITIKA VASHISHTHA</td>
                                                    <td>95.14</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>91</td>
                                                    <td>MANNAT SEHRA</td>
                                                    <td>93.48</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>92</td>
                                                    <td>PRITIKA GUPTA</td>
                                                    <td>98.2</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>93</td>
                                                    <td>RONAV PANDEY</td>
                                                    <td>98.4</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>94</td>
                                                    <td>RUDR DAHIYA</td>
                                                    <td>90.2</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>95</td>
                                                    <td>VEDHANT GUPTA</td>
                                                    <td>89.98</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=14</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="8">&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>CERTIFICATES&nbsp;</td>
                                                    <td>95</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>Pink Badges</td>
                                                    <td>92</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>Grey Pockets</td>
                                                    <td>92</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>COMPARATIVE ANALYSIS</td>
                                                    <td>2022-23</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>Total Strength</td>
                                                    <td>208</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>Scholars</td>
                                                    <td>95</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>%</td>
                                                    <td>45.67%</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>



                                            </tbody></table>
                                        <table className='table-view' border="1" width="100%">

                                            <tbody><tr>
                                                <th colspan="8">DETAILS FOR THE SCHOLAR CERTIFICATES : GRADE VI (2022-23)</th>
                                                <th></th>
                                            </tr>
                                                <tr>
                                                    <th colspan="8">Aggregate 90% &amp; Above</th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAMES</th>
                                                    <th rowspan="2">GRADE - VI (2022-23)</th>
                                                    <th rowspan="2">GRADE - VII (2023-24)</th>
                                                    <th rowspan="2">%</th>
                                                    <th rowspan="2">SESSION</th>
                                                    <th colspan="2">SCHOLAR STATUS</th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th>BADGE</th>
                                                    <th>POCKET</th>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AMAIRA WADHWA</td>
                                                    <td rowspan="20">BEAS</td>
                                                    <td rowspan="20">CHENAB</td>
                                                    <td>94.4</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>ARCHIT GARG</td>
                                                    <td>90.8&nbsp; (B1 IN ENGLISH)</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>ARNAV GARG</td>
                                                    <td>92.2</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>ATHARV GUPTA</td>
                                                    <td>90.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>DIVIT RASTOGI</td>
                                                    <td>96</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>MANIT BHASIN</td>
                                                    <td>90</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>MISHA VASAL</td>
                                                    <td>89.8 (B1 IN ENGLISH)</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>SAANVI KUKREJA</td>
                                                    <td>97.4</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>VEDANJALI SHAH</td>
                                                    <td>95.6</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>AAYAAN SINGH</td>
                                                    <td>91.18</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>AYAAN SALUJA</td>
                                                    <td>94.98</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>HARSHIT SODHI</td>
                                                    <td>92.36</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>MISHIKA AGARWAL</td>
                                                    <td>94.64</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>NEVAAN JUNEJA</td>
                                                    <td>92.64</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>NITYAANT LAKHOTIA</td>
                                                    <td>92.78</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>RAJVEER KAPOOR</td>
                                                    <td>90</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>RISHIKA SACHDEVA</td>
                                                    <td>93.32</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>RUTVA GUPTA</td>
                                                    <td>93.32</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>SRISHTI YADAV</td>
                                                    <td>93.52</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>*W/D</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>YUKT VATS</td>
                                                    <td>96.46</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=9&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>AYANA BHAT</td>
                                                    <td rowspan="19">BRAHMAPUTRA</td>
                                                    <td rowspan="19">DAMODAR</td>
                                                    <td>97.2</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>KIAAN GARG</td>
                                                    <td>92.4</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>RAIZEL TANEJA</td>
                                                    <td>91.2</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>SIDDHARTH BANSAL</td>
                                                    <td>89.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>*W/D</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>YUVRAJ CHAUDHARY</td>
                                                    <td>93.2</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>AADVIK SOOD</td>
                                                    <td>97.16</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>ANANYA AGARWAL</td>
                                                    <td>97.26</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>*W/D</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>DIVIT KHURANA</td>
                                                    <td>92.74</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>*W/D</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>KARTIK PANDE</td>
                                                    <td>94.66</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>KYRA CHADHA</td>
                                                    <td>91.82</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>NAUNIDH SETTHEE</td>
                                                    <td>94.96</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>RAGHAV AGGARWAL</td>
                                                    <td>91.46</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>SAMAD TARIQ</td>
                                                    <td>94</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>SHOMADITYA RAY</td>
                                                    <td>92.69</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>TANAY SHARMA</td>
                                                    <td>90.06</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>VANYA TRIPATHI</td>
                                                    <td>92.92</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>VIVAAN GEHANI</td>
                                                    <td>94.68</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>CHAITANYA SRIVASTAVA</td>
                                                    <td>89.5</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>SAHEJVEER SINGH</td>
                                                    <td>89.5</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=4</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>AVIRAT CHOPRA</td>
                                                    <td rowspan="16">GANGES</td>
                                                    <td rowspan="16">INDUS</td>
                                                    <td>96.2</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>DHRUV BHARTI</td>
                                                    <td>93.2</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>INIKA MALIK</td>
                                                    <td>92</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>ISHIKA AGGARWAL</td>
                                                    <td>92</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>JIVANSH NANGRU</td>
                                                    <td>92.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>NAISHA PODDAR</td>
                                                    <td>92.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>*W/D</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>NETANYA SETHI</td>
                                                    <td>93.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>NIMISHA SINGH</td>
                                                    <td>94</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>YAJUR MEHRA</td>
                                                    <td>93.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>AADVEEK BHATIA</td>
                                                    <td>94.4</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>ARYAN SINGH</td>
                                                    <td>95.86</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>CHESLIN GARG</td>
                                                    <td>92.6</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>DEVYANI KAMBOJ</td>
                                                    <td>95.9</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>KRISHIV JASUJA</td>
                                                    <td>91.06</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>MISHKA SHARMA</td>
                                                    <td>93.82</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>VIHAN ARORA</td>
                                                    <td>91.82</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=8</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>AADYANT SONI</td>
                                                    <td rowspan="20">GODAVARI</td>
                                                    <td rowspan="20">JHELUM</td>
                                                    <td>90.80(B1 IN ENGLISH)</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>AANYA SHARMA</td>
                                                    <td>92.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>ARSHIYA GARG</td>
                                                    <td>97.4</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>IDA SINGH</td>
                                                    <td>92.2</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>60</td>
                                                    <td>JAYANTIKA BHATTACHARYA</td>
                                                    <td>94.2</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>61</td>
                                                    <td>NAVIKA ARORA</td>
                                                    <td>96.2</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>62</td>
                                                    <td>NISHKA SHARMA</td>
                                                    <td>95.8</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>63</td>
                                                    <td>PRISHA AHUJA</td>
                                                    <td>91.4</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>64</td>
                                                    <td>SAKSHAM MITTAL</td>
                                                    <td>93.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>65</td>
                                                    <td>SUMANYU SHARMA</td>
                                                    <td>97.4</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>66</td>
                                                    <td>AARAV JAIN</td>
                                                    <td>94.02</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>67</td>
                                                    <td>AARNA CHAWLA</td>
                                                    <td>91.16</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>68</td>
                                                    <td>ASHWIKA GUPTA</td>
                                                    <td>94.06</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>69</td>
                                                    <td>ATISHAY JAIN</td>
                                                    <td>91.04</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>70</td>
                                                    <td>PRISHA GUPTA</td>
                                                    <td>89.7</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>71</td>
                                                    <td>RASESH SINGLA</td>
                                                    <td>90.5</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>72</td>
                                                    <td>SAMAIRA AHLUWALIA</td>
                                                    <td>94.58</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>73</td>
                                                    <td>SAURISH CHAWLA</td>
                                                    <td>91.83</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>74</td>
                                                    <td>VANSHIKA GOVIL</td>
                                                    <td>91.3</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>75</td>
                                                    <td>YUVRAJ KALIA</td>
                                                    <td>91.48</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=10</td>
                                                </tr>
                                                <tr>
                                                    <td>76</td>
                                                    <td>AANYA VERMA</td>
                                                    <td rowspan="17">KAVERI</td>
                                                    <td rowspan="17">MAHANADI</td>
                                                    <td>90( B1 in Spanish)</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>77</td>
                                                    <td>MAYRA NAGPAL</td>
                                                    <td>97</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>78</td>
                                                    <td>PAVNI MEHTA</td>
                                                    <td>93.4</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>79</td>
                                                    <td>VIHAAN BANSAL</td>
                                                    <td>95.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>80</td>
                                                    <td>VIHAAN JAIN</td>
                                                    <td>91.2</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>81</td>
                                                    <td>VIVAAN KUNAL RANGOLE</td>
                                                    <td>93.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>82</td>
                                                    <td>AARAV PRASAD</td>
                                                    <td>95.8</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>83</td>
                                                    <td>ABIR ARORA</td>
                                                    <td>93.24</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>84</td>
                                                    <td>AHAN ROY</td>
                                                    <td>99.5</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>85</td>
                                                    <td>ARISHA VERMA</td>
                                                    <td>91.44</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>86</td>
                                                    <td>BHAAVYA YADAV</td>
                                                    <td>89.4</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>87</td>
                                                    <td>JAYANSH SAXENA</td>
                                                    <td>93.44</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>88</td>
                                                    <td>MYRA GANDHI</td>
                                                    <td>91.66</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>89</td>
                                                    <td>SIDDH BAKLIWAL</td>
                                                    <td>93.46</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>90</td>
                                                    <td>VARN BATRA</td>
                                                    <td>99.36</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>91</td>
                                                    <td>VIDUSHI RAGHUVANSHI</td>
                                                    <td>93.6</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>92</td>
                                                    <td>VIVAAN CHANDNA</td>
                                                    <td>92.78</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=6</td>
                                                </tr>
                                                <tr>
                                                    <td>93</td>
                                                    <td>AALIYAH WADHWA</td>
                                                    <td rowspan="24">NARMADA</td>
                                                    <td rowspan="24">RAVI</td>
                                                    <td>90</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>94</td>
                                                    <td>ADIT DEWAN</td>
                                                    <td>94.6</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>95</td>
                                                    <td>AMBAR VASHISTH</td>
                                                    <td>97.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>96</td>
                                                    <td>ARNAV CHOPRA</td>
                                                    <td>93.6</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>97</td>
                                                    <td>ARYAVEER PRABHAKAR</td>
                                                    <td>90.6</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>98</td>
                                                    <td>ASHVANT ROY</td>
                                                    <td>91.4</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>99</td>
                                                    <td>DEVARSH MADAN</td>
                                                    <td>95.4</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>100</td>
                                                    <td>DIVIJ ARORA</td>
                                                    <td>96.4</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>101</td>
                                                    <td>EKAANSH AGARWAL</td>
                                                    <td>98.4</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>102</td>
                                                    <td>ISHI GUPTA</td>
                                                    <td>93.2</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>103</td>
                                                    <td>NONITHA TALLURI</td>
                                                    <td>92.4</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>104</td>
                                                    <td>RITWICK AGARWAL</td>
                                                    <td>96</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>105</td>
                                                    <td>SHAARAV AGGARWAL</td>
                                                    <td>94.4</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>*W/D</td>
                                                </tr>
                                                <tr>
                                                    <td>106</td>
                                                    <td>VEDANG BHARDWAJ</td>
                                                    <td>94.6</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>107</td>
                                                    <td>VIHAN KHURANA</td>
                                                    <td>92</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>108</td>
                                                    <td>YAGN GUPTA</td>
                                                    <td>95</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>109</td>
                                                    <td>AANYA DHINGRA</td>
                                                    <td>98.15</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>110</td>
                                                    <td>ANNAN CHAWLA</td>
                                                    <td>89.78</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>111</td>
                                                    <td>ANSHIKA BATRA</td>
                                                    <td>95.36</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>112</td>
                                                    <td>ARJUN BANSAL</td>
                                                    <td>98.02</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>113</td>
                                                    <td>DARSH GAUR</td>
                                                    <td>90.02</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>114</td>
                                                    <td>SAI SAMARTH MARWAHA</td>
                                                    <td>95.92</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>115</td>
                                                    <td>TAMANNA ANAND</td>
                                                    <td>94.8</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>116</td>
                                                    <td>KAVYA MOHINDROO</td>
                                                    <td>89</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=15</td>
                                                </tr>
                                                <tr>
                                                    <td>117</td>
                                                    <td>AARAV KHANDPUR</td>
                                                    <td rowspan="22">SUTLEJ</td>
                                                    <td rowspan="22">TAPTI</td>
                                                    <td>93.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>118</td>
                                                    <td>AKARSHI BHATTACHARYA</td>
                                                    <td>92</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>119</td>
                                                    <td>AMAIRA GARG</td>
                                                    <td>96.6</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>120</td>
                                                    <td>ARAV AGGARWAL</td>
                                                    <td>91.2</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>121</td>
                                                    <td>ASYA BANSAL</td>
                                                    <td>93.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>122</td>
                                                    <td>NAVYA JAIN</td>
                                                    <td>95.4</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>123</td>
                                                    <td>PAHAL BANSAL</td>
                                                    <td>90.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>124</td>
                                                    <td>RACHIT RUSTAGI</td>
                                                    <td>95.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>125</td>
                                                    <td>AADYA BATRA</td>
                                                    <td>90.8</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>126</td>
                                                    <td>AAROHI KHANDELWAL</td>
                                                    <td>92.86</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>127</td>
                                                    <td>ANGAD SHARMA</td>
                                                    <td>94.68</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>128</td>
                                                    <td>ARIHANT SINGH</td>
                                                    <td>90.18</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>129</td>
                                                    <td>ARJUN KAPIL</td>
                                                    <td>93.5</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>130</td>
                                                    <td>AUSTIN RAJU PULLAN</td>
                                                    <td>95.24</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>131</td>
                                                    <td>AYAAN WADHWA</td>
                                                    <td>96</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>132</td>
                                                    <td>RAGHAV ARORA</td>
                                                    <td>91.64</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>133</td>
                                                    <td>SARTHAK TANWAR</td>
                                                    <td>97.36</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>134</td>
                                                    <td>SIA GANDHI</td>
                                                    <td>90.72</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>135</td>
                                                    <td>VAANYA BHUTANI</td>
                                                    <td>94.58</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>136</td>
                                                    <td>VEDIKA MARWAH</td>
                                                    <td>93.22</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>137</td>
                                                    <td>NAYSA ARORA</td>
                                                    <td>89</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>138</td>
                                                    <td>RITVIK MAHESHWARI</td>
                                                    <td>89</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=8</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="8">TOTAL SCHOLARS IN GRADE VI (2022-23) =&nbsp; 63&nbsp; (W/D) = 3</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>CERTIFICATES&nbsp;</td>
                                                    <td>63</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>Pink Badges</td>
                                                    <td>60</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>Grey Pockets</td>
                                                    <td>60</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>COMPARATIVE ANALYSIS</td>
                                                    <td>2021-22</td>
                                                    <td>2022-23</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>Total Strength</td>
                                                    <td>211</td>
                                                    <td>210</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>Scholars</td>
                                                    <td>141</td>
                                                    <td>63</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>%</td>
                                                    <td>66.30%</td>
                                                    <td>30%</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th colspan="8">DETAILS FOR THE SCHOLAR CERTIFICATES : GRADE VII (2022-23)</th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th colspan="8">Aggregate 90% &amp; Above</th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAMES</th>
                                                    <th rowspan="2">GRADE - VII (2022-23)</th>
                                                    <th rowspan="2">GRADE - VIII (2023-24)</th>
                                                    <th rowspan="2">%</th>
                                                    <th rowspan="2">SESSIONS</th>
                                                    <th colspan="2">SCHOLAR STATUS</th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th>BADGE</th>
                                                    <th>POCKET</th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td width="205">AASHVI THAKUR</td>
                                                    <td rowspan="10">CHENAB</td>
                                                    <td rowspan="10">AMAZON</td>
                                                    <td>95.2</td>
                                                    <td>2022-23,2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td width="205">ABHINAV MAKKAR</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td width="205">AKSHAR MATTA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td width="205">DEVYANSH MALIK</td>
                                                    <td>93.6</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td width="205">GARVITA JAIN</td>
                                                    <td>94</td>
                                                    <td>SCHOLAR IN 2022-23 TC CASE</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>W/D</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>GIA VERMA</td>
                                                    <td>91.8</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>KABIR GUPTA</td>
                                                    <td>90.6</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>PRISHA VERMA</td>
                                                    <td>91</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>MEHAK JINDAL</td>
                                                    <td>97.2</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>SONAL MITTAL</td>
                                                    <td>97.6</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL= 7 + 1 TC CASE</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td width="205">AARNA BHUSHAN</td>
                                                    <td rowspan="16">DAMODAR</td>
                                                    <td rowspan="16">COLORADO</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td width="205">AMOGH DOSHI</td>
                                                    <td>93</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td width="205">ANANYA KAPOOR</td>
                                                    <td>90.6</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td width="205">ATHARV MALHOTRA</td>
                                                    <td>92.4</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td width="205">AVNI JAIN</td>
                                                    <td>93.4</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td width="205">GURSIMRAT SINGH</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td width="205">PRISHA KUMAR</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td width="205">SANA BUGALIA</td>
                                                    <td>92.6</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td width="205">SAANVI BHAYANA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td width="205">SARANYA SINGHAL</td>
                                                    <td>94.4</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td width="205">SHARANYA CHAUHAN</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td width="205">SUHANA SINDHWANI</td>
                                                    <td>94.2</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td width="205">VIVAAN BANKA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td width="205">YASHITA MAHESHWARI</td>
                                                    <td>93.8</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td width="205">NIRVAN MAHESHWARI</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td width="205">RUHEEN BAJAJ</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL = 8&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td width="205">AARUSH DEWAN</td>
                                                    <td rowspan="7">INDUS</td>
                                                    <td rowspan="7">CONGO</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>AAROHI GARG</td>
                                                    <td>95.8</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>ADVIKA BANERJEE</td>
                                                    <td>93.4</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td width="205">HIBAH IMTIAZ CHAGLANI</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td width="205">SHREYA MAMTANI</td>
                                                    <td>94.6</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td width="205">SHIVANSH KHANNA</td>
                                                    <td>89.6</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td width="205">SHRISHTI BANSAL</td>
                                                    <td>98.2</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL= 5</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td width="205">ADITYA ASHISH MAHANTA</td>
                                                    <td rowspan="10">JHELUM</td>
                                                    <td rowspan="10">DANUBE</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td width="205">AMANAT GIRDHAR</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td width="205">ANAY GARG</td>
                                                    <td>91.8</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td width="205">KAVNEER KAUR THUKRAL</td>
                                                    <td>91</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td width="205">MMANAT BAGHLA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td width="205">PRIYANSH CHATTERJEE</td>
                                                    <td>92.2</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td width="205">RUHAAN GUPTA</td>
                                                    <td>94.8</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td width="205">SUHANA PALHAN</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td width="205">ESHAN MAKIN</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td width="205">MAHIKA YADAV</td>
                                                    <td>89.6</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL= 5</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td width="205">AARAV RANGRAJ</td>
                                                    <td rowspan="11">MAHANADI</td>
                                                    <td rowspan="11">MISSISSIPPI</td>
                                                    <td>94.6</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td width="205">AHAAN GUPTA</td>
                                                    <td>95.6</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td width="205">AKARSHIKA DHINGRA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td width="205">ANYA MUNDRA</td>
                                                    <td>92.6</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td width="205">AVNI JAIN</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td width="205">ARNAV VIJ</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td width="205">DHWANI MADAN&nbsp;</td>
                                                    <td>90.8</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td width="205">PRANEY GUGLANI</td>
                                                    <td>92.8</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td width="205">UDYAT AHUJA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>AALIYAH ARUN</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>DEVAANSH WADHWA</td>
                                                    <td>91</td>
                                                    <td>2022-23, 2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>SANAH SUTHIN</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>91.8</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=7&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>AADYA PROOTHI</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>90</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>AARAV DURANI</td>
                                                    <td rowspan="12">RAVI</td>
                                                    <td rowspan="12">NILE</td>
                                                    <td>92.8</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>AARNAV SHARMA</td>
                                                    <td>90.8</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>ARJUN WALIA</td>
                                                    <td>94</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>60</td>
                                                    <td>KAAVYA JOSHI</td>
                                                    <td>97.4</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>61</td>
                                                    <td>KYAN MAHAJAN</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>62</td>
                                                    <td>NEEL DHODY</td>
                                                    <td>90</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>63</td>
                                                    <td>SAANVI SINGH 2</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>64</td>
                                                    <td>SAMREEN TULLA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>65</td>
                                                    <td>SHAURYA VASUDEVAN</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>66</td>
                                                    <td>VIR NIJHAWAN</td>
                                                    <td>93.8</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>67</td>
                                                    <td>VEDAANSH KHANEJA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>68</td>
                                                    <td>YUVAKSHI CHOPRA</td>
                                                    <td>94.4</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL=8&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>69</td>
                                                    <td width="205">ADAM SALROO</td>
                                                    <td rowspan="13">TAPTI</td>
                                                    <td rowspan="13">RHINE</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>70</td>
                                                    <td width="205">ARSH SINGH GILL</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>71</td>
                                                    <td width="205">AMAIRA VOHRA</td>
                                                    <td>92.8</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>72</td>
                                                    <td width="205">ARJUN KHETERPAL</td>
                                                    <td>91.8</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>73</td>
                                                    <td width="205">AVANTIKA PANDE</td>
                                                    <td>92.6</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>74</td>
                                                    <td width="205">AVNI PANDEY</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>75</td>
                                                    <td width="205">MANIT ANGIRAS</td>
                                                    <td>96.6</td>
                                                    <td>2022-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>76</td>
                                                    <td width="205">SHANAYA SURI</td>
                                                    <td>96</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>77</td>
                                                    <td width="205">SHAURAY VALECHA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>78</td>
                                                    <td width="205">VAIGA P. NAIR</td>
                                                    <td>94.6</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>79</td>
                                                    <td width="205">VEDANT GROVER</td>
                                                    <td>93.6</td>
                                                    <td>2022-23, 2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>80</td>
                                                    <td width="205">VIVAAN CHOPRA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>81</td>
                                                    <td width="205">MANYA SRIVASTAVA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2021-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>TOTAL= 7&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="8">TOTAL SCHOLARS IN GRADE VII (2022-23) =&nbsp; 48&nbsp; - 1 (WITHDRAWL) = 47</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Certificates&nbsp;</td>
                                                    <td>48</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Pink Badges</td>
                                                    <td>47</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Grey Pockets</td>
                                                    <td>47</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>COMPARATIVE ANALYSIS</td>
                                                    <td>2020-21</td>
                                                    <td>2021-22</td>
                                                    <td>2022-23</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Total Strength</td>
                                                    <td>204</td>
                                                    <td>208</td>
                                                    <td>205</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Scholars</td>
                                                    <td>108</td>
                                                    <td>81</td>
                                                    <td>48</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>%</td>
                                                    <td>52.94%</td>
                                                    <td>39.90%</td>
                                                    <td>23.41 %</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody></table>
                                        <table className='table-view' border="1" width="100%">

                                            <tbody><tr>
                                                <th colspan="5">DETAILS FOR THE SCHOLAR CERTIFICATES : GRADE VIII (2021-22)&nbsp;&nbsp;&nbsp;&nbsp;</th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                                <tr>
                                                    <th colspan="8">Aggregate 90% and Above</th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAMES</th>
                                                    <th rowspan="2">GRADE - VIII (2021-22)</th>
                                                    <th rowspan="2">GRADE - IX&nbsp; (2022-23)</th>
                                                    <th rowspan="2">SESSIONS</th>
                                                    <th colspan="3">SCHOLAR STATUS</th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th>BLAZER</th>
                                                    <th>BADGE</th>
                                                    <th>POCKET</th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AADHYA GUPTA</td>
                                                    <td rowspan="9">AMAZON</td>
                                                    <td>VINDHYAS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>SPANDANA SANJOY BARUA</td>
                                                    <td>VINDHYAS</td>
                                                    <td>2021-22, 2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>SAANVI RANJAN</td>
                                                    <td>VINDHYAS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>PRAGYA YADAV</td>
                                                    <td>NILGIRIS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>AFRAAZ ALAM</td>
                                                    <td>VINDHYAS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>ADITYA KUMAR</td>
                                                    <td>NILGIRIS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>RISHIT GOYAL</td>
                                                    <td>WITHDRAWN</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>ANANYA GOEL</td>
                                                    <td>VINDHYAS</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>NIKITA JUNEJA</td>
                                                    <td>VINDHYAS</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>ARNAV ARORA</td>
                                                    <td rowspan="10">COLORADO</td>
                                                    <td>ARAVALLIS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>AVNI SINGH</td>
                                                    <td>ARAVALLIS</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>AYUSHI MOOLCHANDANI</td>
                                                    <td>NILGIRIS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>NAVYA GARG</td>
                                                    <td>WITHDRAWN</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>RYAN GUPTA</td>
                                                    <td>ARAVALLIS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>SABHYA AGGARWAL</td>
                                                    <td>ARAVALLIS</td>
                                                    <td>2021-22, 2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>SIMAR KAUR</td>
                                                    <td>NILGIRIS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>KARTIK BHAGIA</td>
                                                    <td>ARAVALLIS</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>RISHA AGARWAL</td>
                                                    <td>NILGIRIS</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>SMAHI VIJAY</td>
                                                    <td>WITHDRAWN</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>AAIRIYA JAIN</td>
                                                    <td rowspan="13">CONGO</td>
                                                    <td>EVEREST</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>AYANNA MUNJAL</td>
                                                    <td>EVEREST</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>ABHIMANYU BHARDWAJ</td>
                                                    <td>EVEREST</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>SARTHAK JAIN</td>
                                                    <td>EVEREST</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>SHAURYA SEHRA</td>
                                                    <td>EVEREST</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>SHRADHA MIGLANI</td>
                                                    <td>WITHDRAWN</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>TANVI WASON</td>
                                                    <td>EVEREST</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>MANVIT BANDHU</td>
                                                    <td>EVEREST</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>JITESH BAJAJ</td>
                                                    <td>EVEREST</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>SIMONE KAUR MAKKUR</td>
                                                    <td>SHIVALIKS</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>NISHKA SAXENA</td>
                                                    <td>EVEREST</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>RUDRANSH SINGH</td>
                                                    <td>EVEREST</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>DITI BHATIA</td>
                                                    <td>EVEREST</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>HANEEKA MODI</td>
                                                    <td rowspan="9">DANUBE</td>
                                                    <td>SHIVALIKS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>HARLEEN KAUR</td>
                                                    <td>HIMALAYAS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>JAY SINGH</td>
                                                    <td>SHIVALIKS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>JESSICA SINGH</td>
                                                    <td>SHIVALIKS</td>
                                                    <td>2021-22,2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>SHIVANK NOHWAL</td>
                                                    <td>SHIVALIKS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>SHOBIT GALHOTRA</td>
                                                    <td>SHIVALIKS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>VIVAAN BANERJEE</td>
                                                    <td>HIMALAYAS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>VYOM VIJ</td>
                                                    <td>SHIVALIKS</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>SIDH KHATTER</td>
                                                    <td>SHIVALIKS</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>AANYA MITTAL</td>
                                                    <td rowspan="9">MISSISSIPPI</td>
                                                    <td>SHIVALIKS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>ANIRUDDHA BHATTACHARYA</td>
                                                    <td>HIMALAYAS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>NAVNOOR KAUR</td>
                                                    <td>HIMALAYAS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>PRAGNAY SHARMA</td>
                                                    <td>HIMALAYAS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>PRATEEK SINHA</td>
                                                    <td>HIMALAYAS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>RIDDHI MANOCHA</td>
                                                    <td>HIMALAYAS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>VIDHI VASHISTH</td>
                                                    <td>SHIVALIKS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>AANYA PANDEY</td>
                                                    <td>HIMALAYAS</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>RITHIKA TALLURI</td>
                                                    <td>HIMALAYAS</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>ADVIK MEHTA</td>
                                                    <td rowspan="10">NILE</td>
                                                    <td>KANCHENJUNGA</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>ADVIKA JAIN</td>
                                                    <td>KANCHENJUNGA</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>ADWAY GUPTA</td>
                                                    <td>KANCHENJUNGA</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>ANAV SHAH</td>
                                                    <td>KANCHENJUNGA</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>ARJUN MITTAL</td>
                                                    <td>KANCHENJUNGA</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>DISHA BUDHIRAJA</td>
                                                    <td>KAMET</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>PALAK BHANDARI</td>
                                                    <td>KANCHENJUNGA</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>VADANYA CHATURVEDI</td>
                                                    <td>KANCHENJUNGA</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>KARTIK TANDON</td>
                                                    <td>KANCHENJUNGA</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>60</td>
                                                    <td>LEISHA KAPIL</td>
                                                    <td>KANCHENJUNGA</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>61</td>
                                                    <td>AARAV ANAND</td>
                                                    <td rowspan="13">RHINE</td>
                                                    <td>KAMET</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>62</td>
                                                    <td>AARAV SINHA</td>
                                                    <td>VINDHYAS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>63</td>
                                                    <td>AGASTYA TRIKHA</td>
                                                    <td>KAMET</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>64</td>
                                                    <td>ARCHIT SAHNI</td>
                                                    <td>KAMET</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>65</td>
                                                    <td>KHUSHI JOSHI</td>
                                                    <td>VINDHYAS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>66</td>
                                                    <td>MEHER SETIA</td>
                                                    <td>KAMET</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>67</td>
                                                    <td>REYNA UPADHYAY</td>
                                                    <td>KAMET</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>68</td>
                                                    <td>SURYA KHURANA</td>
                                                    <td>KAMET</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>69</td>
                                                    <td>SVASTI BORA</td>
                                                    <td>KAMET</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>70</td>
                                                    <td>TASHVI VIRMANI</td>
                                                    <td>KAMET</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>71</td>
                                                    <td>TOSHANI GAUR</td>
                                                    <td>KAMET</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>72</td>
                                                    <td>DHRITI SINGH</td>
                                                    <td>KAMET</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>73</td>
                                                    <td>EKLAVYA MUKHERJI</td>
                                                    <td>KAMET</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>74</td>
                                                    <td>AADYA SAXENA</td>
                                                    <td rowspan="18">VOLGA</td>
                                                    <td>ARAVALLIS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>75</td>
                                                    <td>AAHNA GULATI</td>
                                                    <td>ARAVALLIS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>76</td>
                                                    <td>AANYA SAHANI</td>
                                                    <td>VINDHYAS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>77</td>
                                                    <td>ADITI KUMAR</td>
                                                    <td>WITHDRAWN</td>
                                                    <td>2021-22,2019-20,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>78</td>
                                                    <td>AHAAN PORWAL</td>
                                                    <td>ARAVALLIS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>79</td>
                                                    <td>ARHAN ATTRI</td>
                                                    <td>ARAVALLIS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>80</td>
                                                    <td>ARYAN GULATI</td>
                                                    <td>ARAVALLIS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>81</td>
                                                    <td>ASHMI MONGA</td>
                                                    <td>VINDHYAS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>82</td>
                                                    <td>DIYA GERA</td>
                                                    <td>ARAVALLIS</td>
                                                    <td>2021-22,2020-21,2019 -20,</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>83</td>
                                                    <td>KASHIKA GUPTA</td>
                                                    <td>VINDHYAS</td>
                                                    <td>2021-22, 2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>84</td>
                                                    <td>SAARVIN SINGHAL</td>
                                                    <td>ARAVALLIS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>85</td>
                                                    <td>SARANYA JAGGI</td>
                                                    <td>NILGIRIS</td>
                                                    <td>2021-22, 2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>86</td>
                                                    <td>SRISHTI BAKLIWAL</td>
                                                    <td>ARAVALLIS</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>87</td>
                                                    <td width="205">AYANNA VAIDYA</td>
                                                    <td>NILGIRIS</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>88</td>
                                                    <td width="205">SACHIN SOOD</td>
                                                    <td>ARAVALLIS</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>89</td>
                                                    <td width="205">KENISHA DAWAR</td>
                                                    <td>VINDHYAS</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>90</td>
                                                    <td width="205">DIVYANSHI GILL</td>
                                                    <td>VINDHYAS</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>91</td>
                                                    <td width="205">TAASHVI KAPOOR</td>
                                                    <td>ARAVALLIS</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink</td>
                                                    <td>Yes</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="8">TOTAL SCHOLARS IN GRADE VIII (2021-22) =&nbsp; 91&nbsp; , Withdrawal = 5</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>Pink Badges</td>
                                                    <td>91</td>
                                                    <td></td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>Grey Pockets</td>
                                                    <td>33</td>
                                                    <td></td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>Blazers</td>
                                                    <td>58</td>
                                                    <td></td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>COMPARATIVE ANALYSIS</td>
                                                    <td>2020-21</td>
                                                    <td>2021-22</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Total Strength</td>
                                                    <td>230</td>
                                                    <td>224</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Scholars</td>
                                                    <td>93</td>
                                                    <td>91</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>%</td>
                                                    <td>40.40%</td>
                                                    <td>40.62%</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th colspan="9">DETAILS FOR THE SCHOLAR CERTIFICATES (2021-22) : GRADE IX</th>
                                                </tr>
                                                <tr>
                                                    <th colspan="9">CRITERIA:&nbsp; 85%&nbsp; and above</th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAMES</th>
                                                    <th rowspan="2">GRADE - IX (2021-22)</th>
                                                    <th rowspan="2">GRADE - X (2022-23)</th>
                                                    <th rowspan="2">%age</th>
                                                    <th rowspan="2">SESSIONS</th>
                                                    <th colspan="3" width="200">SCHOLAR STATUS</th>
                                                </tr>
                                                <tr>
                                                    <th>BLAZER</th>
                                                    <th>BADGE</th>
                                                    <th>POCKET</th>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>ADITYA PRAKASH</td>
                                                    <td rowspan="13">ARAVALLIS</td>
                                                    <td rowspan="13">ALPS</td>
                                                    <td>90.06</td>
                                                    <td>2021-22,2020-21,2019-20,2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>ARNAV GUPTA</td>
                                                    <td>91.48</td>
                                                    <td>2021-22,2020-21,2019-20,2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>AYATI SHOBNIM SINGH</td>
                                                    <td>84.72</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>DEVANSH SHARMA</td>
                                                    <td>88.58</td>
                                                    <td>&nbsp;2021-22,2020-21, 2019-20,2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>GAURI AGARWAL</td>
                                                    <td>87.44</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>ISHITA MADHOK</td>
                                                    <td>87.82</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>MRRIDUL SESHADRI</td>
                                                    <td>97.38</td>
                                                    <td>2021-22,2020-21,2019-20,2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>PAARTH GUPTA</td>
                                                    <td>89.24</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>PARIDHI GARG</td>
                                                    <td>90.82</td>
                                                    <td>2021-22,2020-21, 2019-20, 2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>PRATHAM SETHI</td>
                                                    <td>85.1</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>SANA MEHTA</td>
                                                    <td>86.92</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>VANSH SRIVASTAVA</td>
                                                    <td>92.7</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>VIDITA SINGH ATRI</td>
                                                    <td>89.12</td>
                                                    <td>2021-22,2020-21,2019-18,2018-19</td>
                                                    <td>Yes</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>BHAVYA GUPTA</td>
                                                    <td rowspan="6">EVEREST</td>
                                                    <td rowspan="6">ANDES</td>
                                                    <td>85.62</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>HITANSHI AGGARWAL</td>
                                                    <td>90.18</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>MAANYA RAJPUT</td>
                                                    <td>90.22</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>NISHKA CHOPRA</td>
                                                    <td>92.58</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>REYANSH AGARWAL</td>
                                                    <td>94.62</td>
                                                    <td>2020-21,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>VIHAAN MEHROTRA</td>
                                                    <td>89.94</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>ARNAV WADHWA</td>
                                                    <td rowspan="11">HIMALAYAS</td>
                                                    <td rowspan="11">ELBRUS</td>
                                                    <td>91.32</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>ARYA JAIN</td>
                                                    <td>87.92</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>ARYAN GUPTA</td>
                                                    <td>89.82</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>ASTU VATS</td>
                                                    <td>84.38</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>HIBAH AULAKH. (W/D)</td>
                                                    <td>91.8</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>PRANYA ARORA</td>
                                                    <td>85.42</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>SAYESHA JAIN</td>
                                                    <td>95.32</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-17</td>
                                                    <td>Yes</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>SHAURYA BANSAL</td>
                                                    <td>85.08</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>SHAURYA SINGH</td>
                                                    <td>91.76</td>
                                                    <td>2021-22,2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>SHIRANI ANAND</td>
                                                    <td>94.28</td>
                                                    <td>2021-22,2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>TANISHQA CHADHA</td>
                                                    <td>88.88</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>ARNAV SHARMA</td>
                                                    <td rowspan="7">SHIVALIKS</td>
                                                    <td rowspan="7">OLYMPUS</td>
                                                    <td>85.42</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>MYRA KAILWOO</td>
                                                    <td>84.88</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>RADHIKA PURI</td>
                                                    <td>89.22</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>SARA GUPTA</td>
                                                    <td>88.66</td>
                                                    <td>2021-22, 2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>SHREYA SETHI</td>
                                                    <td>90.48</td>
                                                    <td>2021-22, 2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>SYED AZHAAN ABBAS RIZVI</td>
                                                    <td>92.62</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>TANUSHREE NONGTHOMBAM</td>
                                                    <td>88.16</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>AAKRITI DEWAN</td>
                                                    <td rowspan="7">KANCHENJUNGA</td>
                                                    <td rowspan="7">ELBERT</td>
                                                    <td>89.5</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>JUNIYALI PANWAR</td>
                                                    <td>89.92</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>RISHI GANDHI</td>
                                                    <td>87.12</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>SAGAR AGGGRWAL</td>
                                                    <td>91.9</td>
                                                    <td>2021-22,2020-21,2020-19,2019-18,2017-18</td>
                                                    <td>Yes</td>
                                                    <td>blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>SHAURYA SHARMA</td>
                                                    <td>93</td>
                                                    <td>2021-22,2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>S.SHREENIDHI</td>
                                                    <td>89.28</td>
                                                    <td>2021-22,2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>VIHAAN KAPOOR</td>
                                                    <td>87.42</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>ANGEL KHANNA</td>
                                                    <td rowspan="6">NILGIRIS</td>
                                                    <td rowspan="6">FUJI</td>
                                                    <td>88.32</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>HARSHITA BUGALIA</td>
                                                    <td>93.72</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>KESHAVA PIYUSH PRASAD</td>
                                                    <td>91.74</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>MANASVI&nbsp; AGARWAL</td>
                                                    <td>92.2</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>MEGHA&nbsp; ANAND</td>
                                                    <td>89.52</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>SANCHIT CHHAMUNYA</td>
                                                    <td>88.52</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>ABHIMANYU ARORA</td>
                                                    <td rowspan="14">VINDHYAS</td>
                                                    <td rowspan="14">WHITNEY</td>
                                                    <td>88.18%</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>AISHIKA CHADHA</td>
                                                    <td>85.32%</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>ANIKA RANAUT</td>
                                                    <td>87.74%</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>ANISHA&nbsp; GUPTA</td>
                                                    <td>85.84%</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>AYUSH KHANDELWAL</td>
                                                    <td>93.38%</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19,2018-17</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>DHRUVIKAA D REDDY</td>
                                                    <td>90.16%</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>GAURI SHARMA</td>
                                                    <td>84.80%</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>KANIKA DEV</td>
                                                    <td>85.22%</td>
                                                    <td>2021-22,2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>MAANSI SINGH</td>
                                                    <td>84.82%</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>60</td>
                                                    <td>MAMILLA SAI ROHAN</td>
                                                    <td>93.94%</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>61</td>
                                                    <td>MEDHA GUPTA</td>
                                                    <td>85.58%</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>62</td>
                                                    <td>MIHIKAA SINGH</td>
                                                    <td>91.40%</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>63</td>
                                                    <td>RADHA ANAND HINGNE</td>
                                                    <td>88.40%</td>
                                                    <td>2021-22,2020-21 2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>64</td>
                                                    <td>SHREYANS BHARGAVA</td>
                                                    <td>85.68%</td>
                                                    <td>2021-22,2020-21,2019-20,2018-19, 2017-18</td>
                                                    <td>yes</td>
                                                    <td>BLUE</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="9">TOTAL SCHOLARS IN GRADE IX (2021-22) = 64&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Withdrawl - 1 Total&nbsp; 63</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Pink Badges</td>
                                                    <td>31</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Blue Badges</td>
                                                    <td>33</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Grey Pockets</td>
                                                    <td>29</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Blue Blazers</td>
                                                    <td>36</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>COMPARATIVE ANALYSIS</td>
                                                    <td>2020-21</td>
                                                    <td>2021-22</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Total Strength</td>
                                                    <td>192</td>
                                                    <td>188</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Scholars</td>
                                                    <td>98</td>
                                                    <td>64</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>%</td>
                                                    <td>51.0</td>
                                                    <td>34.0</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td colspan="2">TC Cases: HIBAH AULAKH (IX HIMALAYAS)</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th colspan="9">DETAILS FOR THE SCHOLAR CERTIFICATES (2021-22) : GRADE X</th>
                                                </tr>
                                                <tr>
                                                    <th colspan="9">CRITERIA:&nbsp; 85%&nbsp; and above</th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAMES</th>
                                                    <th rowspan="2">GRADE - X&nbsp;2021-22)</th>
                                                    <th rowspan="2">GRADE - XI&nbsp;(2022-23)</th>
                                                    <th>&nbsp;</th>
                                                    <th rowspan="2">SESSIONS</th>
                                                    <th colspan="3">SCHOLAR STATUS</th>
                                                </tr>
                                                <tr>
                                                    <th>%age</th>
                                                    <th>BLAZER</th>
                                                    <th>BADGE</th>
                                                    <th>POCKET</th>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AMEYA CHAURASIA</td>
                                                    <td rowspan="18">ALPS</td>
                                                    <td>EINSTEIN</td>
                                                    <td>92</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>AMULYAA KASHYAP</td>
                                                    <td>ARISTOTLE</td>
                                                    <td>96.4</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>ANYA GOYAL (W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>96.4</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>APURVA GANGRADE(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>94.2</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>GARV AGARWAL(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>97.4</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>INAYAT SAIGAL</td>
                                                    <td>DALTON</td>
                                                    <td>88.2</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>JIYA MAHAJAN</td>
                                                    <td>SHAKESPEARE</td>
                                                    <td>95.2</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>JIYA WALIA(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>97</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>KRITHARTH SHARAN</td>
                                                    <td>EINSTEIN</td>
                                                    <td>96.2</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>NYESA JAIN</td>
                                                    <td>SHAKESPEARE</td>
                                                    <td>96.2</td>
                                                    <td>2021-22; 2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>PRISHA KHANNA</td>
                                                    <td>EINSTEIN</td>
                                                    <td>94.76</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>SAKSHAM JAIN(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>94.8</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>SAMRITI SHARMA</td>
                                                    <td>DALTON</td>
                                                    <td>90.4</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>SNEHAL SINGH</td>
                                                    <td>EINSTEIN</td>
                                                    <td>92.8</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>TANISHA SRIVASTAVA</td>
                                                    <td>DALTON</td>
                                                    <td>93.2</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>UTKARSH SINGH(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>93.4</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>VEER UPMANYU</td>
                                                    <td>EINSTEIN</td>
                                                    <td>85.8</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>VIDHRAJ SINGH</td>
                                                    <td>EINSTEIN</td>
                                                    <td>92.8</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>AARAV GARG</td>
                                                    <td rowspan="23">ANDES</td>
                                                    <td>EINSTEIN</td>
                                                    <td>95.6</td>
                                                    <td>2021-22, 2020-21,2019-20, 2018-19</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>ALIZA&nbsp; AZHAR</td>
                                                    <td>ARISTOTLE</td>
                                                    <td>85.8</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>ANUSHKA JAIN(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>95</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>ADITYA SINGH RAJPUROHIT(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>97.2</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>ADVAY DANGI</td>
                                                    <td>SHAKESPEARE</td>
                                                    <td>89</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>ARAV MATHUR</td>
                                                    <td>DALTON</td>
                                                    <td>96.8</td>
                                                    <td>2021-22, 2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>ARNAV SINGH</td>
                                                    <td>EINSTEIN</td>
                                                    <td>92</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>ASHWIKA GUPTA</td>
                                                    <td>ARISTOTLE</td>
                                                    <td>89.6</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>DEEPTI KHETAN</td>
                                                    <td>ARISTOTLE</td>
                                                    <td>95.6</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>DIVY GUPTA(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>91</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>DIYA VERMA</td>
                                                    <td>EINSTEIN</td>
                                                    <td>91.2</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>DIVYAM CHAWLA</td>
                                                    <td>ARISTOTLE</td>
                                                    <td>88</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>GITANJALI SINGH ATRI</td>
                                                    <td>EINSTEIN</td>
                                                    <td>95.4</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>ISHAAN CHHABRA</td>
                                                    <td>ARISTOTLE</td>
                                                    <td>94.8</td>
                                                    <td>2021-22, 2020-21,2019-20, 2018-19</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>KARMAN ROOPRAI(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>94</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>MANYA JAIN</td>
                                                    <td>EINSTEIN</td>
                                                    <td>88</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>SAANVI DAS</td>
                                                    <td>EINSTEIN</td>
                                                    <td>98</td>
                                                    <td>2021-22, 2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>SARA KHURANA</td>
                                                    <td>DALTON</td>
                                                    <td>91</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>SHAURYA AGARWAL</td>
                                                    <td>SHAKESPEARE</td>
                                                    <td>98.2</td>
                                                    <td>2021-2022, 2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>SRINJAY MUKHERJEE(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>88.6</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>TANISHKA SHARMA</td>
                                                    <td>DALTON</td>
                                                    <td>92</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>TANVI SINGH</td>
                                                    <td>ARISTOTLE</td>
                                                    <td>88</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>VEDANT SHARMA</td>
                                                    <td>EINSTEIN</td>
                                                    <td>87.6</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>AKSHAT RAMPAL</td>
                                                    <td rowspan="24">ELBRUS</td>
                                                    <td>SHAKESPEARE</td>
                                                    <td>92.8</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>ANANYA SIROHI</td>
                                                    <td>KEYNES</td>
                                                    <td>96</td>
                                                    <td>2021-22;2019-20, 2018-19, 2017-18, 2016-18</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>ANAYA BANSAL</td>
                                                    <td>KEYNES</td>
                                                    <td>94.6</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>ARYA SETIA</td>
                                                    <td>DALTON</td>
                                                    <td>93</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>HIYA THAKUR(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>92.2</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>KRISHIV KHANNA</td>
                                                    <td>EINSTEIN</td>
                                                    <td>94.2</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>LEPEE JAIN(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>91.8</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>MANNAN RANA</td>
                                                    <td>DALTON</td>
                                                    <td>97</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18, 2016-18</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>MRINALINI CHITRA</td>
                                                    <td>KEYNES</td>
                                                    <td>91.8</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>NAVYA AGARWAL</td>
                                                    <td>SHAKESPEARE</td>
                                                    <td>95.6</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>NAVYA SINGHAL</td>
                                                    <td>KEYNES</td>
                                                    <td>93.8</td>
                                                    <td>2021-22;2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>NIA RANJAN</td>
                                                    <td>DALTON</td>
                                                    <td>94.8</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>NIEEL PRAVEEN</td>
                                                    <td>EINSTEIN</td>
                                                    <td>92.8</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>PRITHVI SUBHASH JANGID</td>
                                                    <td>KEYNES</td>
                                                    <td>91.2</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>PRANYA KASHYAP(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>96.2</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>PRIYANSHI MATHUR</td>
                                                    <td>EINSTEIN</td>
                                                    <td>85.6</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>RAMDAS SINGH</td>
                                                    <td>EINSTEIN</td>
                                                    <td>96.2</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>RISHIT RAMPAL</td>
                                                    <td>KEYNES</td>
                                                    <td>90.2</td>
                                                    <td>2021-22; 2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>60</td>
                                                    <td>RITISHA MEHROTRA</td>
                                                    <td>KEYNES</td>
                                                    <td>88.2</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>61</td>
                                                    <td>SAANVI HORA</td>
                                                    <td>KEYNES</td>
                                                    <td>93.2</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>62</td>
                                                    <td>SIDDHANT CHHONKAR</td>
                                                    <td>KEYNES</td>
                                                    <td>91</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>63</td>
                                                    <td>VANSHIKA JAIN</td>
                                                    <td>KEYNES</td>
                                                    <td>93</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>64</td>
                                                    <td>VIVAAN BATTISH</td>
                                                    <td>KEYNES</td>
                                                    <td>90.62</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>65</td>
                                                    <td>YATEE NAGPAL</td>
                                                    <td>SHAKESPEARE</td>
                                                    <td>90.2</td>
                                                    <td>2021-22; 2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>66</td>
                                                    <td>AADEESH JAIN</td>
                                                    <td rowspan="12">OLYMPUS</td>
                                                    <td>EDISON</td>
                                                    <td>95.4</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>67</td>
                                                    <td>AARNAA BATRA</td>
                                                    <td>WINSLOW</td>
                                                    <td>89.94</td>
                                                    <td>2021-22; 2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>68</td>
                                                    <td>AHAD TARIQ</td>
                                                    <td>WINSLOW</td>
                                                    <td>88.2</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>69</td>
                                                    <td>DITYA BHUTTAN</td>
                                                    <td>SHAKESPEARE</td>
                                                    <td>92.8</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>70</td>
                                                    <td>GARV MULLICK</td>
                                                    <td>WINSLOW</td>
                                                    <td>93.6</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>71</td>
                                                    <td>JAGRAV MAGON</td>
                                                    <td>EINSTEIN</td>
                                                    <td>90.2</td>
                                                    <td>2021-22; 2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>72</td>
                                                    <td>JAIADITYA RATHORE</td>
                                                    <td>DALTON</td>
                                                    <td>93.6</td>
                                                    <td>2021-22;2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>73</td>
                                                    <td>KABIR SIROHI</td>
                                                    <td>EDISON</td>
                                                    <td>91.8</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>74</td>
                                                    <td>NAYANTARA YADAV</td>
                                                    <td>WINSLOW</td>
                                                    <td>89.4</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>75</td>
                                                    <td>SAI MOHIT</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>95</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>76</td>
                                                    <td>SHLOK MALIK</td>
                                                    <td>EDISON</td>
                                                    <td>91.4</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>77</td>
                                                    <td>TANSI MEHROTRA</td>
                                                    <td>WINSLOW</td>
                                                    <td>89.8</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>78</td>
                                                    <td>VIVAAN RASTOGI</td>
                                                    <td>&nbsp;</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>91.4</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>79</td>
                                                    <td>AADYA JAIN(W/D)</td>
                                                    <td>&nbsp;</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>95.8</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>80</td>
                                                    <td>AARAV GHAI(W/D)</td>
                                                    <td rowspan="24">ELBERT</td>
                                                    <td>WINSLOW</td>
                                                    <td>93.4</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>81</td>
                                                    <td>AARUSH JAIN</td>
                                                    <td>EDISON</td>
                                                    <td>96.8</td>
                                                    <td>2021-22; 2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>82</td>
                                                    <td>AARZOO KAPOOR(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>97</td>
                                                    <td>2021-22; 2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>83</td>
                                                    <td>ADITI PANT</td>
                                                    <td>DALTON</td>
                                                    <td>96.4</td>
                                                    <td>2021-22; 2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>84</td>
                                                    <td>ADITYA MARWAH</td>
                                                    <td>KEYNES</td>
                                                    <td>92.6</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>85</td>
                                                    <td>ANANYA SALUJA</td>
                                                    <td>SHAKESPEARE</td>
                                                    <td>92.8</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>86</td>
                                                    <td>ANSHUL B PATEL(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>91.4</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>87</td>
                                                    <td>AVISHI CHOUBEY</td>
                                                    <td>EDISON</td>
                                                    <td>91.4</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>88</td>
                                                    <td>DIYA BHATNAGAR</td>
                                                    <td>KEYNES</td>
                                                    <td>87.9</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>89</td>
                                                    <td>DHRUV SHARMA</td>
                                                    <td>EINSTEIN</td>
                                                    <td>92.2</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>90</td>
                                                    <td>HARSH VOHRA</td>
                                                    <td>DALTON</td>
                                                    <td>88.4</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>91</td>
                                                    <td>ISHIKA MAHAJAN</td>
                                                    <td>DALTON</td>
                                                    <td>94.8</td>
                                                    <td>2021-22; 2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>92</td>
                                                    <td>KSHITIJ VERMA(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>96.2</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>93</td>
                                                    <td>MEHR GAHARWAR</td>
                                                    <td>KEYNES</td>
                                                    <td>92.8</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>94</td>
                                                    <td>NYSA H. VAID</td>
                                                    <td>KEYNES</td>
                                                    <td>91.4</td>
                                                    <td>2021-22;2019-20, 2018-19, 2017-18</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>95</td>
                                                    <td>RAHAT KAURA</td>
                                                    <td>EDISON</td>
                                                    <td>94.6</td>
                                                    <td>2021-22; 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>96</td>
                                                    <td>SHAURYA GUPTA</td>
                                                    <td>EDISON</td>
                                                    <td>93</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>97</td>
                                                    <td>SHOURYA KAPOOR</td>
                                                    <td>KEYNES</td>
                                                    <td>92.2</td>
                                                    <td>2021-22; 2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>98</td>
                                                    <td>SHOURYA VEER(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>96.2</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>99</td>
                                                    <td>TAMANNA KAPOOR(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>97.4</td>
                                                    <td>2021-22; 2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>100</td>
                                                    <td>TISHIA KATOCH</td>
                                                    <td>KEYNES</td>
                                                    <td>91.4</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>101</td>
                                                    <td>UTKARSH CHAUHAN(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>93.4</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>102</td>
                                                    <td>VATSAL KUMAR</td>
                                                    <td>DALTON</td>
                                                    <td>93.6</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>103</td>
                                                    <td>VINAYAK MALHOTRA</td>
                                                    <td>KEYNES</td>
                                                    <td>97</td>
                                                    <td>2021-22;2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>104</td>
                                                    <td>AARAV NAVANI</td>
                                                    <td rowspan="19">FUJI</td>
                                                    <td>EDISON</td>
                                                    <td>90.2</td>
                                                    <td>2017-18; 2018-19; 2019-20;2021-22</td>
                                                    <td>BLUE&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>105</td>
                                                    <td>ANIRUDH GOVINDAN</td>
                                                    <td>EDISON</td>
                                                    <td>89.4</td>
                                                    <td>2021-22; 2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>106</td>
                                                    <td>ANOUSHKA SHARMA</td>
                                                    <td>WINSLOW</td>
                                                    <td>90.6</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>107</td>
                                                    <td>ANYA GUPTA</td>
                                                    <td>ARISTOTLE</td>
                                                    <td>90.6</td>
                                                    <td>2021-22; 2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>108</td>
                                                    <td>APURV BHUSHAN</td>
                                                    <td>EDISON</td>
                                                    <td>93.6</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>109</td>
                                                    <td>ARYAN VIR</td>
                                                    <td>EDISON</td>
                                                    <td>92.2</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>110</td>
                                                    <td>ASHMIT KHETERPAL(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>96.4</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>111</td>
                                                    <td>DHRUV KUMAR</td>
                                                    <td>DALTON</td>
                                                    <td>96.2</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>112</td>
                                                    <td>KAINA MALIK</td>
                                                    <td>SHAKESPEARE</td>
                                                    <td>94.2</td>
                                                    <td>2021-22; 2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>113</td>
                                                    <td>MRIGANKA SINGH</td>
                                                    <td>WINSLOW</td>
                                                    <td>88.8</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>114</td>
                                                    <td>NAVYA LAKHOTIA</td>
                                                    <td>EINSTEIN</td>
                                                    <td>97.6</td>
                                                    <td>2021-22; 2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>115</td>
                                                    <td>NAVYA KASERA</td>
                                                    <td>WINSLOW</td>
                                                    <td>86.2</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>116</td>
                                                    <td>PRANJAL SHARMA</td>
                                                    <td>EDISON</td>
                                                    <td>94.6</td>
                                                    <td>2017-18; 2018-19; 2019-20;2021-22</td>
                                                    <td>BLUE&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>117</td>
                                                    <td>RAIMA GUHA</td>
                                                    <td>DALTON</td>
                                                    <td>91</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>118</td>
                                                    <td>RYAN PURI</td>
                                                    <td>DALTON</td>
                                                    <td>96.4</td>
                                                    <td>2021-22;2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>119</td>
                                                    <td>SANKALP JOSHI</td>
                                                    <td>EINSTEIN</td>
                                                    <td>92</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>120</td>
                                                    <td>SHILADITYA RAY</td>
                                                    <td>DALTON</td>
                                                    <td>93.8</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>121</td>
                                                    <td>SOUMYAWARDHAN MAHESHWARI</td>
                                                    <td>EDISON</td>
                                                    <td>97.4</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>122</td>
                                                    <td>TEJAL DOSHI</td>
                                                    <td>WINSLOW</td>
                                                    <td>98.8</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>123</td>
                                                    <td>AADIT BAHL</td>
                                                    <td rowspan="22">WHITNEY</td>
                                                    <td>DALTON</td>
                                                    <td>87.6</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>124</td>
                                                    <td>ANANDINI AGRAWAL</td>
                                                    <td>KEYNES</td>
                                                    <td>96.34</td>
                                                    <td>2021-22;2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>125</td>
                                                    <td>AVIRAJ GOYLE(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>97.6</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>126</td>
                                                    <td>CHAITANYA GUPTA</td>
                                                    <td>DALTON</td>
                                                    <td>96.8</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>127</td>
                                                    <td>GAURIKA KHANNA</td>
                                                    <td>SHAKESPEARE</td>
                                                    <td>88.8</td>
                                                    <td>2021-22;2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>128</td>
                                                    <td>GAYATRI VEER</td>
                                                    <td>SHAKESPEARE</td>
                                                    <td>92.2</td>
                                                    <td>2021-22; 2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>129</td>
                                                    <td>KATYA SOOD</td>
                                                    <td>WINSLOW</td>
                                                    <td>92.4</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>130</td>
                                                    <td>KRIPA KAUR</td>
                                                    <td>WINSLOW</td>
                                                    <td>97</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>131</td>
                                                    <td>KYNA CHAUDHARY</td>
                                                    <td>EINSTEIN</td>
                                                    <td>96.4</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>132</td>
                                                    <td>LAKSHYA AGARWAL</td>
                                                    <td>EINSTEIN</td>
                                                    <td>97.6</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>133</td>
                                                    <td>MADHAV MALHAN</td>
                                                    <td>WINSLOW</td>
                                                    <td>96.2</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>134</td>
                                                    <td>NAVYA NANDINI DHODY</td>
                                                    <td>EINSTEIN</td>
                                                    <td>98</td>
                                                    <td>2022-21;2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>135</td>
                                                    <td>MANYA ARORA</td>
                                                    <td>SHAKESPEARE</td>
                                                    <td>88</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>136</td>
                                                    <td>PARTH AHUJA(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>97</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>137</td>
                                                    <td>PRACHI CHOPRA</td>
                                                    <td>EDISON</td>
                                                    <td>96.6</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>138</td>
                                                    <td>PRIYADARSHINI GHOSH(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>99</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>139</td>
                                                    <td>RAGHAV BANSAL(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>98</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>140</td>
                                                    <td>RITWIK MALHOTRA(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>87</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>141</td>
                                                    <td>SATVIK SRIVASTAVA</td>
                                                    <td>EDISON</td>
                                                    <td>90.6</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>142</td>
                                                    <td>SAUMYA BABBAR</td>
                                                    <td>SHAKESPEARE</td>
                                                    <td>95.6</td>
                                                    <td>2021-22;2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>143</td>
                                                    <td>SHIVAAN SEHGAL</td>
                                                    <td>SHAKESPEARE</td>
                                                    <td>95.6</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>144</td>
                                                    <td>YASH VERMA(W/D)</td>
                                                    <td>WITHRAWAL</td>
                                                    <td>95.8</td>
                                                    <td>2021-22;2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>37</td>
                                                    <td>30</td>
                                                    <td>89</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>93</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td colspan="7">TOTAL SCHOLARS IN GRADE X (2021-22) = 146</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th colspan="9">DETAILS FOR THE SCHOLAR CERTIFICATES (2021-22) : GRADE XI</th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAME</th>
                                                    <th rowspan="2"> GRADE -XI (2020-21)</th>
                                                    <th rowspan="2">GRADE - XII (2021-22)</th>
                                                    <th rowspan="2">%</th>
                                                    <th rowspan="2">SESSIONS</th>
                                                    <th colspan="3">SCHOLAR STATUS</th>
                                                </tr>
                                                <tr>
                                                    <th>BLAZER</th>
                                                    <th>BADGE</th>
                                                    <th>POCKET</th>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>ARYAN KAPOOR</td>
                                                    <td rowspan="6">ARISTOTLE</td>
                                                    <td rowspan="6">MARSHALL</td>
                                                    <td>90</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>HIYA JAIN</td>
                                                    <td>96.4</td>
                                                    <td>2021-22, 2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>RISHITA SINGH_LVG/1370</td>
                                                    <td>93.6</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>RISHITA SINGH_LVG/580</td>
                                                    <td>92.2</td>
                                                    <td>2021-22, 2020-21&nbsp;&nbsp;&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>SHIKHER AGRAWAL</td>
                                                    <td>87.83</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>TRISHA SAXENA</td>
                                                    <td>92</td>
                                                    <td>2021-22&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>PRISHA SOOD</td>
                                                    <td rowspan="4">KEYNES</td>
                                                    <td rowspan="4">LEONARDO</td>
                                                    <td>91.68</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>PREKSHA BOHRA</td>
                                                    <td>94.22</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>SADHIL ARORA</td>
                                                    <td>86.47</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>VEDANT AGARWAL</td>
                                                    <td>84.76</td>
                                                    <td>2021-22, 2020-21&nbsp;&nbsp;&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>ABHIGYAN SRIVASTAVA</td>
                                                    <td rowspan="6">DALTON</td>
                                                    <td rowspan="4">ARCHIMEDES</td>
                                                    <td>88.46</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>ANUSHKA RATHORE</td>
                                                    <td>93.22</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>BHAKTI BANSAL</td>
                                                    <td>88.48</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>PRATHAM LAL</td>
                                                    <td>89.56</td>
                                                    <td>2021-22,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>ROHINI VERMA</td>
                                                    <td rowspan="2">GALILEO</td>
                                                    <td>87.8</td>
                                                    <td>2022-21,2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>SMIRA CHANAN</td>
                                                    <td>86.34</td>
                                                    <td>2021-22,2020-21<br /></td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>AHAAN DAIDIPYA KANHERE</td>
                                                    <td rowspan="3">EINSTEIN</td>
                                                    <td rowspan="3">ARCHIMEDES</td>
                                                    <td>88.04</td>
                                                    <td>2021-22, 2020-21,2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>DEVASYA KANWAR</td>
                                                    <td>87.14</td>
                                                    <td>2021-22, 2020-21,2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>TVESHA SINGH</td>
                                                    <td>84.88</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>DHRUV MEHTA</td>
                                                    <td rowspan="2">EDISON</td>
                                                    <td rowspan="2">ARCHIMEDES</td>
                                                    <td>89.36</td>
                                                    <td>2021-22, 2020-21,2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>SUCHIT SRIVASTAVA</td>
                                                    <td>91.82</td>
                                                    <td>2021-22, 2020-21; 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>ADVAY AWASTHY</td>
                                                    <td rowspan="16">SHAKESPEARE</td>
                                                    <td rowspan="16">WORDSWORTH</td>
                                                    <td>94.63</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>ANANYAA PRIYA NAIR</td>
                                                    <td>84.6</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>ARSHIA KATOCH</td>
                                                    <td>83.84</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>CHERYL JOSHI</td>
                                                    <td>97.7</td>
                                                    <td>2021-22,2020-21; 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>DIYA SANDHIR</td>
                                                    <td>93.62</td>
                                                    <td>2021-22,2020-21; 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>GAURIKA SINGH</td>
                                                    <td>89.78</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>ISHITA BHUSHAN</td>
                                                    <td>86.62</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>JIA ARORA</td>
                                                    <td>91.3</td>
                                                    <td>2022-21,2020-21,2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>KIAH SINGHAL</td>
                                                    <td>85.29</td>
                                                    <td>2022-21,2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>KISHA DUA</td>
                                                    <td>88.38</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>KRISHA RASTOGI</td>
                                                    <td>90.36</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>MAHAK DUTTA</td>
                                                    <td>92.6</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>MANYA DHULL</td>
                                                    <td>92.18</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>MIHEEKA BHASIN</td>
                                                    <td>97</td>
                                                    <td>2022-21,2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Yes</td>
                                                    <td>Blue</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>PAVNI GUPTA</td>
                                                    <td>81.74</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>SUNAINA CHAUHAN DUTTA</td>
                                                    <td>88.68</td>
                                                    <td>2021-22,2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="9">TOTAL SCHOLARS IN GRADE XI(2021-22) = 35</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td align="right">13</td>
                                                    <td align="right">0</td>
                                                    <td align="right">24</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Pink Badges</td>
                                                    <td>22</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td align="right">0</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Blue Badges</td>
                                                    <td>13</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Grey Pockets</td>
                                                    <td>22</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Blue Pockets</td>
                                                    <td>13</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Super Scholars</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>COMPARATIVE ANALYSIS</td>
                                                    <td>2020-21</td>
                                                    <td>2021-22</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Total Strength</td>
                                                    <td>127</td>
                                                    <td>120</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Scholars</td>
                                                    <td>56</td>
                                                    <td>35</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>%</td>
                                                    <td>44.09%</td>
                                                    <td>29.16%</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th colspan="7">DETAILS FOR THE SCHOLAR CERTIFICATES (2021-22) : GRADE XII</th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th colspan="7">CRITERIA:&nbsp; 85% and above with no B-grades</th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAME</th>
                                                    <th rowspan="2">GRADE - XII&nbsp;(2021-22)</th>
                                                    <th rowspan="2">%</th>
                                                    <th rowspan="2">SESSIONS</th>
                                                    <th colspan="2">STATUS</th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th>CERTIFICATE</th>
                                                    <th>PLAQUE</th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>ABHAY VERMA</td>
                                                    <td rowspan="16">ARCHIMEDES</td>
                                                    <td>92.4</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>AMITESH ANAND PANDEY</td>
                                                    <td>94.6</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>ANANYA JAIN</td>
                                                    <td>97.6</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>ANINDYA MISHRA</td>
                                                    <td>90.6</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>ARCHIT CHOPRA</td>
                                                    <td>86.2</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>ARNAV GARG&nbsp;</td>
                                                    <td>90.0</td>
                                                    <td>2021-22, 2020-21, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>ARUNAKSH KAPOOR</td>
                                                    <td>96.2</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>DHANUR CHAHAL</td>
                                                    <td>90.8</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>DIYA TRIPATHI</td>
                                                    <td>87.6</td>
                                                    <td>2021-22, 2020-21, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>ESHAAN ARYAN SINHA</td>
                                                    <td>90.0</td>
                                                    <td>2021-22, 2020-21, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>INHAAS VIRMANI</td>
                                                    <td>97.8</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>ISHAAN VATUS</td>
                                                    <td>87.8</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>NIPUN YADAV</td>
                                                    <td>94.8</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>PRANAY GOEL</td>
                                                    <td>91.8</td>
                                                    <td>2021-22, 2020-21, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>RIYA RAWAL</td>
                                                    <td>89.2</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>SIDDHARTH MISHRA</td>
                                                    <td>94.6</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>ANANYA MALIK</td>
                                                    <td rowspan="20">GALILEO</td>
                                                    <td>93.0</td>
                                                    <td>2021-22, 2020-2021, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>ANJALI TYAGI</td>
                                                    <td>89.0</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>ARADHYA MISHRA</td>
                                                    <td>89.2</td>
                                                    <td>2021-22, 2020-2021, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>ASVIKA NIGAM</td>
                                                    <td>93.8</td>
                                                    <td>2021-22, 2020-21, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>AVISHI MONGA</td>
                                                    <td>96.0</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18,2016-17, 2015-16, 2014-15, 2013-14</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>DIVANSHIE SUMIT SETIA</td>
                                                    <td>93.8</td>
                                                    <td>2021-22, 2020-21, 2019-20,2018-19, 2017-18, 2016-17</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>DIVYALAKSHMI SINGH</td>
                                                    <td>86.8</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>FREYA SIDHWA</td>
                                                    <td>86.8</td>
                                                    <td>2021-22, 2020-21, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>ISHIKA ARORA</td>
                                                    <td>86.8</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>KAVYA SONDHI</td>
                                                    <td>86.8</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>KHUSHI SATNALIWALA</td>
                                                    <td>91.6</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>KHYATI PRASAD</td>
                                                    <td>89.2</td>
                                                    <td>2021-22, 2020-21, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>MANBHAV SUGLA</td>
                                                    <td>93.6</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>NISHA BARBUDDHE</td>
                                                    <td>86.6</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>PRARABDHA HALDER</td>
                                                    <td>90.4</td>
                                                    <td>2021-22, 2020-21, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>RAJ KASERA</td>
                                                    <td>86.4</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>SRISHTI MAKKAR</td>
                                                    <td>86.4</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>SUHANI VALECHA&nbsp;</td>
                                                    <td>87.0</td>
                                                    <td>2021-22, 2020-21, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>TITHI SARKAR</td>
                                                    <td>89.6</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>VIKRAMADITYA YADAV&nbsp;</td>
                                                    <td>95.0</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>AADITYA KUMAR</td>
                                                    <td rowspan="13">LEONARDO</td>
                                                    <td>88.6</td>
                                                    <td>2021-22, 2020-21, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>ADRIJA DE</td>
                                                    <td>96.2</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>ANNAHITA RATHI</td>
                                                    <td>92.4</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>DHRITI AGARWAL</td>
                                                    <td>91.8</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>DHRUV MADHOK</td>
                                                    <td>90.4</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>MANAN DUTTA</td>
                                                    <td>88.4</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>MANAS JAIN</td>
                                                    <td>90.4</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>NANDINI SINGH</td>
                                                    <td>91.4</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>SAAGARIKA GAHLOT</td>
                                                    <td>96.4</td>
                                                    <td>2021-22, 2020-2021, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>SARMATHA R</td>
                                                    <td>95.0</td>
                                                    <td>2021-22, 2020-21, 2019-20,2018-19</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>TANYA VIG</td>
                                                    <td>92.0</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>TIYA GUPTA</td>
                                                    <td>89.8</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>YASHITA AGARWAL</td>
                                                    <td>96.8</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>ADITYA VERMA</td>
                                                    <td rowspan="15">MARSHALL</td>
                                                    <td>86.6</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>ANIRUDH RATHOD</td>
                                                    <td>92.8</td>
                                                    <td>&nbsp;2021-22, 2020-21, 2019-20, 2018-19</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>GAYATRI VARMA</td>
                                                    <td>94.0</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>HRIDAY GULATI</td>
                                                    <td>88.0</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>JALAJ YADAV</td>
                                                    <td>95.0</td>
                                                    <td>2021-22, 2020-2021, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>LORD LUGANI</td>
                                                    <td>94.8</td>
                                                    <td>2021-22, 2020-2021, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>LOVISH CHOUDHARY<br /></td>
                                                    <td>95.2</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>PANSHUL JETWANI</td>
                                                    <td>93.4</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>PRATYUSH PURWAR</td>
                                                    <td>95.2</td>
                                                    <td>2021-22, 2020-2021, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>PRERNA SEJWAL</td>
                                                    <td>90.0</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>60</td>
                                                    <td>RISHAB JAIN</td>
                                                    <td>92.4</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>61</td>
                                                    <td>ROLI AGGARWAL<br /></td>
                                                    <td>97.4</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>62</td>
                                                    <td width="205">SARAH MAHESHWARI</td>
                                                    <td>89.8</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>63</td>
                                                    <td>SARISHA JAGGI</td>
                                                    <td>93.0</td>
                                                    <td>2021-22, 2020-2021, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>64</td>
                                                    <td>STUTI SINGHAL</td>
                                                    <td>86.0</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>65</td>
                                                    <td>AARUSHI DHAWAN</td>
                                                    <td rowspan="17">WORDSWORTH</td>
                                                    <td>88.6</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>66</td>
                                                    <td>AKSHITA SHARMA</td>
                                                    <td>95.6</td>
                                                    <td>2021-22, 2020-21,2019-20&nbsp;</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>67</td>
                                                    <td>ANUSHKA BANSAL</td>
                                                    <td>87.6</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>68</td>
                                                    <td>ARUSHI BANERJEE</td>
                                                    <td>94.4</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>69</td>
                                                    <td>DISHA VASHISTHA</td>
                                                    <td>93.2</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>70</td>
                                                    <td>KHUSHI SOOD</td>
                                                    <td>87.4</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>71</td>
                                                    <td>MAANYAA GUPTA</td>
                                                    <td>95.8</td>
                                                    <td>2021-22, 2020-21</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>72</td>
                                                    <td>MEGHA BISHT</td>
                                                    <td>89.4</td>
                                                    <td>2021-22, 2020-21, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>73</td>
                                                    <td>MEHAK CHAWLA</td>
                                                    <td>94.2</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>74</td>
                                                    <td>MEHMA SINGH AHLUWALIA</td>
                                                    <td>92.8</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>75</td>
                                                    <td>PARTH PIYUSH PRASAD</td>
                                                    <td>95.2</td>
                                                    <td>2021-22, 2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>YES</td>
                                                    <td>YES</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>76</td>
                                                    <td>RASHI CHAUHAN</td>
                                                    <td>95.4</td>
                                                    <td>2021-22, 2020-21, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>77</td>
                                                    <td>RIYA KUMAR</td>
                                                    <td>90.4</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>78</td>
                                                    <td>ROHAN MENDIRATTA<br /></td>
                                                    <td>86.2</td>
                                                    <td>2021-22</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>79</td>
                                                    <td>SAMYAK YASH JAIN</td>
                                                    <td>89.2</td>
                                                    <td>2021-22, 2020-21, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>80</td>
                                                    <td>SHIVIKA PANDEY</td>
                                                    <td>97.4</td>
                                                    <td>2021-22, 2020-21, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>81</td>
                                                    <td>TANVI CHAND</td>
                                                    <td>92.4</td>
                                                    <td>2021-22, 2020-21, 2019-20</td>
                                                    <td>YES</td>
                                                    <td>NO</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="7">TOTAL STRENGTH OF GRADE XII IN 2021-22 = 128</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="7">NO. OF SCHOLARS (2021-22) SECURING 85% AND ABOVE = 81</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="7">SCHOLARS FOR FOUR CONSECUTIVE YEARS (ELIGIBLE FOR PLAQUE) = 26</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody></table>
                                    </div>


                                </div>
                            )
                            }
                            {filterData === "2" && (
                                <div class="">
                                    <div class="heading2 text-center">
                                        <h4>Scholar Badge Holders 2021-22</h4>
                                    </div>
                                    <div class="table">
                                        <table className='table-view' border="1" width="100%">
                                            <tbody><tr>
                                                <th colspan="8">DETAILS FOR THE SCHOLAR CERTIFICATES : GRADE V (2020-21)</th>
                                            </tr>
                                                <tr>
                                                    <th colspan="8">Aggregate 90% &amp; Above</th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAMES</th>
                                                    <th rowspan="2">GRADE -V&nbsp; (2020-21)</th>
                                                    <th rowspan="2">GRADE - VI (2021-22)</th>
                                                    <th rowspan="2">SESSIONS</th>
                                                    <th colspan="2">SCHOLAR STATUS</th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <td>BADGE</td>
                                                    <td>POCKET</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AAHANA GUPTA</td>
                                                    <td rowspan="17">BIRCHES</td>
                                                    <td rowspan="17">BEAS</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>AARNAV KOSHAL</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>AASHVI THAKUR</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>ABHINAV MAKKAR</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>AKSHAR MATTA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>AKSHITA ROY CHOWDHURY</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>DEVYANSH MALIK</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>GARVITA JAIN</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>GIA VERMA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>HARSHIKA JOSHI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>KABIR GUPTA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>MEHAK JINDAL</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>PRISHA VERMA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>SONAL MITTAL</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>VEDANT MAHESHWARI</td>
                                                    <td>2020-21</td>
                                                    <td colspan="2">NOT VALID</td>
                                                    <td>B1 IN MATHEMATICS</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>VEDANT RATHI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>VIRAJH AGARWAL</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>AARAV GUPTA</td>
                                                    <td rowspan="18">BURANS</td>
                                                    <td rowspan="18">BRAHMAPUTRA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>AARNA BHUSHAN</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>AKSHAYNI MATHUR</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>AMOGH DOSHI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>ANAHAT KAUR</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>ANANYA KAPOOR</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>ATHARV MALHOTRA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>AVNI JAIN</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>GURSIMRAT SINGH</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>PRISHA KUMAR</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>RAJVEER SINGH RAJPUROHIT</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>SAANVI BHAYANA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>SANA BUGALIA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>SARANYA SINGHAL</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>SUHANA SINDHWANI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>VIVAAN AGRAWAL</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>VIVAAN BANKA</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>YASHITA MAHESHWARI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>AARUSH DEWAN</td>
                                                    <td rowspan="11">CEDARS</td>
                                                    <td rowspan="11">GANGES</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>ADVIK MALIK</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>ADVIKA BANERJEE</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>ANUSHKA CHOUBEY</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>HARSHITA BHALLA</td>
                                                    <td>2020-21</td>
                                                    <td colspan="2">NOT VALID</td>
                                                    <td>B1 IN MATHEMATICS</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>HIBAH IMTIAZ CHAGLANI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>PRIYAL SIROHI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>SHREYA MAMTANI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>SHRISHTI BANSAL</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>TVISHA GUPTA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>VANSHIKA MODI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>AARAV JAGLAN</td>
                                                    <td rowspan="18">MAPLES</td>
                                                    <td rowspan="18">GODAVARI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>AARAV MODI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>ADITYA ASHISH MAHANTA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>AMANAT GIRDHAR</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>ANAY GARG</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>CHAITANYAA KANODIA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>ISHAAN SONI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>KAVNEER KAUR THUKRAL</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>KUSHAL KASHYAP</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>MAHIT SHARMA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>MMANAT BAGHLA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>NAAVYA BHATIA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>NAISHA KHURANA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>60</td>
                                                    <td>PRIYANSH CHATTERJEE</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>61</td>
                                                    <td>RUHAAN GUPTA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>62</td>
                                                    <td>SUHANA PALHAN</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>63</td>
                                                    <td>UDAANT TYAGI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>64</td>
                                                    <td>YASHRAJ KAPOOR</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>65</td>
                                                    <td>AARYAV MAKHIJA</td>
                                                    <td rowspan="15">NEEMS</td>
                                                    <td rowspan="15">KAVERI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>66</td>
                                                    <td>AHAAN GUPTA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>67</td>
                                                    <td>AKARSHIKA DHINGRA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>68</td>
                                                    <td>ANYA MUNDRA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>69</td>
                                                    <td>ARNAV VIJ</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>70</td>
                                                    <td>ARYAMAN GULATI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>71</td>
                                                    <td>ARYAVEER KAPOOR</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>72</td>
                                                    <td>AVIRAJ S. CHEEMA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>73</td>
                                                    <td>AYAAN JAIN</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>74</td>
                                                    <td>DHWANI MADAN (TC)</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>75</td>
                                                    <td>NAISHA JAIN (TC)</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>76</td>
                                                    <td>REYANSH AGGRAWAL (TC)</td>
                                                    <td>2020-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>77</td>
                                                    <td>RIDDHI GUPTA (TC)</td>
                                                    <td>2020-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>78</td>
                                                    <td>PRANEY GUGLANI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>79</td>
                                                    <td>UDYAT AHUJA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>80</td>
                                                    <td>AADYA PROOTHI</td>
                                                    <td rowspan="18">OAKS</td>
                                                    <td rowspan="18">NARMADA</td>
                                                    <td>2020-20</td>
                                                    <td colspan="2">NOT VALID</td>
                                                    <td>B1 IN ENGLISH</td>
                                                </tr>
                                                <tr>
                                                    <td>81</td>
                                                    <td>AARAV DURANI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>82</td>
                                                    <td>ANJINI KUMAR</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>83</td>
                                                    <td>ARJUN WALIA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>84</td>
                                                    <td>AVIK MALHOTRA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>85</td>
                                                    <td>JASRAAJ SINGH CHEEMA</td>
                                                    <td>2020-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>86</td>
                                                    <td>KAAVYA JOSHI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>87</td>
                                                    <td>KYAN MAHAJAN</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>88</td>
                                                    <td>NEEL DHODY</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>89</td>
                                                    <td>PRISHA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>90</td>
                                                    <td>RIAAN GARG</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>91</td>
                                                    <td>SAANVI SINGH 2</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>92</td>
                                                    <td>SAMARTH MATHUR</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>93</td>
                                                    <td>SHAURYA VASUDEVAN</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>94</td>
                                                    <td>SRISHTI GAUR</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>95</td>
                                                    <td>VEDAANSH KHANEJA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>96</td>
                                                    <td>VIR NIJHAWAN</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>97</td>
                                                    <td>YUVAKSHI CHOPRA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>98</td>
                                                    <td>AARSH SINGH GILL</td>
                                                    <td rowspan="15">OLIVES</td>
                                                    <td rowspan="15">SUTLEJ</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>99</td>
                                                    <td>AASHVI AGRAWAL</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>100</td>
                                                    <td>ADAM SALROO</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>101</td>
                                                    <td>AMAIRA VOHRA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>102</td>
                                                    <td>ARJUN KHETERPAL</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>103</td>
                                                    <td>ARNAV KUMAR</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>104</td>
                                                    <td>AVANTIKA PANDE</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>105</td>
                                                    <td>AVNI PANDEY</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>106</td>
                                                    <td>SHANAYA SURI</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>107</td>
                                                    <td>SHAURAY VALECHA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>108</td>
                                                    <td>SUHAS BIKKINA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>109</td>
                                                    <td>VAIGA P. NAIR</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>110</td>
                                                    <td>VEDANT GROVER</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>111</td>
                                                    <td>VEDIKA KAPOOR</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>112</td>
                                                    <td>VIVAAN CHOPRA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="7">TOTAL SCHOLARS IN GRADE V (2020-21) =&nbsp; 112&nbsp; - 4 (WITHDRAWL) = 108</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Pink Badges</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Grey Pockets</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>COMPARATIVE ANALYSIS</td>
                                                    <td>2019-20</td>
                                                    <td>2021-22</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Total Strength</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Scholars</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>%</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody></table>
                                        <table cellspacing="0" cellpadding="0">
                                            <tbody><tr>
                                                <th colspan="6">DETAILS FOR THE SCHOLAR CERTIFICATES : GRADE VI (2020-21)&nbsp;&nbsp;&nbsp;&nbsp;</th>
                                            </tr>
                                                <tr>
                                                    <th colspan="6">Aggregate 90% and Above</th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAMES</th>
                                                    <th rowspan="2">GRADE -VI  (2020-21)</th>
                                                    <th rowspan="2">GRADE - VII &nbsp;&nbsp;&nbsp;&nbsp; (2021-22)</th>
                                                    <th rowspan="2">SESSIONS</th>
                                                    <th rowspan="2">REMARK</th>
                                                </tr>
                                                <tr> </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AARAV MALIK</td>
                                                    <td rowspan="16">BEAS</td>
                                                    <td rowspan="16">CHENAB</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>ABHYUDITA VERMA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>ARSHIYA SINGH</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>AVICHAL GUPTA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>AVIRAJ AGARWAL</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>FIONA GUPTA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>GARVIT SINGHAL</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>IRSA SHARMA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>ISHAAN DAS</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>NAVBIR SINGH GUJRAL</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>REESHA SUHAG</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>SAMAIRA WADHWA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>SANVI NANDA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>KHUSHIKA PAHWA</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>SAMAERA CHAWLA</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>SHIVENN GUPTA</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>AARAV GUPTA&nbsp;</td>
                                                    <td rowspan="15">GANGES</td>
                                                    <td rowspan="15">DAMODAR</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>ALAINA BHATIA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>AYATI JAIN&nbsp;</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>GURSAANA DANG</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>HARSHIL SHARMA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>ISHAAN TAPARIA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>JASMEH KAUR SODHI</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>KAYAAN JAI PRAKASH</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>NAISHA INGOLE</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>SARTHAK CHATURVEDI</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>UNNATI SAXENA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>AADHAR MITTAL</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>ANIRUDH SHARMA</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>NANDINI SHARMA</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>NEHAL SOTHWAL</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>AADYA SHARMA</td>
                                                    <td rowspan="14">GODAVARI</td>
                                                    <td rowspan="14">INDUS</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>ALIA RATHI</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>ANAHITA PANT</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>ANAHITA SINGHAL</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>ANAYA JAIN</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>AVIK BANERJEE</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>KRISHANG GROVER</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>NASHA SAWHNEY</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>SHAURYA ARORA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>SIYONA BAKSHI</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>AARAV JAIN</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>MANAN VERMA</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>SAINA CHOPRA</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>SWARIT NARULA</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>AADYA CHOPRA</td>
                                                    <td rowspan="12">KAVERI</td>
                                                    <td rowspan="12">JHELUM</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>AARYA MEHROTRA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>ANANYA LAKARA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>KSHIRJA VERMA</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>OJAS MANGLANI</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>OUCHITYA KHURANA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>SHYLA TYAGI</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>UTKARSHIKA RAJPUT</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>VIVAAN KAMBOJ</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>VIHAAN N. BANSAL</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>ADITYA SRIVASTAVA</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>SHAUNAK RAJPAL</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>ARMAAN ANAND</td>
                                                    <td rowspan="16">NARMADA</td>
                                                    <td rowspan="16">MAHANADI</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>ARYAN GUPTA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>MAYAN BHASKAR&nbsp;</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>MIHIKA SHARMA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>PRAKHAR BUKALSARIA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>SHIVANGHI TALWAR</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>SIDDHARTH DHAWAN</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>SIDHANSH GARG</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>SOHANA SINGH</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>VIHAAN AGARWAL</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>VRINDA MITTAL</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>DHRUV MOZA</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>HITAGYA JAIN</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>KARTIK SUGLA</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>RASHESH AGGARWAL</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>TVISHA CHAWLA</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>ADVIKA MISHRA</td>
                                                    <td rowspan="13">&nbsp;</td>
                                                    <td rowspan="13">&nbsp;</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>LAVANYA BAJAJ</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>PRISHA MISHRA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>PRISHA SATIJA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>60</td>
                                                    <td>RHEA GOVIL</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>61</td>
                                                    <td>SEDHAARTH SUDHIR NAIR</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>62</td>
                                                    <td>SHREYANSH KANOTRA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>63</td>
                                                    <td>TANYA DAS</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>64</td>
                                                    <td>TISNOOR KAUR GULIANI</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>65</td>
                                                    <td>VANIA RAY</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>66</td>
                                                    <td>VASUDHA SINGHAL</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>AARIN SHARMA</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>AVANTIKA JAISWAL</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>67</td>
                                                    <td>AARNA GUPTA</td>
                                                    <td rowspan="19">SUTLEJ</td>
                                                    <td rowspan="19">TAPTI</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>68</td>
                                                    <td>ARNAV GOYAL&nbsp;</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>69</td>
                                                    <td>ARNAV NAGPAL</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>70</td>
                                                    <td>ARSHIA AHUJA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>71</td>
                                                    <td>ASMI GUPTA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>72</td>
                                                    <td>CHARVi YAADAV</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>73</td>
                                                    <td>DISHA AGARWAL</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>74</td>
                                                    <td>IVANYA DAYAL</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>75</td>
                                                    <td>MYRA SHARMA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>76</td>
                                                    <td>RAGHAV VERMA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>77</td>
                                                    <td>RASHI VANIDANI</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>78</td>
                                                    <td>RUHAAN AGGARWAL</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>79</td>
                                                    <td>SAESHHA ADHANA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>80</td>
                                                    <td>SARTHAK GUPTA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>81</td>
                                                    <td>VIDISHA SRIVASTAVA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>AARAV THARWANI</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>DIVYANSH KAPOOR</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>HIYA GOSWAMI</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>KALPANA YADAV</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>82</td>
                                                    <td>AAHANA JAIN</td>
                                                    <td rowspan="19">THAMES</td>
                                                    <td rowspan="19">YAMUNA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>83</td>
                                                    <td>ADITI SEHGAL</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>84</td>
                                                    <td>AKANKSHA BANSAL</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>85</td>
                                                    <td>ANYA AGGARWAL</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>86</td>
                                                    <td>ARIKA SAHAI</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>87</td>
                                                    <td>ARNAV JAIN</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>88</td>
                                                    <td>AVANYA KHANNA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>89</td>
                                                    <td>AVISHA GARG</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>90</td>
                                                    <td>BHUVI SHARMA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>91</td>
                                                    <td>ISHIT RASTOGI</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>92</td>
                                                    <td>JAI DUGAL</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>93</td>
                                                    <td>NAISHA KHANNA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>94</td>
                                                    <td>NIMAN GUJRAL</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>95</td>
                                                    <td>SAARANYA SINHA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>96</td>
                                                    <td>TANISHA GUPTA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>97</td>
                                                    <td>VRINDA KHANNA</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>ARYAVEER SINGH</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>PRIYASHA BAJAJ</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>~</td>
                                                    <td>VIBHU NARAYAN BANSAL</td>
                                                    <td>2019-20</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="6">TOTAL SCHOLARS IN GRADE VI (2020-21) =&nbsp; 97&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>COMPARATIVE ANALYSIS</td>
                                                    <td>2019-20</td>
                                                    <td>2021-22</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Total Strength</td>
                                                    <td>231</td>
                                                    <td align="right">219</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Scholars</td>
                                                    <td>94</td>
                                                    <td align="right">97</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>%</td>
                                                    <td align="right">40.70%</td>
                                                    <td align="right">44.29%</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                            </tbody></table>
                                        <table cellspacing="0" cellpadding="0">
                                            <tbody><tr>
                                                <th colspan="8">DETAILS FOR THE SCHOLAR CERTIFICATES : GRADE VII (2020-21)&nbsp;&nbsp;&nbsp;&nbsp;</th>
                                            </tr>
                                                <tr>
                                                    <th colspan="8">Aggregate 90% and Above</th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAMES</th>
                                                    <th rowspan="2">GRADE - VII &nbsp;&nbsp;&nbsp;&nbsp; (2020-21)</th>
                                                    <th rowspan="2">GRADE - VIII &nbsp;&nbsp;&nbsp;&nbsp; (2021-22)</th>
                                                    <th rowspan="2">PERCENTAGE</th>
                                                    <th rowspan="2">REMARKS</th>
                                                    <th rowspan="2">SESSIONS</th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AADHYA GUPTA</td>
                                                    <td rowspan="12">CHENAB</td>
                                                    <td rowspan="12">AMAZON</td>
                                                    <td>96.4</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>SPANDANA SANJOY BARUA</td>
                                                    <td>94</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>SAANVI RANJAN</td>
                                                    <td>90.8</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>PRAGYA YADAV</td>
                                                    <td>92.4</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>PARTHAV SARIN</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>ANYA SAXENA</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>AFRAAZ ALAM</td>
                                                    <td>91.8</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>ADITYA KUMAR</td>
                                                    <td>96.6</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>RISHIT GOYAL</td>
                                                    <td>94.2</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>ARJUN MANN</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>ANANYA GOEL</td>
                                                    <td>94.6</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>VRISHANK KUTHIALA</td>
                                                    <td>90</td>
                                                    <td>FRENCH B2</td>
                                                    <td>2020-21</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>AGAM BHANSWAL</td>
                                                    <td rowspan="13">COL</td>
                                                    <td rowspan="13">COL</td>
                                                    <td>93.6</td>
                                                    <td>FRENCH B1</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>ARNAV ARORA</td>
                                                    <td>90</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>AVNI SINGH</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>AYUSHI MOOLCHANDANI</td>
                                                    <td>91.4</td>
                                                    <td>MATH B1</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>GRISHA MAULIN GANDHI</td>
                                                    <td>90</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>LAVANYA TIWARI</td>
                                                    <td>WITHDRAWN</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>NAVYA GARG</td>
                                                    <td>95.6</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>RYAN GUPTA</td>
                                                    <td>95.2</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>SABHYA AGGARWAL</td>
                                                    <td>98</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>SIMAR KAUR</td>
                                                    <td>91.6</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>SAKSHAM ARORA</td>
                                                    <td>91.6</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>SMAHI VIJAY</td>
                                                    <td>94.2</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>RISHA AGARWAL</td>
                                                    <td>88.8</td>
                                                    <td>THROUGHOUT A1,A2</td>
                                                    <td>2020-21</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>AAIRIYA JAIN</td>
                                                    <td rowspan="17">DAMODAR</td>
                                                    <td rowspan="17">CONGO</td>
                                                    <td>95</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19,2020-21</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>ABHIMANYU BHARDWAJ</td>
                                                    <td>95.2</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19,2020-21</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>INSHA MIRZA (TC)</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>NAVYA DALAL</td>
                                                    <td>WITHDRAWN</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>NAMAN GUPTA</td>
                                                    <td>WITHDRAWN</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>NISHKA SAXENA</td>
                                                    <td>91.6</td>
                                                    <td>MATH B1</td>
                                                    <td>2019-20,2020-21</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>RUDRANSH SINGH</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>SARTHAK JAIN</td>
                                                    <td>94.2</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>SHAURYA SEHRA</td>
                                                    <td>91.8</td>
                                                    <td>SPANISH B1</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>SHRADHA MIGLANI</td>
                                                    <td>93.4</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>TANVI WASON</td>
                                                    <td>98.8</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>ANVI JAIN</td>
                                                    <td>93.2</td>
                                                    <td>SPANISH B2</td>
                                                    <td>2020-21</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>DHRUV SRIVASTAVA</td>
                                                    <td>89.4</td>
                                                    <td>SPANISH C1</td>
                                                    <td>2020-21</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>DISHIETA HOTA</td>
                                                    <td>92.8</td>
                                                    <td>SPANISH B2</td>
                                                    <td>2020-21</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>MANVIT BANDHU</td>
                                                    <td>92.4</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>JITESH BAJAJ</td>
                                                    <td>96.8</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>DITI BHATIA</td>
                                                    <td>90</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>ANNANYA BAJAJ</td>
                                                    <td rowspan="13">INDUS</td>
                                                    <td rowspan="13">DANUBE</td>
                                                    <td>93.5</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>HANEEKA MODI</td>
                                                    <td>97.8</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>HARLEEN KAUR</td>
                                                    <td>98.6</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>HARSHIL GUPTA</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>JAY SINGH</td>
                                                    <td>92</td>
                                                    <td>ML CASE</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>????</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>JESSICA SINGH</td>
                                                    <td>89.8</td>
                                                    <td>THROUGHOUT A1 AND A2</td>
                                                    <td>2020-21,2019-20,2020-21</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>SHIVANK NOHWAL</td>
                                                    <td>93.2</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>SHOBIT GALHOTRA</td>
                                                    <td>96.6</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>VANIA JALAN</td>
                                                    <td>95</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>VIVAAN BANERJEE</td>
                                                    <td>96</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>SIDH KHATTER</td>
                                                    <td>91.8</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>SHUBHAM BHASIN</td>
                                                    <td>90.4</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>SAANVI GUPTA</td>
                                                    <td>89.2</td>
                                                    <td>THROUGHOUT A1 AND A2</td>
                                                    <td>2020-21</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>AANYA MITTAL</td>
                                                    <td rowspan="13">RAVI</td>
                                                    <td rowspan="13">MISSISSIPPI</td>
                                                    <td>95</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>AARNA SHARMA</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>ANGEL GOMES</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>ANIRUDDHA BHATTACHARYA</td>
                                                    <td>94.75</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>60</td>
                                                    <td>NANDINI GUPTA</td>
                                                    <td>94.75</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>61</td>
                                                    <td>NAVNOOR KAUR</td>
                                                    <td>98</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>62</td>
                                                    <td>PRAGNAY SHARMA</td>
                                                    <td>95.5</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>63</td>
                                                    <td>PRATEEK SINHA</td>
                                                    <td>93</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>64</td>
                                                    <td>RIDDHI MANOCHA</td>
                                                    <td>97.75</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>65</td>
                                                    <td>VIDHI VASHISTH</td>
                                                    <td>98.5</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>66</td>
                                                    <td>AARAV GUPTA</td>
                                                    <td>89.75</td>
                                                    <td>A1 IN SCHOLASTIC</td>
                                                    <td>&nbsp;</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>67</td>
                                                    <td>ARYAN SABHARWAL</td>
                                                    <td>92</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>68</td>
                                                    <td>RITHIKA TALLURI</td>
                                                    <td>91.25</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>69</td>
                                                    <td>ADVIK MEHTA</td>
                                                    <td rowspan="15">RHINE</td>
                                                    <td rowspan="15">NILE</td>
                                                    <td>97.6</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>70</td>
                                                    <td>ADVIKA JAIN</td>
                                                    <td>95.4</td>
                                                    <td>SPANISH B1</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>71</td>
                                                    <td>ADWAY GUPTA</td>
                                                    <td>89.6</td>
                                                    <td>SPANISH C1</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>72</td>
                                                    <td>ANAV SHAH</td>
                                                    <td>96.4</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>73</td>
                                                    <td>ARJUN MITTAL</td>
                                                    <td>95</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>74</td>
                                                    <td>ATHARV KUMAR</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>75</td>
                                                    <td>DISHA BUDHIRAJA</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>76</td>
                                                    <td>KYESHA DEORANI</td>
                                                    <td>89.6</td>
                                                    <td>MATH B1 SPANISH B1</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>77</td>
                                                    <td>PALAK BHANDARI</td>
                                                    <td>96</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>78</td>
                                                    <td>PRATIVINDHYA SINGH</td>
                                                    <td>91.2</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>79</td>
                                                    <td>TVESHA YADAV</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>80</td>
                                                    <td>VADANYA CHATURVEDI</td>
                                                    <td>92.8</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>81</td>
                                                    <td>VIHAAN ARORA</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>82</td>
                                                    <td>KARTIK TANDON</td>
                                                    <td>93.2</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>83</td>
                                                    <td>ARYAV MATHUR</td>
                                                    <td>87.8</td>
                                                    <td>SPANISH C1</td>
                                                    <td>2020-21</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>84</td>
                                                    <td>STAVYA KHURANA</td>
                                                    <td rowspan="15">VOLGA</td>
                                                    <td rowspan="15">RHINE</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>85</td>
                                                    <td>AARAV ANAND</td>
                                                    <td>91.6</td>
                                                    <td>SPANISH B2</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>86</td>
                                                    <td>AARAV SINHA</td>
                                                    <td>96.4</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>87</td>
                                                    <td>AGASTYA TRIKHA</td>
                                                    <td>97.6</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>88</td>
                                                    <td>ARCHIT SAHNI</td>
                                                    <td>89</td>
                                                    <td>MATH AND SPANISH B1</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>89</td>
                                                    <td>DIVA JOHN</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>90</td>
                                                    <td>KHUSHI JOSHI</td>
                                                    <td>98.8</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>91</td>
                                                    <td>KRISHIV KHANNA</td>
                                                    <td>90.2</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20,2020-21</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>92</td>
                                                    <td>MEHER SETIA</td>
                                                    <td>92.8</td>
                                                    <td>SPANISH B2</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>93</td>
                                                    <td>REYNA UPADHYAY</td>
                                                    <td>98</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>94</td>
                                                    <td>SURYA KHURANA</td>
                                                    <td>93.8</td>
                                                    <td>SPANISH B1</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>95</td>
                                                    <td>SVASTI BORA</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>96</td>
                                                    <td>TASHVI VIRMANI</td>
                                                    <td>96.4</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>97</td>
                                                    <td>TOSHANI GAUR</td>
                                                    <td>90.6</td>
                                                    <td>MATH AND SPANISH B1</td>
                                                    <td>2019-20,2020-21</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>98</td>
                                                    <td>EKLAVYA MUKHERJI</td>
                                                    <td>94.4</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>99</td>
                                                    <td>AADYA SAXENA</td>
                                                    <td rowspan="16">YAMUNA</td>
                                                    <td rowspan="16">VOLGA</td>
                                                    <td>89.75</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>100</td>
                                                    <td>AAHNA GULATI</td>
                                                    <td>96</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>101</td>
                                                    <td>AANYA SAHANI</td>
                                                    <td>98.75</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>102</td>
                                                    <td>ADITI KUMAR</td>
                                                    <td>96.5</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20,2020-21</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>103</td>
                                                    <td>AHAAN PORWAL</td>
                                                    <td>94</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>104</td>
                                                    <td>ARHAN ATTRI</td>
                                                    <td>95.5</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>105</td>
                                                    <td>ARYAN GULATI</td>
                                                    <td>96</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>106</td>
                                                    <td>ASHMI MONGA</td>
                                                    <td>93</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>107</td>
                                                    <td>ATHARV V GUPTA</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>108</td>
                                                    <td>DIYA GERA</td>
                                                    <td>91</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019 -20,,2020-21</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>109</td>
                                                    <td>KASHIKA GUPTA</td>
                                                    <td>96.5</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>110</td>
                                                    <td>SAARVIN SINGHAL</td>
                                                    <td>89.75</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>111</td>
                                                    <td>SARANYA JAGGI</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>112</td>
                                                    <td>SHARANYA SINGH</td>
                                                    <td>91.25</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>113</td>
                                                    <td>SRISHTI BAKLIWAL</td>
                                                    <td>92.25</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>114</td>
                                                    <td>TAASHVI KAPOOR</td>
                                                    <td>NA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="7">TOTAL SCHOLARS IN GRADE VII (2020-21) =&nbsp; 114&nbsp; , Withdrawal = 3</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>COMPARATIVE ANALYSIS</td>
                                                    <td>2019-20</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>Total Strength</td>
                                                    <td>&nbsp;</td>
                                                    <td align="right">230</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>Scholars</td>
                                                    <td>&nbsp;</td>
                                                    <td align="right">93</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>%</td>
                                                    <td>&nbsp;</td>
                                                    <td align="right">40.40%</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody></table>
                                        <table cellspacing="0" cellpadding="0">
                                            <tbody><tr>
                                                <th colspan="8">DETAILS FOR THE SCHOLAR CERTIFICATES : GRADE VIII (2021-22)</th>
                                            </tr>
                                                <tr>
                                                    <th colspan="7">Aggregate 90%</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAMES</th>
                                                    <th rowspan="2">GRADE - VIII  (2020-21)</th>
                                                    <th>&nbsp;</th>
                                                    <th rowspan="2">SESSIONS</th>
                                                    <th colspan="2">SCHOLAR STATUS</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                                <tr>
                                                    <td>GRADE IX SECTIONS&nbsp; 2021-22</td>
                                                    <td>BADGE</td>
                                                    <td>POCKET</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>ADITYA PRAKASH</td>
                                                    <td rowspan="16">AMAZON</td>
                                                    <td>IX ARAVALLIS</td>
                                                    <td>2019-20,2018-19, 2017-18</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>ARNAV GUPTA</td>
                                                    <td>IX ARAVALLIS</td>
                                                    <td>2019-20,2018-19, 2017-19</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>CHIRAG MAYOR</td>
                                                    <td>IX ARAVALLIS</td>
                                                    <td>2020_21, 2020_21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>DEVANSH SHARMA</td>
                                                    <td>IX ARAVALLIS</td>
                                                    <td>&nbsp;2020-21, 2019-20,2018-19, 2017-20</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>DHRUV NAGWANI</td>
                                                    <td>IX ARAVALLIS</td>
                                                    <td>2020_21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>KRISHYANGI DIXIT</td>
                                                    <td>IX ARAVALLIS</td>
                                                    <td>2020_21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>MANASVI AGARWAL</td>
                                                    <td>IXNILGIRIS&nbsp;</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>MRRIDUL SESHADRI</td>
                                                    <td>IX ARAVALLIS</td>
                                                    <td>2020-21,2019-20,2018-19, 2017-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>PAARTH GUPTA</td>
                                                    <td>IX ARAVALLIS</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>PARIDHI GARG</td>
                                                    <td>IX ARAVALLIS</td>
                                                    <td>2020-21, 2019-20, 2018-19</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>PRATHAM SETHI</td>
                                                    <td>IX ARAVALLIS</td>
                                                    <td>,2019-20, 2018-19, 2017-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>VANSH SRIVASTAVA</td>
                                                    <td>IX ARAVALLIS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>VIDITA SINGH ATRI</td>
                                                    <td>IX ARAVALLIS</td>
                                                    <td>2020-21,2019-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>TUHINA TULI</td>
                                                    <td>IXNILGIRIS&nbsp;</td>
                                                    <td>87.8</td>
                                                    <td>Has B1 in Math</td>
                                                    <td>&nbsp;</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>DHRITI SHARMA</td>
                                                    <td>IXNILGIRIS&nbsp;</td>
                                                    <td>86.6</td>
                                                    <td>Has B1 in Math</td>
                                                    <td>&nbsp;</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>ATHARV TIWARI</td>
                                                    <td>IXNILGIRIS&nbsp;</td>
                                                    <td>86.6</td>
                                                    <td>Has B1 in S.SC</td>
                                                    <td>&nbsp;</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AAIRA KATOCH</td>
                                                    <td rowspan="8">BRAHMAPUTRA</td>
                                                    <td>IX EVEREST</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>BHAVYA GUPTA</td>
                                                    <td>IX EVEREST</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>DHRUV RASTOGI</td>
                                                    <td>IX EVEREST</td>
                                                    <td>2019-20</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>KESHAVA P PRASAD</td>
                                                    <td>IXNILGIRIS&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>MAANYA RAJPUT</td>
                                                    <td>IX EVEREST</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-19</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>MAHUA JAIN</td>
                                                    <td>&nbsp;</td>
                                                    <td>2019-20, 2018-19, 2017-20</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>MEGHA ANAND</td>
                                                    <td>IXNILGIRIS&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>NISHKA CHOPRA</td>
                                                    <td>IX EVEREST</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>ARNAV SHARMA</td>
                                                    <td rowspan="8">DANUBE</td>
                                                    <td>IX HIMALAYAS</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>ARYAN GUPTA</td>
                                                    <td>IX HIMALAYAS</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>NANDINI KHARBANDA&nbsp;</td>
                                                    <td>IX HIMALAYAS</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>PRANYA ARORA</td>
                                                    <td>IX HIMALAYAS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>SAYESHA JAIN</td>
                                                    <td>IX HIMALAYAS</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>SHAURYA BANSAL</td>
                                                    <td>IX HIMALAYAS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>SHREYA SETHI</td>
                                                    <td>IX SHIVALIKS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>TANUSHREE</td>
                                                    <td>IX SHIVALIKS</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AISHIKA CHADHA</td>
                                                    <td rowspan="6">JHELUM</td>
                                                    <td>IX VINDHYAS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>AYUSH KHANDELWAL</td>
                                                    <td>IX VINDHYAS</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>DHRUVIKAA D REDDY</td>
                                                    <td>IX VINDHYAS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>GAURI AGARWAL</td>
                                                    <td>IX ARAVALLIS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>KANIKA DEV</td>
                                                    <td>IX VINDHYAS</td>
                                                    <td>2020-21,2019-20</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>SHREYANS BHARGAVA</td>
                                                    <td>IX VINDHYAS</td>
                                                    <td>2018-19, 2017-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AAKRITI DEWAN</td>
                                                    <td rowspan="12">MISSISSPPI</td>
                                                    <td>IX KANCHENJUNGA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>ANISHA GUPTA</td>
                                                    <td>IX VINDHYAS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-20</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>CHEHAKREET KAUR&nbsp;</td>
                                                    <td>IX KANCHENJUNGA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>JUNIYALI PANWAR&nbsp;</td>
                                                    <td>IX KANCHENJUNGA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>MAANSI SINGH</td>
                                                    <td>IX VINDHYAS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>MAMILLA SAI ROHAN</td>
                                                    <td>IX VINDHYAS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>MIHIKAA SINGH</td>
                                                    <td>IX VINDHYAS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>OJAL BISWANI</td>
                                                    <td>IX KANCHENJUNGA</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>RADHA HINGNE</td>
                                                    <td>IX VINDHYAS</td>
                                                    <td>2020-21 2019-20, 2018-19, 2017-24<br /></td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>SAGAR AGGARWAL</td>
                                                    <td>IX KANCHENJUNGA</td>
                                                    <td>2020-21,2018-19, 2017-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>SHAURYA SHARMA</td>
                                                    <td>IX KANCHENJUNGA</td>
                                                    <td>2020-21,2019-20</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>S SHREENIDHI</td>
                                                    <td>IX KANCHENJUNGA</td>
                                                    <td>2020-21,2019-20</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AARAV GUPTA</td>
                                                    <td>&nbsp;</td>
                                                    <td>IX KANCHENJUNGA</td>
                                                    <td>&nbsp;</td>
                                                    <td>89.4</td>
                                                    <td>B1 IN MATH</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>ANGEL KHANNA</td>
                                                    <td rowspan="12">MISSISSIPPI</td>
                                                    <td>IXNILGIRIS&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>ARINJAY JAIN</td>
                                                    <td>IX EVEREST</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-19</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>BAAVYA BANSAL</td>
                                                    <td>IX EVEREST</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>DHWANI GERA</td>
                                                    <td>IX EVEREST</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>HARSHITA BUGALIA</td>
                                                    <td>IXNILGIRIS&nbsp;</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>HITANSHI AGGARWAL</td>
                                                    <td>IX EVEREST</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-19</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>MAHIRA KOHLI</td>
                                                    <td>IX EVEREST</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-20</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>REYANSH AGARWAL</td>
                                                    <td>IX EVEREST</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>RONAN VIKRAM SINGH</td>
                                                    <td>IXNILGIRIS&nbsp;</td>
                                                    <td>2020-21,2019-20</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>SANCHIT CHHAMUNYA</td>
                                                    <td>IXNILGIRIS&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>SARA GUPTA</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-22</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>VIHAAN MEHROTRA</td>
                                                    <td>IX EVEREST</td>
                                                    <td>22020-21,019-20, 2018-19, 2017-23</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AKSHAT SHARMA&nbsp;</td>
                                                    <td>MISSISSIPPI</td>
                                                    <td>IX HIMALAYAS</td>
                                                    <td>2021</td>
                                                    <td>89.60%</td>
                                                    <td>Grey</td>
                                                    <td>GO AHEAD</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>ANIKA RANAUT</td>
                                                    <td>&nbsp;</td>
                                                    <td>IX VINDHYAS</td>
                                                    <td>2021</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>ANTRIKSH GUPTA</td>
                                                    <td rowspan="8">TAPTI</td>
                                                    <td>IX HIMALAYAS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>ARNAV WADHWA</td>
                                                    <td>IX HIMALAYAS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-19</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>ARYA JAIN</td>
                                                    <td>IX HIMALAYAS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>MYRA KAILWOO</td>
                                                    <td>IX SHIVALIKS</td>
                                                    <td>2020-21</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>PARNIKA CHANDRA</td>
                                                    <td>IX SHIVALIKS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-19</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>SHAURYA SINGH</td>
                                                    <td>IX HIMALAYAS</td>
                                                    <td>2020-21,2019-20</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>SHIRANI ANAND</td>
                                                    <td>IX HIMALAYAS</td>
                                                    <td>2020-21,2019-20</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>SYED AZHAAN ABBAS RIZVI</td>
                                                    <td>IX SHIVALIKS</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-19</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>TANISHQA&nbsp; CHADHHA</td>
                                                    <td>TAPTI</td>
                                                    <td>IX HIMALAYAS</td>
                                                    <td>90.80%</td>
                                                    <td>B GRADE IN MATH</td>
                                                    <td>&nbsp;</td>
                                                    <td>NOT VALID</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td colspan="6">TOTAL SCHOLARS IN GRADE VIII (2020-21) =&nbsp; 68 - 2 withdrawal = 66</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>Pink Badges</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>Grey Pockets</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>COMPARATIVE ANALYSIS</td>
                                                    <td>2019-20</td>
                                                    <td>2021-22</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>Total Strength</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>Scholars</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>%</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                            </tbody></table>
                                        <table cellspacing="0" cellpadding="0">
                                            <tbody><tr>
                                                <th colspan="9">DETAILS FOR THE SCHOLAR CERTIFICATES (2020-21) : GRADE IX</th>
                                            </tr>
                                                <tr>
                                                    <th colspan="9">CRITERIA:&nbsp; 85%&nbsp; and above</th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAMES</th>
                                                    <th rowspan="2">GRADE - IX  (2020-21)</th>
                                                    <th rowspan="2">GRADE - X  (2021-22)</th>
                                                    <th>&nbsp;</th>
                                                    <th rowspan="2">SESSIONS</th>
                                                    <th colspan="3">SCHOLAR STATUS</th>
                                                </tr>
                                                <tr>
                                                    <td>%age</td>
                                                    <td>BLAZER</td>
                                                    <td>BADGE</td>
                                                    <td>POCKET</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>AMULYAA KASHYAP</td>
                                                    <td rowspan="8">ARAVALLIS</td>
                                                    <td rowspan="8">ALPS</td>
                                                    <td>95.22</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>ANYA GOYAL</td>
                                                    <td>95.76</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>GARV AGARWAL</td>
                                                    <td>96.66</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>JIYA MAHAJAN</td>
                                                    <td>92.62</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>JIYA WALIA</td>
                                                    <td>96.32</td>
                                                    <td>2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>NYESA JAIN</td>
                                                    <td>92.32</td>
                                                    <td>&nbsp;2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>PRISHA KHANNA</td>
                                                    <td>94.76</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>UTKARSH SINGH</td>
                                                    <td>94.54</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>AARAV GARG</td>
                                                    <td rowspan="13">EVEREST</td>
                                                    <td rowspan="13">ANDES</td>
                                                    <td>92.38</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>ADYA PASSEY</td>
                                                    <td>89.54</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>ANUSHKA JAIN</td>
                                                    <td>93.9</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>ARAV MATHUR</td>
                                                    <td>94.6</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>DEEPTI KHETAN</td>
                                                    <td>90.16</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>DIYA VERMA</td>
                                                    <td>90.9</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>GITANJALI SINGH ATRI</td>
                                                    <td>95.06</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>ISHAAN CHHABRA</td>
                                                    <td>91.94</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>KARMAN ROOPRAI</td>
                                                    <td>92.58</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>SAANVI DAS</td>
                                                    <td>97.74</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>SARA KHURANA</td>
                                                    <td>91.94</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>SHAURYA AGARWAL</td>
                                                    <td>95.26</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>SUHANI YADAV</td>
                                                    <td>92.28</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>AKSHAT RAMPAL</td>
                                                    <td rowspan="20">HIMALAYAS</td>
                                                    <td rowspan="20">ELBRUS</td>
                                                    <td>91.52</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>ANANYA SIROHI</td>
                                                    <td>94.02</td>
                                                    <td>2019-20, 2018-19, 2017-18, 2016-18</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>ANAYA BANSAL</td>
                                                    <td>94.42</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>ARYA SETIA</td>
                                                    <td>87.74</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>KRISHIV KHANNA</td>
                                                    <td>88.08</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>LEEPE JAIN</td>
                                                    <td>93.1</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>MANNAN RANA</td>
                                                    <td>94.14</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-18</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>NAVYA AGARWAL</td>
                                                    <td>94.8</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>NAVYA SINGHAL</td>
                                                    <td>90.8</td>
                                                    <td>2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>NIA RANJAN</td>
                                                    <td>94.02</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>NIEEL PRAVEEN</td>
                                                    <td>92.54</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>NIKKHIL PRAVEEN</td>
                                                    <td>88.78</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>PRANYA KASHYAP</td>
                                                    <td>89.7</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>RISHIT RAMPAL</td>
                                                    <td>92.18</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>RITISHA MEHROTRA</td>
                                                    <td>95.62</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>SAANVI HORA</td>
                                                    <td>95.42</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>SHIVAM VIRMANI</td>
                                                    <td>90.76</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>VANSHIKA JAIN</td>
                                                    <td>93.3</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>VIVAAN BATTISH</td>
                                                    <td>90.62</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>YATEE NAGPAL</td>
                                                    <td>90.6</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>AADEESH JAIN</td>
                                                    <td rowspan="8">SHIVALIKS</td>
                                                    <td rowspan="8">OLYMPUS</td>
                                                    <td>92.36</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>AARNAA BATRA</td>
                                                    <td>89.94</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>AHAD TARIQ</td>
                                                    <td>92.14</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>JAGRAV MAGON</td>
                                                    <td>91.6</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>JAIADITYA RATHORE</td>
                                                    <td>89.2</td>
                                                    <td>2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>NAYANTARA YADAV</td>
                                                    <td>89.5</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>SAI MOHIT KOTTA</td>
                                                    <td>93.1</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>TANSI MEHROTRA</td>
                                                    <td>89.8</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>AADYA JAIN</td>
                                                    <td rowspan="21">KANCHENJUNGA</td>
                                                    <td rowspan="21">ELBERT</td>
                                                    <td>96.48</td>
                                                    <td>2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>AARUSH JAIN</td>
                                                    <td>95.24</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>AARZOO KAPOOR</td>
                                                    <td>97.52</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>ADITI PANT</td>
                                                    <td>95.7</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>ADITYA MARWAH</td>
                                                    <td>92.3</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>ANANYA SALUJA</td>
                                                    <td>91.34</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>ARRSH REHANI</td>
                                                    <td>89.04</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>57</td>
                                                    <td>AVISHI CHOUBEY</td>
                                                    <td>96.56</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>58</td>
                                                    <td>DIYA BHATNAGAR</td>
                                                    <td>87.9</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>59</td>
                                                    <td>ISHIKA MAHAJAN</td>
                                                    <td>95.88</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>60</td>
                                                    <td>KSHITIJ VERMA</td>
                                                    <td>95.18</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>61</td>
                                                    <td>MEHR GAHARWAR</td>
                                                    <td>93.5</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>62</td>
                                                    <td>NYSA H. VAID</td>
                                                    <td>92.52</td>
                                                    <td>2019-20, 2018-19, 2017-18</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>63</td>
                                                    <td>RAHAT KAURA</td>
                                                    <td>93.34</td>
                                                    <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>64</td>
                                                    <td>SARAH AHMAD</td>
                                                    <td>91.54</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>65</td>
                                                    <td>SHAURYA GUPTA</td>
                                                    <td>94.74</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>66</td>
                                                    <td>SHOURYA KAPOOR</td>
                                                    <td>92.04</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>67</td>
                                                    <td>TAMANNA KAPOOR</td>
                                                    <td>97.82</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>68</td>
                                                    <td>TANISH SHARAN</td>
                                                    <td>92.34</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>69</td>
                                                    <td>TISHIA KATOCH</td>
                                                    <td>90.1</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>70</td>
                                                    <td>VINAYAK MALHOTRA</td>
                                                    <td>93.08</td>
                                                    <td>2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>71</td>
                                                    <td>ANIRUDH GOVINDAN</td>
                                                    <td rowspan="9">NILGIRIS</td>
                                                    <td rowspan="9">FUJI</td>
                                                    <td>93.6</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>72</td>
                                                    <td>ANYA GUPTA</td>
                                                    <td>94.74</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>73</td>
                                                    <td>ASHMIT KHETERPAL</td>
                                                    <td>91.88</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>74</td>
                                                    <td>KAINA MALIK</td>
                                                    <td>90.44</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>75</td>
                                                    <td>NAVYA LAKHOTIA</td>
                                                    <td>93.94</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-19</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>76</td>
                                                    <td>RAIMA GUHA</td>
                                                    <td>93.5</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>77</td>
                                                    <td>RYAN PURI</td>
                                                    <td>94.28</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>78</td>
                                                    <td>SOUMYAVARDHAN MAHESHWARI</td>
                                                    <td>93.02</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>79</td>
                                                    <td>TEJAL DOSHI</td>
                                                    <td>96.1</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>80</td>
                                                    <td>ANANDINI AGRAWAL</td>
                                                    <td rowspan="19">VINDHYAS</td>
                                                    <td rowspan="19">WHITNEY</td>
                                                    <td>96.34</td>
                                                    <td>2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>81</td>
                                                    <td>AVIRAJ GOYLE</td>
                                                    <td>96.7</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>82</td>
                                                    <td>CHAITANYA GUPTA</td>
                                                    <td>94.32</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>83</td>
                                                    <td>GAURIKA KHANNA</td>
                                                    <td>86.6</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>84</td>
                                                    <td>GAYATRI VEER</td>
                                                    <td>91.94</td>
                                                    <td>2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>85</td>
                                                    <td>KATYA SOOD</td>
                                                    <td>94.26</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>86</td>
                                                    <td>KRIPA KAUR</td>
                                                    <td>96.22</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>87</td>
                                                    <td>KYNA CHAUDHARY</td>
                                                    <td>95.34</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>88</td>
                                                    <td>LAKSHYA AGARWAL</td>
                                                    <td>95.52</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>89</td>
                                                    <td>MADHAV MALHAN</td>
                                                    <td>94.36</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>90</td>
                                                    <td>NAINA MAHAK TANDON</td>
                                                    <td>85.92</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>91</td>
                                                    <td>NAVYA NANDINI DHODY</td>
                                                    <td>97</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>92</td>
                                                    <td>PARTH AHUJA</td>
                                                    <td>95.84</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>93</td>
                                                    <td>PRACHI CHOPRA</td>
                                                    <td>97.58</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>94</td>
                                                    <td>PRIYADARSHINI GHOSH</td>
                                                    <td>98.32</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>95</td>
                                                    <td>RAGHAV BANSAL</td>
                                                    <td>95.76</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>96</td>
                                                    <td>SANVI ARORA</td>
                                                    <td>91.56</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>97</td>
                                                    <td>SAUMYA BABBAR</td>
                                                    <td>95.72</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>98</td>
                                                    <td>YASH VERMA</td>
                                                    <td>94.56</td>
                                                    <td>2020-21,2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td colspan="7">TOTAL SCHOLARS IN GRADE IX (2020-21) = 98</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Pink Badges</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Grey Pockets</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Blue Blazers</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>COMPARATIVE ANALYSIS</td>
                                                    <td>2019-20</td>
                                                    <td>2020-21</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Total Strength</td>
                                                    <td>152</td>
                                                    <td>192</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Scholars</td>
                                                    <td>57</td>
                                                    <td>98</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>%</td>
                                                    <td>37.5</td>
                                                    <td>51.0</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>TC Cases:</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>ADITYA SUNDARAM&nbsp; (TC)</td>
                                                    <td>SHIVALIKS</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>Grey</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>ARNAV GUPTA (TC)</td>
                                                    <td>SHIVALIKS</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>2020-21,2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>Blue&nbsp;</td>
                                                    <td>Pink&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                            </tbody></table>
                                        <table cellspacing="0" cellpadding="0">
                                            <tbody><tr>
                                                <th colspan="10">DETAILS FOR THE SCHOLAR CERTIFICATES (2020-21) : GRADE XI</th>
                                            </tr>
                                                <tr>
                                                    <th colspan="10">CRITERIA:&nbsp; 85%&nbsp; and above with no B-grades</th>
                                                </tr>
                                                <tr>
                                                    <th rowspan="2">S.N.</th>
                                                    <th rowspan="2">NAME</th>
                                                    <th rowspan="2">GRADE -XI  (2019-20)</th>
                                                    <th rowspan="2">GRADE - XII&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (2020-21)</th>
                                                    <th rowspan="2">%</th>
                                                    <th rowspan="2">SESSIONS</th>
                                                    <th colspan="4">STATUS</th>
                                                </tr>
                                                <tr>
                                                    <td>SCHOLAR</td>
                                                    <td>BLAZER</td>
                                                    <td>BADGE</td>
                                                    <td>POCKET</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>ANIRUDH RATHOD</td>
                                                    <td rowspan="8">ARISTOTLE</td>
                                                    <td rowspan="8">MARSHALL</td>
                                                    <td>89.78</td>
                                                    <td>2020-2021, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td rowspan="56">&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>GAYATRI VARMA</td>
                                                    <td>92.58</td>
                                                    <td>2020-2021, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>JALAJ YADAV</td>
                                                    <td>89.6</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>LORD LUGANI</td>
                                                    <td>86.24</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>LOVISH CHOUDHARY<br /></td>
                                                    <td>85.66</td>
                                                    <td>2020-2021, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>PRATYUSH PURWAR</td>
                                                    <td>84.54</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>ROLI AGGARWAL<br /></td>
                                                    <td>97.2</td>
                                                    <td>2020-2021, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>SARISHA JAGGI</td>
                                                    <td>85.78</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>AADITYA KUMAR</td>
                                                    <td rowspan="6">KEYNES</td>
                                                    <td rowspan="6">LEONARDO</td>
                                                    <td>86.58</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>ADRIJA DE</td>
                                                    <td>88.88</td>
                                                    <td>2020-2021, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>MAYANK KATARIA</td>
                                                    <td>85.62</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>SAAGARIKA GAHLOT</td>
                                                    <td>93.04</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>SARMATHA R</td>
                                                    <td>94.14</td>
                                                    <td>2020-2021, 2019-20,2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>YASHITA AGARWAL</td>
                                                    <td>94.26</td>
                                                    <td>2020-2021, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>ANANYA MALIK</td>
                                                    <td rowspan="9">DALTON</td>
                                                    <td rowspan="9">GALILEO</td>
                                                    <td>87.06</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>ARADHYA MISHRA</td>
                                                    <td>89.3</td>
                                                    <td>2020-2021, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>ASVIKA NIGAM</td>
                                                    <td>87.26</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>AVISHI MONGA</td>
                                                    <td>87.46</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18,2016-17, 2015-16, 2014-15, 2013-14</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>KHUSHI SATNALIWALA</td>
                                                    <td>88.98</td>
                                                    <td>2020-21, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>KHYATI PRASAD</td>
                                                    <td>86.86</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>SUHANI VALECHA&nbsp;</td>
                                                    <td>85.34</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>TITHI SARKAR</td>
                                                    <td>85.06</td>
                                                    <td>2020-21, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>VIKRAMADITYA YADAV&nbsp;</td>
                                                    <td>89.78</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>ARCHIT SHARMA</td>
                                                    <td rowspan="12">EINSTEIN</td>
                                                    <td rowspan="12">ARCHIMEDES</td>
                                                    <td>88.64</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>PRANAY GOEL</td>
                                                    <td>88</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>RIYA SUHAG</td>
                                                    <td>88.18</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>DIYA TRIPATHI</td>
                                                    <td>87.72</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>ABHAY VERMA</td>
                                                    <td>90.18</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>DHANUR CHAHAL</td>
                                                    <td>88.76</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>NIPUN YADAV</td>
                                                    <td>95.06</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>SIDDHARTH MISHRA</td>
                                                    <td>94.54</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>TANUSH YADAV</td>
                                                    <td>86.36</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>ESHAAN ARYAN SINHA</td>
                                                    <td>86.84</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>AMITESH ANAND PANDEY</td>
                                                    <td>88.74</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>ANINDYA MISHRA</td>
                                                    <td>92.88</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>ANANYA JAIN</td>
                                                    <td rowspan="10">EDISON</td>
                                                    <td>ARCHIMEDES</td>
                                                    <td>95.56</td>
                                                    <td>2020-21, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>ARNAV GARG&nbsp;</td>
                                                    <td>ARCHIMEDES</td>
                                                    <td>87.98</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>ARUNAKSH KAPOOR</td>
                                                    <td>ARCHIMEDES</td>
                                                    <td>93.02</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>DIVANSHIE SUMIT SETIA</td>
                                                    <td>GALILEO</td>
                                                    <td>94.28</td>
                                                    <td>2020-21, 2019-20,2018-19, 2017-18, 2016-17</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>FREYA SIDHWA</td>
                                                    <td>GALILEO</td>
                                                    <td>87.18</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>INHAAS VIRMANI</td>
                                                    <td>ARCHIMEDES</td>
                                                    <td>97</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>KAVYA SONDHI</td>
                                                    <td>GALILEO</td>
                                                    <td>85.12</td>
                                                    <td>2020-21, 2019-20,2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>PRARABDHA HALDER</td>
                                                    <td>GALILEO</td>
                                                    <td>85.26</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>RIYA RAWAL</td>
                                                    <td>ARCHIMEDES</td>
                                                    <td>91.26</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>VIDIT YADUVANSHI</td>
                                                    <td>ARCHIMEDES</td>
                                                    <td>84.96</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>AKSHITA SHARMA</td>
                                                    <td rowspan="11">SHAKESPEARE</td>
                                                    <td rowspan="11">WORDSWORTH</td>
                                                    <td>85.38</td>
                                                    <td>2020-21,2019-20&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>ARUSHI BANERJEE</td>
                                                    <td>89.58</td>
                                                    <td>2020-21, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>DISHA VASHISTHA</td>
                                                    <td>89.17</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>KHUSHI SOOD</td>
                                                    <td>88.86</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>MAANYAA GUPTA</td>
                                                    <td>87.56</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>MEGHA BISHT</td>
                                                    <td>87.02</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>PARTH PIYUSH PRASAD</td>
                                                    <td>92.78</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>RASHI CHAUHAN</td>
                                                    <td>90.16</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>SAMYAK YASH JAIN</td>
                                                    <td>85.02</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>SHIVIKA PANDEY</td>
                                                    <td>93.9</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>TANVI CHAND</td>
                                                    <td>89.42</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="7">TOTAL SCHOLARS IN GRADE XI(2020-21) =&nbsp; 56</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Pink Badges</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Blue Badges</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Grey Pockets</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Blue Pockets</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Super Scholars</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>COMPARATIVE ANALYSIS</td>
                                                    <td>2019-20</td>
                                                    <td>20120-21</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Total Strength</td>
                                                    <td>100</td>
                                                    <td>127</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Scholars</td>
                                                    <td>21</td>
                                                    <td>56</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>%</td>
                                                    <td>21</td>
                                                    <td>44.09</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody></table>
                                        <table cellspacing="0" cellpadding="0">

                                            <tbody><tr>
                                                <th colspan="4">ASSESSMENT PLAN FOR THE YEAR 2021-22 (SUMMARY)</th>
                                            </tr>
                                                <tr>
                                                    <th>Assessment Dates</th>
                                                    <th>Grade IV</th>
                                                    <th>Grade V</th>
                                                    <th>Grades VI, VII and VIII</th>
                                                </tr>
                                                <tr>
                                                    <td>28th June -6th Aug</td>
                                                    <td>Unit Test 1</td>
                                                    <td>Unit Test 1</td>
                                                    <td>Unit Test 1</td>
                                                </tr>
                                                <tr>
                                                    <td>27th&nbsp;Aug to 13th&nbsp;Sept</td>
                                                    <td>Unit Test 2</td>
                                                    <td>Unit Test 2</td>
                                                    <td>Half Yearly Examination</td>
                                                </tr>
                                                <tr>
                                                    <td>15th&nbsp;Nov - Dec</td>
                                                    <td>Unit Test 3</td>
                                                    <td>Unit Test 3</td>
                                                    <td>Unit Test 2</td>
                                                </tr>
                                                <tr>
                                                    <td>17th&nbsp;Jan - 4th&nbsp;Feb</td>
                                                    <td>Passion Paathshala</td>
                                                    <td>Passion Paathshala</td>
                                                    <td>Unit Test 3</td>
                                                </tr>
                                                <tr>
                                                    <td>7th&nbsp;Feb - 7th&nbsp;March</td>
                                                    <td>Unit Test 4</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;21st&nbsp;Feb – 11th&nbsp;March</td>
                                                    <td>&nbsp;</td>
                                                    <td>Year End Assessment</td>
                                                    <td>Year End Assessment</td>
                                                </tr>
                                            </tbody></table>
                                    </div>
                                </div>
                            )
                            }
                            {filterData === "3" && (
                                <div class="">
                                    <div class="heading2 text-center">
                                        <h4>Scholar Badge Holders 2020-21</h4>
                                    </div>
                                    <div class="table">
                                        <table className='table-view' border="1" width="100%">
                                            <tbody><tr>
                                                <th colspan="10">DETAILS FOR THE SCHOLAR CERTIFICATES (2020-21) : GRADE XI</th>
                                            </tr>
                                                <tr>
                                                    <th colspan="10">CRITERIA:&nbsp; 85%&nbsp; and above with no B-grades</th>
                                                </tr>
                                                <tr>
                                                    <td rowspan="2">S.N.</td>
                                                    <td rowspan="2">NAME</td>
                                                    <td rowspan="2">GRADE -XI (2019-20)</td>
                                                    <td rowspan="2">GRADE - XII (2020-21)</td>
                                                    <td rowspan="2">%</td>
                                                    <td rowspan="2">SESSIONS</td>
                                                    <td colspan="4">STATUS</td>
                                                </tr>
                                                <tr>
                                                    <td>SCHOLAR</td>
                                                    <td>BLAZER</td>
                                                    <td>BADGE</td>
                                                    <td>POCKET</td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>ANIRUDH RATHOD</td>
                                                    <td rowspan="8">ARISTOTLE</td>
                                                    <td rowspan="8">MARSHALL</td>
                                                    <td>89.78</td>
                                                    <td>2020-2021, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td rowspan="56">&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>GAYATRI VARMA</td>
                                                    <td>92.58</td>
                                                    <td>2020-2021, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>JALAJ YADAV</td>
                                                    <td>89.6</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>LORD LUGANI</td>
                                                    <td>86.24</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>LOVISH CHOUDHARY<br /></td>
                                                    <td>85.66</td>
                                                    <td>2020-2021, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>PRATYUSH PURWAR</td>
                                                    <td>84.54</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>ROLI AGGARWAL<br /></td>
                                                    <td>97.2</td>
                                                    <td>2020-2021, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>SARISHA JAGGI</td>
                                                    <td>85.78</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>AADITYA KUMAR</td>
                                                    <td rowspan="6">KEYNES</td>
                                                    <td rowspan="6">LEONARDO</td>
                                                    <td>86.58</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>ADRIJA DE</td>
                                                    <td>88.88</td>
                                                    <td>2020-2021, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>11</td>
                                                    <td>MAYANK KATARIA</td>
                                                    <td>85.62</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>12</td>
                                                    <td>SAAGARIKA GAHLOT</td>
                                                    <td>93.04</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>13</td>
                                                    <td>SARMATHA R</td>
                                                    <td>94.14</td>
                                                    <td>2020-2021, 2019-20,2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>14</td>
                                                    <td>YASHITA AGARWAL</td>
                                                    <td>94.26</td>
                                                    <td>2020-2021, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>15</td>
                                                    <td>ANANYA MALIK</td>
                                                    <td rowspan="9">DALTON</td>
                                                    <td rowspan="9">GALILEO</td>
                                                    <td>87.06</td>
                                                    <td>2020-2021, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>16</td>
                                                    <td>ARADHYA MISHRA</td>
                                                    <td>89.3</td>
                                                    <td>2020-2021, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>17</td>
                                                    <td>ASVIKA NIGAM</td>
                                                    <td>87.26</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>18</td>
                                                    <td>AVISHI MONGA</td>
                                                    <td>87.46</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18,2016-17, 2015-16, 2014-15, 2013-14</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>19</td>
                                                    <td>KHUSHI SATNALIWALA</td>
                                                    <td>88.98</td>
                                                    <td>2020-21, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>20</td>
                                                    <td>KHYATI PRASAD</td>
                                                    <td>86.86</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>21</td>
                                                    <td>SUHANI VALECHA&nbsp;</td>
                                                    <td>85.34</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>22</td>
                                                    <td>TITHI SARKAR</td>
                                                    <td>85.06</td>
                                                    <td>2020-21, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>23</td>
                                                    <td>VIKRAMADITYA YADAV&nbsp;</td>
                                                    <td>89.78</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>24</td>
                                                    <td>ARCHIT SHARMA</td>
                                                    <td rowspan="12">EINSTEIN</td>
                                                    <td rowspan="12">ARCHIMEDES</td>
                                                    <td>88.64</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>25</td>
                                                    <td>PRANAY GOEL</td>
                                                    <td>88</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>26</td>
                                                    <td>RIYA SUHAG</td>
                                                    <td>88.18</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>27</td>
                                                    <td>DIYA TRIPATHI</td>
                                                    <td>87.72</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>28</td>
                                                    <td>ABHAY VERMA</td>
                                                    <td>90.18</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>29</td>
                                                    <td>DHANUR CHAHAL</td>
                                                    <td>88.76</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>30</td>
                                                    <td>NIPUN YADAV</td>
                                                    <td>95.06</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>31</td>
                                                    <td>SIDDHARTH MISHRA</td>
                                                    <td>94.54</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>32</td>
                                                    <td>TANUSH YADAV</td>
                                                    <td>86.36</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>33</td>
                                                    <td>ESHAAN ARYAN SINHA</td>
                                                    <td>86.84</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>34</td>
                                                    <td>AMITESH ANAND PANDEY</td>
                                                    <td>88.74</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>35</td>
                                                    <td>ANINDYA MISHRA</td>
                                                    <td>92.88</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>36</td>
                                                    <td>ANANYA JAIN</td>
                                                    <td rowspan="10">EDISON</td>
                                                    <td>ARCHIMEDES</td>
                                                    <td>95.56</td>
                                                    <td>2020-21, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>37</td>
                                                    <td>ARNAV GARG&nbsp;</td>
                                                    <td>ARCHIMEDES</td>
                                                    <td>87.98</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>38</td>
                                                    <td>ARUNAKSH KAPOOR</td>
                                                    <td>ARCHIMEDES</td>
                                                    <td>93.02</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>39</td>
                                                    <td>DIVANSHIE SUMIT SETIA</td>
                                                    <td>GALILEO</td>
                                                    <td>94.28</td>
                                                    <td>2020-21, 2019-20,2018-19, 2017-18, 2016-17</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>40</td>
                                                    <td>FREYA SIDHWA</td>
                                                    <td>GALILEO</td>
                                                    <td>87.18</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>41</td>
                                                    <td>INHAAS VIRMANI</td>
                                                    <td>ARCHIMEDES</td>
                                                    <td>97</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>42</td>
                                                    <td>KAVYA SONDHI</td>
                                                    <td>GALILEO</td>
                                                    <td>85.12</td>
                                                    <td>2020-21, 2019-20,2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>43</td>
                                                    <td>PRARABDHA HALDER</td>
                                                    <td>GALILEO</td>
                                                    <td>85.26</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>44</td>
                                                    <td>RIYA RAWAL</td>
                                                    <td>ARCHIMEDES</td>
                                                    <td>91.26</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>45</td>
                                                    <td>VIDIT YADUVANSHI</td>
                                                    <td>ARCHIMEDES</td>
                                                    <td>84.96</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>46</td>
                                                    <td>AKSHITA SHARMA</td>
                                                    <td rowspan="11">SHAKESPEARE</td>
                                                    <td rowspan="11">WORDSWORTH</td>
                                                    <td>85.38</td>
                                                    <td>2020-21,2019-20&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>47</td>
                                                    <td>ARUSHI BANERJEE</td>
                                                    <td>89.58</td>
                                                    <td>2020-21, 2019-20, 2018-19</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>48</td>
                                                    <td>DISHA VASHISTHA</td>
                                                    <td>89.17</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>49</td>
                                                    <td>KHUSHI SOOD</td>
                                                    <td>88.86</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>50</td>
                                                    <td>MAANYAA GUPTA</td>
                                                    <td>87.56</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>51</td>
                                                    <td>MEGHA BISHT</td>
                                                    <td>87.02</td>
                                                    <td>2020-21</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>52</td>
                                                    <td>PARTH PIYUSH PRASAD</td>
                                                    <td>92.78</td>
                                                    <td>2020-21, 2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>53</td>
                                                    <td>RASHI CHAUHAN</td>
                                                    <td>90.16</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>54</td>
                                                    <td>SAMYAK YASH JAIN</td>
                                                    <td>85.02</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>55</td>
                                                    <td>SHIVIKA PANDEY</td>
                                                    <td>93.9</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>56</td>
                                                    <td>TANVI CHAND</td>
                                                    <td>89.42</td>
                                                    <td>2020-21, 2019-20</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="7">TOTAL SCHOLARS IN GRADE XI(2020-21) =&nbsp; 56</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Pink Badges</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Blue Badges</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Grey Pockets</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Blue Pockets</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Super Scholars</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>COMPARATIVE ANALYSIS</td>
                                                    <td>2019-20</td>
                                                    <td>20120-21</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Total Strength</td>
                                                    <td>100</td>
                                                    <td>127</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>Scholars</td>
                                                    <td>21</td>
                                                    <td>56</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>%</td>
                                                    <td>21</td>
                                                    <td>44.09</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                            </table>
                                    </div>
                                </div>
                            )
                            }
                            {
                                filterData === "4" && (
                                    <div class="">
                                        <div class="heading2 text-center">
                                            <h4>Scholar Badge Holders 2019-20</h4>
                                        </div>
                                        <div class="table">
                                            <table className='table-view' border="1" width="100%">
                                                <tbody><tr>
                                                    <th colspan="7">DETAILS FOR THE SCHOLAR CERTIFICATES : GRADE V (2019-20)</th>
                                                </tr>
                                                    <tr>
                                                        <th colspan="7">Aggregate 90% &amp; above</th>
                                                    </tr>
                                                    <tr>
                                                        <th rowspan="2">S.N.</th>
                                                        <th rowspan="2">NAMES</th>
                                                        <th rowspan="2">GRADE -V  (2019-20)</th>
                                                        <th rowspan="2">GRADE - VI  (2020-21)</th>
                                                        <th rowspan="2">SESSIONS</th>
                                                        <th colspan="2">SCHOLAR STATUS</th>
                                                    </tr>
                                                    <tr>
                                                        <td>BADGE</td>
                                                        <td>POCKET</td>
                                                    </tr>
                                                    <tr>
                                                        <td>1</td>
                                                        <td>AAHANA VERMA (TC)</td>
                                                        <td rowspan="14">BIRCHES</td>
                                                        <td rowspan="14">BEAS</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>2</td>
                                                        <td>ABHYUDITA VERMA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>3</td>
                                                        <td>ARSHIYA SINGH</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>4</td>
                                                        <td>AVICHAL GUPTA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>5</td>
                                                        <td>AVIRAJ AGARWAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>6</td>
                                                        <td>FIONA GUPTA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>7</td>
                                                        <td>GARVIT SINGHAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>8</td>
                                                        <td>IRSA SHARMA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>9</td>
                                                        <td>ISHAAN DAS</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>10</td>
                                                        <td>KHUSHIKA PAHWA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>11</td>
                                                        <td>SAMAERA CHAWLA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>12</td>
                                                        <td>SAMAIRA WADHWA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>13</td>
                                                        <td>SANVI NANDA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>14</td>
                                                        <td>SHIVENN GUPTA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>15</td>
                                                        <td>AADHAR MITTAL</td>
                                                        <td rowspan="16">BURANS</td>
                                                        <td rowspan="16">GANGES</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>16</td>
                                                        <td>AARAV MITTAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>17</td>
                                                        <td>ALAINA BHATIA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>18</td>
                                                        <td>ANIRUDH SHARMA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>19</td>
                                                        <td>ARSHIA SHARMA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>20</td>
                                                        <td>AYATI JAIN</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>21</td>
                                                        <td>GURSAANA DANG</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>22</td>
                                                        <td>HARSHIL SHARMA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>23</td>
                                                        <td>ISHAAN TAPARIA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>24</td>
                                                        <td>JASMEH SODHI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>25</td>
                                                        <td>NANDINI SHARMA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>26</td>
                                                        <td>NEHAL SOTHWAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>27</td>
                                                        <td>RIDHIMA JINDAL (TC)</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>28</td>
                                                        <td>SARTHAK CHATURVEDI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>29</td>
                                                        <td>TANISHKKA AGGARWAL (TC)</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>30</td>
                                                        <td>UNNATI SAXENA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>31</td>
                                                        <td>AADYA SHARMA</td>
                                                        <td rowspan="16">CEDARS</td>
                                                        <td rowspan="16">GODAVARI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>32</td>
                                                        <td>AARAV JAIN</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>33</td>
                                                        <td>ALIA RATHI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>34</td>
                                                        <td>ANAHITA PANT</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>35</td>
                                                        <td>ANAHITA SINGAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>36</td>
                                                        <td>ANAYA JAIN</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>37</td>
                                                        <td>AVIK BANERJEE</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>38</td>
                                                        <td>KRISHANG GROVER</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>39</td>
                                                        <td>MANAN VERMA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>40</td>
                                                        <td>MOHIT SONI (TC)</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>41</td>
                                                        <td>NAISHA SAWHNEY</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>42</td>
                                                        <td>NEVAN ROY &nbsp;(TC)</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>43</td>
                                                        <td>SAINA CHOPRA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>44</td>
                                                        <td>SHAURYA ARORA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>45</td>
                                                        <td>SIYONA BAKSHI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>46</td>
                                                        <td>SWARIT NARULA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>47</td>
                                                        <td>AADYA CHOPRA</td>
                                                        <td rowspan="10">MAPLES</td>
                                                        <td rowspan="10">KAVERI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>48</td>
                                                        <td>ADITYA SRIVASTAVA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>49</td>
                                                        <td>ANANYA LAKARA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>50</td>
                                                        <td>OJAS MANGLANI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>51</td>
                                                        <td>OUCHITYA KHURANA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>52</td>
                                                        <td>PARINAV CHOUDHURY &nbsp;(TC)</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>53</td>
                                                        <td>SHAUNAK RAJPAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>54</td>
                                                        <td>SHYLA TYAGI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>55</td>
                                                        <td>UTKARSHIKA RAJPUT</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>56</td>
                                                        <td>AARYA MEHROTRA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>57</td>
                                                        <td>ARMAAN ANAND</td>
                                                        <td rowspan="17">NEEMS</td>
                                                        <td rowspan="17">NARMADA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>58</td>
                                                        <td>ARYAN GUPTA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>59</td>
                                                        <td>AYAAN TALWAR&nbsp; (TC)</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>60</td>
                                                        <td>DHRUV MOZA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>61</td>
                                                        <td>HITAGYA JAIN</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>62</td>
                                                        <td>KARTIK SUGLA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>63</td>
                                                        <td>MAYAN BHASKAR</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>64</td>
                                                        <td>MIHIKA SHARMA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>65</td>
                                                        <td>PRAKHAR BUKALSARIA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>66</td>
                                                        <td>RASHESH AGGARWAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>67</td>
                                                        <td>SHIVANGI GUPTA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>68</td>
                                                        <td>SIDDHARTH DHAWAN</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>69</td>
                                                        <td>SIDHANSH GARG</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>70</td>
                                                        <td>SOHANA SINGH</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>71</td>
                                                        <td>TVISHA CHAWLA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>72</td>
                                                        <td>VIHAAN AGRAWAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>73</td>
                                                        <td>VRINDA MITTAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>74</td>
                                                        <td>AARIN SHARMA</td>
                                                        <td rowspan="12">OAKS</td>
                                                        <td rowspan="12">NILE</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>75</td>
                                                        <td>ADVIKA MISHRA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>76</td>
                                                        <td>AVANTIKA JAISWAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>77</td>
                                                        <td>DHAIRYA KEDIA &nbsp;(TC)</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>78</td>
                                                        <td>LAVANYA BAJAJ</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>79</td>
                                                        <td>PRISHA MISHRA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>80</td>
                                                        <td>PRISHA SATIJA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>81</td>
                                                        <td>RHEA GOVIL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>82</td>
                                                        <td>SHREYANSH KANOTRA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>83</td>
                                                        <td>TISNOOR KAUR GULIANI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>84</td>
                                                        <td>VANIA RAY</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>85</td>
                                                        <td>VASUDHA SINGHAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>86</td>
                                                        <td>ARNAV GOYAL</td>
                                                        <td rowspan="20">OLIVES</td>
                                                        <td rowspan="20">SUTLEJ</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>87</td>
                                                        <td>ARNAV NAGPAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>88</td>
                                                        <td>ASMI GUPTA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>89</td>
                                                        <td>CHARVI YAADAV</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>90</td>
                                                        <td>DISHA AGARWAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>91</td>
                                                        <td>DIVYANSH KAPOOR</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>92</td>
                                                        <td>IVANYA DAYAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>93</td>
                                                        <td>MYRA SHARMA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>94</td>
                                                        <td>RASHI VANIDANI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>95</td>
                                                        <td>RUHAAN AGGARWAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>96</td>
                                                        <td>AARAV THARWANI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>97</td>
                                                        <td>AARNA GUPTA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>98</td>
                                                        <td>ARSHIA AHUJA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>99</td>
                                                        <td>HIYA GOSWAMI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>100</td>
                                                        <td>KALPANA YADAV</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>101</td>
                                                        <td>PARIDHI CHOUDHARY &nbsp;(TC)</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>102</td>
                                                        <td>RAGHAV VERMA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>103</td>
                                                        <td>SAESHHA ADHANA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>104</td>
                                                        <td>SARTHAK GUPTA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>105</td>
                                                        <td>VIDISHA SRIVASTAVA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>106</td>
                                                        <td>AAHANA JAIN</td>
                                                        <td rowspan="20">PINES</td>
                                                        <td rowspan="20">THAMES</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>107</td>
                                                        <td>ADITI SEHGAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>108</td>
                                                        <td>AKANSHA BANSAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>109</td>
                                                        <td>ANYA AGARWAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>110</td>
                                                        <td>ARIKA SAHAI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>111</td>
                                                        <td>ARNAV JAIN</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>112</td>
                                                        <td>ARYAVEER SINGH</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>113</td>
                                                        <td>AVANYA KHANNA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>114</td>
                                                        <td>AVISHA GARG</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>115</td>
                                                        <td>BHUVI SHARMA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>116</td>
                                                        <td>ISHIT RASTOGI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>117</td>
                                                        <td>JAI DUGGAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>118</td>
                                                        <td>KASHVI AGGARWAL &nbsp;(TC)</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>119</td>
                                                        <td>NAISHA KHANNA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>120</td>
                                                        <td>PRIYASHA BAJAJ</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>121</td>
                                                        <td>SAARANYA SINHA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>122</td>
                                                        <td>SHASWAT BAHRI &nbsp;(TC)</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>123</td>
                                                        <td>TANISHA GUPTA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>124</td>
                                                        <td>VIBHU NARAYAN BANSAL</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>125</td>
                                                        <td>VRINDA KHANNA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>126</td>
                                                        <td>ARYAN TALWAR&nbsp;</td>
                                                        <td>OAKS</td>
                                                        <td>THAMES</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="7">TOTAL SCHOLARS IN GRADE V (2019-20) =&nbsp; 126&nbsp; - 11 withdrawal = 115</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Pink Badges</td>
                                                        <td>126</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Grey Pockets</td>
                                                        <td>126</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>COMPARATIVE ANALYSIS</td>
                                                        <td>2018-19</td>
                                                        <td>2019-20</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Total Strength</td>
                                                        <td align="right">247</td>
                                                        <td align="right">235</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Scholars</td>
                                                        <td align="right">133</td>
                                                        <td align="right">126</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>%</td>
                                                        <td align="right">53.846154</td>
                                                        <td align="right">53.617021</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <th colspan="7">DETAILS FOR THE SCHOLAR CERTIFICATES : GRADE VI (2019-20)&nbsp;&nbsp;&nbsp;&nbsp;</th>
                                                    </tr>
                                                    <tr>
                                                        <th colspan="7">Aggregate 90%</th>
                                                    </tr>
                                                    <tr>
                                                        <th rowspan="2">S.N.</th>
                                                        <th rowspan="2">NAMES</th>
                                                        <th rowspan="2">GRADE -VI  (2019-20)</th>
                                                        <th rowspan="2">GRADE - VII &nbsp;&nbsp;&nbsp;&nbsp; (2020-21)</th>
                                                        <th rowspan="2">SESSIONS</th>
                                                        <th colspan="2">SCHOLAR STATUS</th>
                                                    </tr>
                                                    <tr>
                                                        <td>BADGE</td>
                                                        <td>POCKET</td>
                                                    </tr>
                                                    <tr>
                                                        <td>1</td>
                                                        <td>AADHYA GUPTA</td>
                                                        <td rowspan="9">BEAS</td>
                                                        <td rowspan="9">CHENAB</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>2</td>
                                                        <td>SPANDANA SANJOY BARUA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>3</td>
                                                        <td>SAANVI RANJAN</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>4</td>
                                                        <td>PRAGYA YADAV</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>5</td>
                                                        <td>PARTHAV SARIN</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>6</td>
                                                        <td>ANYA SAXENA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>7</td>
                                                        <td>AFRAAZ ALAM</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>8</td>
                                                        <td>ADITYA KUMAR</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>9</td>
                                                        <td>RISHIT GOYAL</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>10</td>
                                                        <td>ARJUN MANN</td>
                                                        <td>GANGES</td>
                                                        <td>CHENAB</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>11</td>
                                                        <td>AGAM BHANSWAL</td>
                                                        <td rowspan="10">GANGES</td>
                                                        <td rowspan="10">COLORADO</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>12</td>
                                                        <td>ARNAV ARORA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>13</td>
                                                        <td>AVNI SINGH</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>14</td>
                                                        <td>AYUSHI MOOLCHANDANI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>15</td>
                                                        <td>GRISHA MAULIN GANDHI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>16</td>
                                                        <td>LAVANYA TIWARI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>17</td>
                                                        <td>NAVYA GARG</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>18</td>
                                                        <td>RYAN GUPTA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>19</td>
                                                        <td>SABHYA AGGARWAL</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>20</td>
                                                        <td>SIMAR KAUR</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>21</td>
                                                        <td>AAIRIYA JAIN</td>
                                                        <td rowspan="11">GODAVARI</td>
                                                        <td rowspan="11">DAMODAR</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>22</td>
                                                        <td>ABHIMANYU BHARDWAJ</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>23</td>
                                                        <td>INSHA MIRZA (TC)</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>24</td>
                                                        <td>NAVYA DALAL</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>25</td>
                                                        <td>NAMAN GUPTA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>26</td>
                                                        <td>NISHKA SAXENA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>27</td>
                                                        <td>RUDRANSH SINGH</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>28</td>
                                                        <td>SARTHAK JAIN</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>29</td>
                                                        <td>SHAURYA SEHRA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>30</td>
                                                        <td>SHRADHA MIGLANI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>31</td>
                                                        <td>TANVI WASON</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>32</td>
                                                        <td>ANNANYA BAJAJ</td>
                                                        <td rowspan="10">KAVERI</td>
                                                        <td rowspan="10">INDUS</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>33</td>
                                                        <td>HANEEKA MODI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>34</td>
                                                        <td>HARLEEN KAUR</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>35</td>
                                                        <td>HARSHIL GUPTA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>36</td>
                                                        <td>JAY SINGH</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>37</td>
                                                        <td>JESSICA SINGH</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>38</td>
                                                        <td>SHIVANK NOHWAL</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>39</td>
                                                        <td>SHOBIT GALHOTRA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>40</td>
                                                        <td>VANIA JALAN</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>41</td>
                                                        <td>VIVAAN BANERJEE</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>42</td>
                                                        <td>AANYA MITTAL</td>
                                                        <td rowspan="10">NARMADA</td>
                                                        <td rowspan="10">RAVI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>43</td>
                                                        <td>AARNA SHARMA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>44</td>
                                                        <td>ANGEL GOMES</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>45</td>
                                                        <td>ANIRUDDHA BHATTACHARYA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>46</td>
                                                        <td>NANDINI GUPTA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>47</td>
                                                        <td>NAVNOOR KAUR</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>48</td>
                                                        <td>PRAGNAY SHARMA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>49</td>
                                                        <td>PRATEEK SINHA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>50</td>
                                                        <td>RIDDHI MANOCHA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>51</td>
                                                        <td>VIDHI VASHISTH</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>52</td>
                                                        <td>ADVIK MEHTA</td>
                                                        <td rowspan="13">NILE</td>
                                                        <td rowspan="13">RHINE</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>53</td>
                                                        <td>ADVIKA JAIN</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>54</td>
                                                        <td>ADWAY GUPTA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>55</td>
                                                        <td>ANAV SHAH</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>56</td>
                                                        <td>ARJUN MITTAL</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>57</td>
                                                        <td>ATHARV KUMAR</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>58</td>
                                                        <td>DISHA BUDHIRAJA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>59</td>
                                                        <td>KYESHA DEORANI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>60</td>
                                                        <td>PALAK BHANDARI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>61</td>
                                                        <td>PRATIVINDHYA SINGH</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>62</td>
                                                        <td>TVESHA YADAV</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>63</td>
                                                        <td>VADANYA CHATURVEDI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>64</td>
                                                        <td>VIHAAN ARORA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>65</td>
                                                        <td>STAVYA KHURANA</td>
                                                        <td>KAVERI</td>
                                                        <td>VOLGA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>66</td>
                                                        <td>AARAV ANAND</td>
                                                        <td rowspan="13">SUTLEJ</td>
                                                        <td rowspan="13">VOLGA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>67</td>
                                                        <td>AARAV SINHA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>68</td>
                                                        <td>AGASTYA TRIKHA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>69</td>
                                                        <td>ARCHIT SAHNI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>70</td>
                                                        <td>DIVA JOHN</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>71</td>
                                                        <td>KHUSHI JOSHI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>72</td>
                                                        <td>KRISHIV KHANNA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>73</td>
                                                        <td>MEHER SETIA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>74</td>
                                                        <td>REYNA UPADHYAY</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>75</td>
                                                        <td>SURYA KHURANA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>76</td>
                                                        <td>SVASTI BORA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>77</td>
                                                        <td>TASHVI VIRMANI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>78</td>
                                                        <td>TOSHANI GAUR</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>79</td>
                                                        <td>AADYA SAXENA</td>
                                                        <td rowspan="16">THAMES</td>
                                                        <td rowspan="16">YAMUNA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>80</td>
                                                        <td>AAHNA GULATI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>81</td>
                                                        <td>AANYA SAHANI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>82</td>
                                                        <td>ADITI KUMAR</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>83</td>
                                                        <td>AHAAN PORWAL</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>84</td>
                                                        <td>ARHAN ATTRI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>85</td>
                                                        <td>ARYAN GULATI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>86</td>
                                                        <td>ASHMI MONGA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>87</td>
                                                        <td>ATHARV V GUPTA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>88</td>
                                                        <td>DIYA GERA</td>
                                                        <td>2019 -20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>89</td>
                                                        <td>KASHIKA GUPTA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>90</td>
                                                        <td>SAARVIN SINGHAL</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>91</td>
                                                        <td>SARANYA JAGGI</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>92</td>
                                                        <td>SHARANYA SINGH</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>93</td>
                                                        <td>SRISHTI BAKLIWAL</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>94</td>
                                                        <td>TAASHVI KAPOOR</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="7">TOTAL SCHOLARS IN GRADE VII (2019-20) =&nbsp; 94&nbsp; - 1 withdrawal = 93</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Pink Badges</td>
                                                        <td>94</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Grey Pockets</td>
                                                        <td>94</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td>COMPARATIVE ANALYSIS</td>
                                                        <td>2018-19</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td>Total Strength</td>
                                                        <td>195</td>
                                                        <td>231</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td>Scholars</td>
                                                        <td>55</td>
                                                        <td>94</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>%</td>
                                                        <td>28.2</td>
                                                        <td>40.7</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <th colspan="7">DETAILS FOR THE SCHOLAR CERTIFICATES : GRADE VII (2019-20)</th>
                                                    </tr>
                                                    <tr>
                                                        <th colspan="7">Aggregate 90%</th>
                                                    </tr>
                                                    <tr>
                                                        <th rowspan="2">S.N.</th>
                                                        <th rowspan="2">NAMES</th>
                                                        <th rowspan="2">GRADE - VII (2019-20)</th>
                                                        <th rowspan="2">GRADE - VIII (2020-21)</th>
                                                        <th rowspan="2">SESSIONS</th>
                                                        <th colspan="2">SCHOLAR STATUS</th>
                                                    </tr>
                                                    <tr>
                                                        <td>BADGE</td>
                                                        <td>POCKET</td>
                                                    </tr>
                                                    <tr>
                                                        <td>1</td>
                                                        <td>ADITYA PRAKASH</td>
                                                        <td rowspan="8">CHENAB</td>
                                                        <td rowspan="8">AMAZON</td>
                                                        <td>2019-20,2018-19, 2017-18</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>2</td>
                                                        <td>ARNAV GUPTA</td>
                                                        <td>2019-20,2018-19, 2017-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>3</td>
                                                        <td>DEVANSH SHARMA</td>
                                                        <td>2019-20,2018-19, 2017-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>4</td>
                                                        <td>MRRIDUL SESHADRI</td>
                                                        <td>2019-20,2018-19, 2017-21</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>5</td>
                                                        <td>PARIDHI GARG</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>6</td>
                                                        <td>PRATHAM SETHI</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>7</td>
                                                        <td>VANSH SRIVASTAVA</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>8</td>
                                                        <td>VIDITA SINGH ATRI</td>
                                                        <td>2019-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>9</td>
                                                        <td>AAIRA KATOCH</td>
                                                        <td rowspan="7">COLORADO</td>
                                                        <td rowspan="7">BRAHMAPUTRA</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>10</td>
                                                        <td>DHRUV RASTOGI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>11</td>
                                                        <td>KESHAVA P PRASAD</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>12</td>
                                                        <td>MAANYA RAJPUT</td>
                                                        <td>2019-20, 2018-19, 2017-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>13</td>
                                                        <td>MAHUA JAIN</td>
                                                        <td>2019-20, 2018-19, 2017-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>14</td>
                                                        <td>MEGHA ANAND</td>
                                                        <td>2019-20, 2018-19, 2017-21</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>15</td>
                                                        <td>NISHKA CHOPRA</td>
                                                        <td>2019-20, 2018-19, 2017-22</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>16</td>
                                                        <td>PRANYA ARORA</td>
                                                        <td rowspan="4">INDUS</td>
                                                        <td rowspan="4">DANUBE</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>17</td>
                                                        <td>SAYESHA JAIN</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>18</td>
                                                        <td>SHAURYA BANSAL</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>19</td>
                                                        <td>SHREYA SETHI</td>
                                                        <td>2019-20, 2018-19, 2017-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>20</td>
                                                        <td>AISHIKA CHADHA</td>
                                                        <td rowspan="6">RAVI</td>
                                                        <td rowspan="6">JHELUM</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>21</td>
                                                        <td>AYUSH KHANDELWAL</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>22</td>
                                                        <td>DHRUVIKAA D REDDY</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>23</td>
                                                        <td>GAURI AGARWAL</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>24</td>
                                                        <td>KANIKA DEV</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>25</td>
                                                        <td>SHREYANS BHARGAVA</td>
                                                        <td>2018-19, 2017-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>26</td>
                                                        <td>ADITYA JAIN</td>
                                                        <td rowspan="10">RHINE</td>
                                                        <td rowspan="10">MAHANADI</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>27</td>
                                                        <td>AKSHAT JAIN</td>
                                                        <td>2019-20, 2018-19, 2017-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>28</td>
                                                        <td>ANISHA GUPTA</td>
                                                        <td>2019-20, 2018-19, 2017-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>29</td>
                                                        <td>MAANSI SINGH</td>
                                                        <td>2019-20, 2018-19, 2017-21</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>30</td>
                                                        <td>MAMILLA SAI ROHAN</td>
                                                        <td>2019-20, 2018-19, 2017-22</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>31</td>
                                                        <td>MIHIKAA SINGH</td>
                                                        <td>2019-20, 2018-19, 2017-23</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>32</td>
                                                        <td>RADHA HINGNE</td>
                                                        <td>2019-20, 2018-19, 2017-24</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>33</td>
                                                        <td>SAGAR AGGARWAL</td>
                                                        <td>2018-19, 2017-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>34</td>
                                                        <td>SHAURYA SHARMA</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>35</td>
                                                        <td>S SHREENIDHI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>36</td>
                                                        <td>ANGEL KHANNA</td>
                                                        <td rowspan="9">VOLGA</td>
                                                        <td rowspan="9">MISSISSIPPI</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>37</td>
                                                        <td>ARINJAY JAIN</td>
                                                        <td>2019-20, 2018-19, 2017-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>38</td>
                                                        <td>HITANSHI AGGARWAL</td>
                                                        <td>2019-20, 2018-19, 2017-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>39</td>
                                                        <td>MAHIRA KOHLI</td>
                                                        <td>2019-20, 2018-19, 2017-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>40</td>
                                                        <td>REYANSH AGARWAL</td>
                                                        <td>2019-20, 2018-19, 2017-21</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>41</td>
                                                        <td>RONAN VIKRAM SINGH</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>42</td>
                                                        <td>SANCHIT CHHAMUNYA</td>
                                                        <td>2019-20, 2018-19, 2017-21</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>43</td>
                                                        <td>SARA GUPTA</td>
                                                        <td>2019-20, 2018-19, 2017-22</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>44</td>
                                                        <td>VIHAAN MEHROTRA</td>
                                                        <td>2019-20, 2018-19, 2017-23</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>45</td>
                                                        <td>HARSHITA BUGALIA</td>
                                                        <td rowspan="8">YAMUNA</td>
                                                        <td>MISSISSIPPI</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>46</td>
                                                        <td>ANTRIKSH GUPTA</td>
                                                        <td rowspan="7">TAPTI</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>47</td>
                                                        <td>ARNAV WADHWA</td>
                                                        <td>2019-20, 2018-19, 2017-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>48</td>
                                                        <td>ARYA JAIN</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>49</td>
                                                        <td>PARNIKA CHANDRA</td>
                                                        <td>2019-20, 2018-19, 2017-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>50</td>
                                                        <td>SHAURYA SINGH</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>51</td>
                                                        <td>SHIRANI ANAND</td>
                                                        <td>2019-20</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>52</td>
                                                        <td>SYED AZHAAN ABBAS RIZVI</td>
                                                        <td>2019-20, 2018-19, 2017-19</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td colspan="6">TOTAL SCHOLARS IN GRADE VIII (2019-20) =&nbsp; 68 - 2 withdrawal = 66</td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td>Pink Badges</td>
                                                        <td>52</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td>Grey Pockets</td>
                                                        <td>52</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>COMPARATIVE ANALYSIS</td>
                                                        <td>2018-19</td>
                                                        <td>2019-20</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Total Strength</td>
                                                        <td>193</td>
                                                        <td>201</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Scholars</td>
                                                        <td>69</td>
                                                        <td>52</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>%</td>
                                                        <td>35.8</td>
                                                        <td>25.9</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </tbody></table>
                                            <table cellspacing="0" cellpadding="0">
                                                <tbody><tr>
                                                    <th colspan="8">DETAILS FOR THE SCHOLAR CERTIFICATES : GRADE VIII (2019-20)</th>
                                                </tr>
                                                    <tr>
                                                        <th colspan="8">Aggregate 90%</th>
                                                    </tr>
                                                    <tr>
                                                        <th rowspan="2">S.N.</th>
                                                        <th rowspan="2">NAMES</th>
                                                        <th rowspan="2">GRADE -VIII&nbsp; (2019-20)</th>
                                                        <th rowspan="2">GRADE - IX&nbsp;(2020-21)</th>
                                                        <th rowspan="2">SESSIONS</th>
                                                        <th colspan="3">SCHOLAR STATUS</th>
                                                    </tr>
                                                    <tr>
                                                        <td>BLAZER</td>
                                                        <td>BADGE</td>
                                                        <td>POCKET</td>
                                                    </tr>
                                                    <tr>
                                                        <td>1</td>
                                                        <td>AARAV NAVANI</td>
                                                        <td rowspan="11">AMAZON</td>
                                                        <td>NILGIRIS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>2</td>
                                                        <td>ANYA GOYAL</td>
                                                        <td>ARAVALLIS</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>3</td>
                                                        <td>ANYA GUPTA</td>
                                                        <td>NILGIRIS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>4</td>
                                                        <td>ASHMIT KHETERPAL</td>
                                                        <td>NILGIRIS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>5</td>
                                                        <td>GARV AGARWAL</td>
                                                        <td>ARAVALLIS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>6</td>
                                                        <td>JIYA MAHAJAN</td>
                                                        <td>ARAVALLIS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>7</td>
                                                        <td>NYESA JAIN</td>
                                                        <td>ARAVALLIS</td>
                                                        <td>&nbsp;2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>8</td>
                                                        <td>PRISHA KHANNA</td>
                                                        <td>ARAVALLIS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>9</td>
                                                        <td>JIYA WALIA</td>
                                                        <td>ARAVALLIS</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>10</td>
                                                        <td>TANISHA SRIVASTAVA</td>
                                                        <td>ARAVALLIS</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>11</td>
                                                        <td>UTKARSH SINGH</td>
                                                        <td>ARAVALLIS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>12</td>
                                                        <td>AARAV GARG</td>
                                                        <td rowspan="9">BRAHMAPUTRA</td>
                                                        <td>EVEREST</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>13</td>
                                                        <td>ADITYA SINGH RAJPUROHIT</td>
                                                        <td>EVEREST</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>14</td>
                                                        <td>GITANJALI SINGH ATRI</td>
                                                        <td>EVEREST</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>15</td>
                                                        <td>ISHAAN CHHABRA</td>
                                                        <td>EVEREST</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>16</td>
                                                        <td>RYAN PURI</td>
                                                        <td>NILGIRIS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>17</td>
                                                        <td>SAANVI DAS</td>
                                                        <td>EVEREST</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>18</td>
                                                        <td>SHAURYA AGARWAL</td>
                                                        <td>EVEREST</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>19</td>
                                                        <td>SUHANI YADAV</td>
                                                        <td>EVEREST</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>20</td>
                                                        <td>TEJAL DOSHI</td>
                                                        <td>NILGIRIS</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>21</td>
                                                        <td>ANUSHKA JAIN</td>
                                                        <td rowspan="7">DANUBE</td>
                                                        <td>EVEREST</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>22</td>
                                                        <td>CHAITANYA GUPTA</td>
                                                        <td>VINDHYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>23</td>
                                                        <td>KATYA SOOD</td>
                                                        <td>VINDHYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>24</td>
                                                        <td>NAVYA AGARWAL</td>
                                                        <td>HIMALAYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>25</td>
                                                        <td>NAVYA SINGHAL</td>
                                                        <td>HIMALAYAS</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>26</td>
                                                        <td>NIA RANJAN</td>
                                                        <td>HIMALAYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>27</td>
                                                        <td>RITISHA MEHROTRA</td>
                                                        <td>HIMALAYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>28</td>
                                                        <td>ADITYA SUNDARAM</td>
                                                        <td rowspan="6">JHELUM</td>
                                                        <td>SHIVALIKS</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>29</td>
                                                        <td>AMULYAA KASHYAP</td>
                                                        <td>ARAVALLIS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>30</td>
                                                        <td>ARNAV GUPTA (TC)</td>
                                                        <td>&nbsp;</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>31</td>
                                                        <td>JAIADITYA RATHORE</td>
                                                        <td>SHIVALIKS</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>32</td>
                                                        <td>KRIPA KAUR</td>
                                                        <td>VINDHYAS</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>33</td>
                                                        <td>SAKSHAM JAIN</td>
                                                        <td>ARAVALLIS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>34</td>
                                                        <td>AARZOO KAPOOR</td>
                                                        <td rowspan="9">MAHANADI</td>
                                                        <td>KANCHENJUNGA</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>35</td>
                                                        <td>ADITI PANT</td>
                                                        <td>KANCHENJUNGA</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>36</td>
                                                        <td>ANANYA SALUJA</td>
                                                        <td>KANCHENJUNGA</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>37</td>
                                                        <td>ARAV MATHUR</td>
                                                        <td>EVEREST</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>38</td>
                                                        <td>ISHIKA MAHAJAN</td>
                                                        <td>KANCHENJUNGA</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>39</td>
                                                        <td>KSHITIJ VERMA</td>
                                                        <td>KANCHENJUNGA</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>40</td>
                                                        <td>RAHAT KAURA</td>
                                                        <td>KANCHENJUNGA</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>41</td>
                                                        <td>SHAURYA GUPTA</td>
                                                        <td>KANCHENJUNGA</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>42</td>
                                                        <td>TAMANNA KAPOOR</td>
                                                        <td>KANCHENJUNGA</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>43</td>
                                                        <td>ANANYA SIROHI</td>
                                                        <td rowspan="11">MISSISSIPPI</td>
                                                        <td>HIMALAYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>44</td>
                                                        <td>DHRUV KUMAR</td>
                                                        <td>NILGIRIS</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>45</td>
                                                        <td>KASHIKA SHRIVASTAVA (TC)</td>
                                                        <td>&nbsp;</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>46</td>
                                                        <td>KYNA CHAUDHARY</td>
                                                        <td>VINDHYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>47</td>
                                                        <td>MANNAN RANA</td>
                                                        <td>HIMALAYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>48</td>
                                                        <td>NAVYA LAKHOTIA</td>
                                                        <td>NILGIRIS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>49</td>
                                                        <td>NAVYA NANDINI DHODY</td>
                                                        <td>VINDHYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>50</td>
                                                        <td>PARTH AHUJA</td>
                                                        <td>VINDHYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>51</td>
                                                        <td>PRANJAL SHARMA</td>
                                                        <td>NILGIRIS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>52</td>
                                                        <td>SAANVI HORA</td>
                                                        <td>HIMALAYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>53</td>
                                                        <td>RAGHAV BANSAL</td>
                                                        <td>HIMALAYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>54</td>
                                                        <td>AADYA JAIN</td>
                                                        <td rowspan="15">TAPTI</td>
                                                        <td>KANCHENJUNGA</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>55</td>
                                                        <td>AARAV GHAI</td>
                                                        <td>KANCHENJUNGA</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>56</td>
                                                        <td>ANANDINI AGRAWAL</td>
                                                        <td>VINDHYAS</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>57</td>
                                                        <td>AVIRAJ GOYLE</td>
                                                        <td>VINDHYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>58</td>
                                                        <td>GAYATRI VEER</td>
                                                        <td>VINDHYAS</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>59</td>
                                                        <td>LAKSHYA AGARWAL</td>
                                                        <td>SHIVALIKS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>60</td>
                                                        <td>MADHAV MALHAN</td>
                                                        <td>VINDHYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>61</td>
                                                        <td>NYSA H. VAID</td>
                                                        <td>KANCHENJUNGA</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>62</td>
                                                        <td>PRACHI CHOPRA</td>
                                                        <td>VINDHYAS</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>63</td>
                                                        <td>PRIYADARSHINI GHOSH</td>
                                                        <td>VINDHYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>64</td>
                                                        <td>SAUMYA BABBAR</td>
                                                        <td>VINDHYAS</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>65</td>
                                                        <td>SHOURYA VEER</td>
                                                        <td>KANCHENJUNGA</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>66</td>
                                                        <td>TISHIA KATOCH</td>
                                                        <td>KANCHENJUNGA</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>67</td>
                                                        <td>VINAYAK MALHOTRA</td>
                                                        <td>KANCHENJUNGA</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>68</td>
                                                        <td>YASH VERMA</td>
                                                        <td>VINDHYAS</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>39</td>
                                                        <td>68</td>
                                                        <td>29</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td colspan="6">TOTAL SCHOLARS IN GRADE VIII (2019-20) =&nbsp; 68 - 2 withdrawal = 66</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Pink Badges</td>
                                                        <td>68</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Grey Pockets</td>
                                                        <td>29</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Blue Blazers</td>
                                                        <td>39</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>COMPARATIVE ANALYSIS</td>
                                                        <td>2018-19</td>
                                                        <td>2019-20</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Total Strength</td>
                                                        <td>155</td>
                                                        <td>201</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Scholars</td>
                                                        <td>43</td>
                                                        <td>68</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>%</td>
                                                        <td>28</td>
                                                        <td>33.8</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </tbody></table>
                                            <table cellspacing="0" cellpadding="0">
                                                <tbody><tr>
                                                    <td colspan="10">DETAILS FOR THE SCHOLAR CERTIFICATES (2019-20) : GRADE X</td>
                                                </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <th colspan="10">CRITERIA:&nbsp; 85% and above</th>
                                                    </tr>
                                                    <tr>
                                                        <th rowspan="2">S.N.</th>
                                                        <th rowspan="2">NAME</th>
                                                        <th rowspan="2">GRADE -X&nbsp;(2019-20)</th>
                                                        <th rowspan="2">GRADE - XI&nbsp;(2020-21)</th>
                                                        <th rowspan="2"> %</th>
                                                        <th rowspan="2">SESSIONS</th>
                                                        <th colspan="4">STATUS</th>
                                                    </tr>
                                                    <tr>
                                                        <td>SCHOLAR</td>
                                                        <td>BLAZER</td>
                                                        <td>BADGE</td>
                                                        <td>POCKET</td>
                                                    </tr>
                                                    <tr>
                                                        <td>1</td>
                                                        <td>AKSHITA SHARMA</td>
                                                        <td rowspan="19">ALPS</td>
                                                        <td>SHAKESPEARE</td>
                                                        <td>89.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>2</td>
                                                        <td>ARCHIT SHARMA</td>
                                                        <td>EINSTEIN</td>
                                                        <td>95.4</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>3</td>
                                                        <td>ARYAN MANN</td>
                                                        <td>WITHDRAWAL</td>
                                                        <td>94</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>4</td>
                                                        <td>AYUSH DAS GUPTA</td>
                                                        <td>WITHDRAWAL</td>
                                                        <td>95</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>5</td>
                                                        <td>DIYA TRIPATHI</td>
                                                        <td>EINSTEIN</td>
                                                        <td>95</td>
                                                        <td>2019-20, 2017-18, 2015-16, 2014-15</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>6</td>
                                                        <td>ISHIKA ARORA</td>
                                                        <td>DALTON</td>
                                                        <td>87</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>7</td>
                                                        <td>JALAJ YADAV</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>95.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>8</td>
                                                        <td>LOVISH CHOUDHARY</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>94</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>9</td>
                                                        <td>NIHAL KALER</td>
                                                        <td>EINSTEIN</td>
                                                        <td>87.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>10</td>
                                                        <td>PALAK KABRA</td>

                                                        <td>ARISTOTLE</td>
                                                        <td>96.2</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>11</td>
                                                        <td>PRANAY GOEL</td>
                                                        <td>EINSTEIN</td>
                                                        <td>95.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>12</td>
                                                        <td>RASHI CHAUHAN</td>
                                                        <td>SHAKESPEARE</td>
                                                        <td>93.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>13</td>
                                                        <td>RIYA SUHAG</td>
                                                        <td>EINSTEIN</td>
                                                        <td>85</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>14</td>
                                                        <td>SAKSHAM GUPTA</td>
                                                        <td>EINSTEIN</td>
                                                        <td>90</td>
                                                        <td>2019-20, 2015-16, 2013-14</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>15</td>
                                                        <td>SARAH MAHESHWARI</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>87.4</td>
                                                        <td>2019-20, 2015-16</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>16</td>
                                                        <td>SHIVIKA PANDEY</td>
                                                        <td>SHAKESPEARE</td>
                                                        <td>96.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>17</td>
                                                        <td>SUHANI VALECHA</td>
                                                        <td>DALTON</td>
                                                        <td>90.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>18</td>
                                                        <td>TUSHIT KAPUR</td>
                                                        <td>WITHDRAWAL</td>
                                                        <td>93.4</td>
                                                        <td>2019-20, 2018-19, 2017-18,2016-17, 2015-16, 2014-15</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>19</td>
                                                        <td>YUVRAJ MANN</td>
                                                        <td>SHAKESPEARE</td>
                                                        <td>86</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>20</td>
                                                        <td>ABHAY VERMA</td>
                                                        <td rowspan="19">ANDES&nbsp;</td>
                                                        <td>EINSTEIN</td>
                                                        <td>95.8</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>21</td>
                                                        <td>ANIRUDH RATHOD</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>91.8</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>22</td>
                                                        <td>ARCHIT CHOPRA</td>
                                                        <td>EINSTEIN</td>
                                                        <td>90.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>23</td>
                                                        <td>DHANUR CHAHAL</td>
                                                        <td>EINSTEIN</td>
                                                        <td>93.6</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>24</td>
                                                        <td>DHRUV MADHOK</td>
                                                        <td>KEYNES</td>
                                                        <td>87.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>25</td>
                                                        <td>DIYA GUPTA</td>
                                                        <td>SHAKESPEARE</td>
                                                        <td>85.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>26</td>
                                                        <td>ESHAAN ARYAN SINHA</td>
                                                        <td>EINSTEIN</td>
                                                        <td>94.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>27</td>
                                                        <td>GAYATRI VARMA</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>96.8</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>28</td>
                                                        <td>KHUSHI SATNALIWALA</td>
                                                        <td>DALTON</td>
                                                        <td>95.8</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>29</td>
                                                        <td>LORD LUGANI</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>88.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>30</td>
                                                        <td>NIPUN YADAV</td>
                                                        <td>EINSTEIN</td>
                                                        <td>97</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>31</td>
                                                        <td>PRATYUSH PURWAR</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>92.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>32</td>
                                                        <td>ROLI AGGARWAL</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>97.8</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>33</td>
                                                        <td>SAMYAK YASH JAIN</td>
                                                        <td>SHAKESPEARE</td>
                                                        <td>91.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>34</td>
                                                        <td>SIDDHARTH MISHRA</td>
                                                        <td>EINSTEIN</td>
                                                        <td>95.6</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>35</td>
                                                        <td>SPARSH GUPTA</td>
                                                        <td>DALTON</td>
                                                        <td>85.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>36</td>
                                                        <td>TAMANNA NAGPAL</td>
                                                        <td>SHAKESPEARE</td>
                                                        <td>85.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>37</td>
                                                        <td>TANUSH YADAV</td>
                                                        <td>EINSTEIN</td>
                                                        <td>94.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>38</td>
                                                        <td>VANSHIKA SINGH</td>
                                                        <td>DALTON</td>
                                                        <td>91.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>39</td>
                                                        <td>AADITYA KUMAR</td>
                                                        <td rowspan="17">ELBERT</td>
                                                        <td>KEYNES</td>
                                                        <td>91.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>40</td>
                                                        <td>ANUSHKA BANSAL</td>
                                                        <td>SHAKESPEARE</td>
                                                        <td>95.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>41</td>
                                                        <td>ARNAV GARG</td>
                                                        <td>EDISON</td>
                                                        <td>92.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>42</td>
                                                        <td>DHRITI AGARWAL</td>
                                                        <td>KEYNES</td>
                                                        <td>88.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>43</td>
                                                        <td>DIVANSHIE SUMIT SETIA</td>
                                                        <td>EDISON</td>
                                                        <td>96.4</td>
                                                        <td>2019-20,2018-19, 2017-18, 2016-17</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>44</td>
                                                        <td>GAURANGI OBEROI</td>
                                                        <td>SHAKESPEARE</td>
                                                        <td>85.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>45</td>
                                                        <td>KAVYA SONDHI</td>
                                                        <td>EDISON</td>
                                                        <td>94.2</td>
                                                        <td>2019-20,2018-19&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>46</td>
                                                        <td>MANBHAV SUGLA</td>
                                                        <td>EDISON</td>
                                                        <td>93.4</td>
                                                        <td>2019-20,2018-19&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>47</td>
                                                        <td>NANDINI SINGH</td>
                                                        <td>KEYNES</td>
                                                        <td>93.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>48</td>
                                                        <td>NISHA BARBUDDHE</td>
                                                        <td>DALTON</td>
                                                        <td>90.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>49</td>
                                                        <td>RIDDHI MAHESHWARI</td>
                                                        <td>KEYNES</td>
                                                        <td>86.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>50</td>
                                                        <td>RIYA RAWAL</td>
                                                        <td>EDISON</td>
                                                        <td>95.8</td>
                                                        <td>2019-20,2018-19, 2017-18</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>51</td>
                                                        <td>SARMATHA R.</td>
                                                        <td>KEYNES</td>
                                                        <td>95.8</td>
                                                        <td>2019-20,2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>52</td>
                                                        <td>SRISHTI MAKKAR</td>
                                                        <td>DALTON</td>
                                                        <td>92</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>53</td>
                                                        <td>SYNA GOGIA</td>
                                                        <td>LEFT SCHOOL</td>
                                                        <td>89.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>54</td>
                                                        <td>TANISHQ GUPTA</td>
                                                        <td>EDISON</td>
                                                        <td>92.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>55</td>
                                                        <td>TIYA GUPTA</td>
                                                        <td>KEYNES</td>
                                                        <td>89</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>56</td>
                                                        <td>ADITYA VERMA</td>
                                                        <td rowspan="18">ELBRUS</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>88</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>57</td>
                                                        <td>ARAV KUMAR</td>
                                                        <td>WITHDRAWAL</td>
                                                        <td>95.8</td>
                                                        <td>2019-20,2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>58</td>
                                                        <td>ARUNAKSH KAPOOR</td>
                                                        <td>EDISON</td>
                                                        <td>96.8</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>59</td>
                                                        <td>ARUSHI BANERJEE</td>
                                                        <td>SHAKESPEARE</td>
                                                        <td>94.6</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>60</td>
                                                        <td>HRIDAY GULATI</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>94.4</td>
                                                        <td>2019-20,2018-17,2017-16,016-15,2015-14,2014-13.</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>61</td>
                                                        <td>INHAAS VIRMANI</td>
                                                        <td>EDISON</td>
                                                        <td>97.8</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>62</td>
                                                        <td>IRA VIKRAM KHER</td>
                                                        <td>EDISON</td>
                                                        <td>95</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>63</td>
                                                        <td>KHYATI PRASAD</td>
                                                        <td>DALTON</td>
                                                        <td>93.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>64</td>
                                                        <td>MEHMA SINGH AHLUWALIA</td>
                                                        <td>SHAKESPEARE</td>
                                                        <td>88.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>65</td>
                                                        <td>PANSHUL JETWANI</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>87.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>66</td>
                                                        <td>PRERNA SEJWAL</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>87.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>67</td>
                                                        <td>RIYA KUMAR</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>87.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>68</td>
                                                        <td>SARISHA JAGGI</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>93.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>69</td>
                                                        <td>SHEEN NAGRI</td>
                                                        <td>EDISON</td>
                                                        <td>92.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>70</td>
                                                        <td>SIYA KHATTAR</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>87</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>71</td>
                                                        <td>STUTI SINGHAL</td>
                                                        <td>EDISON</td>
                                                        <td>88.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>72</td>
                                                        <td>TITHI SARKAR</td>
                                                        <td>DALTON</td>
                                                        <td>93</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>73</td>
                                                        <td>UTKARSH MISRA</td>
                                                        <td>EDISON</td>
                                                        <td>96.2</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>74</td>
                                                        <td>ADRIJA DE</td>
                                                        <td rowspan="21">FUJI&nbsp;</td>
                                                        <td>KEYNES</td>
                                                        <td>95.8</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>75</td>
                                                        <td>ANAND KRIPAL AGGARWAL</td>
                                                        <td>EDISON</td>
                                                        <td>96</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>76</td>
                                                        <td>ANNAHITA RATHI</td>
                                                        <td>KEYNES</td>
                                                        <td>91.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>77</td>
                                                        <td>ASVIKA NIGAM</td>
                                                        <td>DALTON</td>
                                                        <td>96.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>78</td>
                                                        <td>DIVIJ BHAMBHANI</td>
                                                        <td>EDISON</td>
                                                        <td>94.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>79</td>
                                                        <td>HARSHIT GOYAL</td>
                                                        <td>WITHDRAWAL</td>
                                                        <td>95</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>80</td>
                                                        <td>ISHANI SINGH</td>
                                                        <td>SHAKESPEARE</td>
                                                        <td>90.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>81</td>
                                                        <td>JIVESH MEHTA</td>
                                                        <td>EDISON</td>
                                                        <td>91</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>82</td>
                                                        <td>KRISHIV GARG</td>
                                                        <td>WITHDRAWAL</td>
                                                        <td>90.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>83</td>
                                                        <td>MADHAV PRATAP SINGH</td>
                                                        <td>EDISON</td>
                                                        <td>86</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>84</td>
                                                        <td>MAMILLA SAI NAYAN</td>
                                                        <td>WITHDRAWAL</td>
                                                        <td>94.2</td>
                                                        <td>2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>85</td>
                                                        <td>MEHAK CHAWLA</td>
                                                        <td>SHAKESPEARE</td>
                                                        <td>88.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>86</td>
                                                        <td>PARTH PIYUSH PRASAD</td>
                                                        <td>SHAKESPEARE</td>
                                                        <td>97.4</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>87</td>
                                                        <td>PRARABDHA HALDER</td>
                                                        <td>EDISON</td>
                                                        <td>96.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>88</td>
                                                        <td>RAJ KASERA</td>
                                                        <td>EDISON</td>
                                                        <td>90.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>89</td>
                                                        <td>RANA YUVRAJ</td>
                                                        <td>WITHDRAWAL</td>
                                                        <td>96</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>90</td>
                                                        <td>SHREYA BAJAJ</td>
                                                        <td>WITHDRAWAL</td>
                                                        <td>92.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>91</td>
                                                        <td>SNEHAL JAISWAL</td>
                                                        <td>WITHDRAWAL</td>
                                                        <td>98.4</td>
                                                        <td>2019-20, 2018-19,2017-18,2016-17, 2015-16, 2014-15, 2013-14</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>92</td>
                                                        <td>TANVI CHAND</td>
                                                        <td>SHAKESPEARE</td>
                                                        <td>94.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>93</td>
                                                        <td>YASHIKA GUPTA</td>
                                                        <td>KEYNES</td>
                                                        <td>87.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>94</td>
                                                        <td>YASHITA AGARWAL</td>
                                                        <td>KEYNES</td>
                                                        <td>97.6</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>95</td>
                                                        <td>AKSHAJ BHARDWAJ&nbsp;</td>
                                                        <td rowspan="25">OLYMPUS</td>
                                                        <td>WITHDRAWAL</td>
                                                        <td>94.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>96</td>
                                                        <td>AMITESH ANAND PANDEY&nbsp;</td>
                                                        <td>EINSTEIN</td>
                                                        <td>97.8</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>97</td>
                                                        <td>ANANYA JAIN&nbsp;</td>
                                                        <td>EDISON</td>
                                                        <td>98.4</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>98</td>
                                                        <td>ANANYA MALIK</td>
                                                        <td>DALTON</td>
                                                        <td>94.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>99</td>
                                                        <td>ANINDYA MISHRA&nbsp;</td>
                                                        <td>EINSTEIN</td>
                                                        <td>98.6</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>100</td>
                                                        <td>ANJALI TYAGI&nbsp;</td>
                                                        <td>DALTON</td>
                                                        <td>97.6</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>101</td>
                                                        <td>ARADHYA MISHRA&nbsp;</td>
                                                        <td>DALTON</td>
                                                        <td>96.6</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>102</td>
                                                        <td>AVISHI MONGA&nbsp;</td>
                                                        <td>DALTON</td>
                                                        <td>98.6</td>
                                                        <td>2019-20, 2018-19, 2017-18,2016-17, 2015-16, 2014-15, 2013-14</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>103</td>
                                                        <td>DHRUV GOEL&nbsp;</td>
                                                        <td>DALTON</td>
                                                        <td>94.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>104</td>
                                                        <td>DIVYALAKSHMI SINGH&nbsp;</td>
                                                        <td>DALTON</td>
                                                        <td>92.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>105</td>
                                                        <td>FREYA SIDHWA</td>
                                                        <td>EDISON</td>
                                                        <td>94.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>106</td>
                                                        <td>HIBAH SHARMA&nbsp;</td>
                                                        <td>KEYNES</td>
                                                        <td>88.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>107</td>
                                                        <td>ISHAAN KONWAR SAIKIA&nbsp;</td>
                                                        <td>EINSTEIN</td>
                                                        <td>88.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>108</td>
                                                        <td>ISHAAN VATUS&nbsp;</td>
                                                        <td>EINSTEIN</td>
                                                        <td>93.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>109</td>
                                                        <td>MAITHILI DUBEY&nbsp;</td>
                                                        <td>WITHDRAWAL</td>
                                                        <td>94.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>110</td>
                                                        <td>MANAS JAIN&nbsp;</td>
                                                        <td>KEYNES</td>
                                                        <td>87.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>111</td>
                                                        <td>MAYANK KATARIA&nbsp;</td>
                                                        <td>KEYNES</td>
                                                        <td>92.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>112</td>
                                                        <td>RISHAB JAIN&nbsp;</td>
                                                        <td>ARISTOTLE</td>
                                                        <td>92.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>113</td>
                                                        <td>RISHITA MAKDE&nbsp;</td>
                                                        <td>WITHDRAWAL</td>
                                                        <td>99.2</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-2015</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>114</td>
                                                        <td>SAAGARIKA GAHLOT&nbsp;</td>
                                                        <td>KEYNES</td>
                                                        <td>96</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>115</td>
                                                        <td>SARISHA NOWAL&nbsp;</td>
                                                        <td>WITHDRAWAL</td>
                                                        <td>98.2</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>116</td>
                                                        <td>TANYA GUPTA&nbsp;</td>
                                                        <td>WITHDRAWAL</td>
                                                        <td>97.8</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>117</td>
                                                        <td>TANYA VIG&nbsp;</td>
                                                        <td>KEYNES</td>
                                                        <td>89.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>118</td>
                                                        <td>VIDIT YADUVANSHI&nbsp;</td>
                                                        <td>EDISON</td>
                                                        <td>93.2</td>
                                                        <td>2019-20, 2014-15, 2015-16</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>119</td>
                                                        <td>VIKRAMADITYA YADAV&nbsp;</td>
                                                        <td>DALTON</td>
                                                        <td>96.8</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="10">TOTAL SCHOLARS IN GRADE X (2019-20) =&nbsp; 119</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td>Pink Badges</td>
                                                        <td>&nbsp;</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>Total Strength</td>
                                                        <td>143</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td>Blue Badges</td>
                                                        <td>&nbsp;</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>Scholars</td>
                                                        <td>119</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td>Grey Pockets</td>
                                                        <td>&nbsp;</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>%</td>
                                                        <td>83.2</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue Pockets</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue Blazers</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </tbody></table>
                                            <table cellspacing="0" cellpadding="0">
                                                <tbody><tr>
                                                    <th colspan="10">DETAILS FOR THE SCHOLAR CERTIFICATES (2019-20) : GRADE XI</th>
                                                </tr>
                                                    <tr>
                                                        <th colspan="10">CRITERIA:&nbsp; 85%&nbsp; and above with no B-grades</th>
                                                    </tr>
                                                    <tr>
                                                        <th rowspan="2">S.N.</th>
                                                        <th rowspan="2">NAME</th>
                                                        <th rowspan="2">GRADE -XI (2019-20)</th>
                                                        <th rowspan="2">GRADE - XII (2020-21)</th>
                                                        <th rowspan="2">%</th>
                                                        <th rowspan="2">SESSIONS</th>
                                                        <th colspan="4">STATUS</th>
                                                    </tr>
                                                    <tr>
                                                        <td>SCHOLAR</td>
                                                        <td>BLAZER</td>
                                                        <td>BADGE</td>
                                                        <td>POCKET</td>
                                                    </tr>
                                                    <tr>
                                                        <td>1</td>
                                                        <td>ALAINA RARA</td>
                                                        <td rowspan="9">ARISTOTLE</td>
                                                        <td rowspan="9">LEONARDO</td>
                                                        <td>90.2</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15, 2013-14</td>
                                                        <td>Super Scholar</td>
                                                        <td rowspan="21">NON</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>2</td>
                                                        <td>ANOUSHKA MATHUR</td>
                                                        <td>90.2</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>3</td>
                                                        <td>ELINA&nbsp; SINGH</td>
                                                        <td>92.4</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15, 2013-14</td>
                                                        <td>Super Scholar</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>4</td>
                                                        <td>RADHIKAA GOEL</td>
                                                        <td>91.8</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>Super Scholar</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>5</td>
                                                        <td>SHAGUN BOHRA</td>
                                                        <td>87</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15, 2013-14</td>
                                                        <td>Super Scholar</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>6</td>
                                                        <td>SUBHIKSHA R.</td>
                                                        <td>85</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>7</td>
                                                        <td>TANVI ARORA</td>
                                                        <td>84.6</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>8</td>
                                                        <td>TRUPTI AGARWAL</td>
                                                        <td>91.17</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15, 2013-14</td>
                                                        <td>Super Scholar</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>9</td>
                                                        <td>YOGITA BAISHYA</td>
                                                        <td>87.4</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15, 2013-14</td>
                                                        <td>Super Scholar</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>10</td>
                                                        <td>AARYAN PERIWAL</td>
                                                        <td rowspan="2">KEYNES</td>
                                                        <td rowspan="2">MARSHALL</td>
                                                        <td>90</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>Super Scholar</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>11</td>
                                                        <td>ABEER CHOPRA</td>
                                                        <td>87.6</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>12</td>
                                                        <td>AARNA MAHESHWARI</td>
                                                        <td rowspan="6">DALTON</td>
                                                        <td rowspan="6">GALILEO</td>
                                                        <td>87.8</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                        <td>Super Scholar</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>13</td>
                                                        <td>NAINIKA GUPTA</td>
                                                        <td>91.2</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15, 2013-14</td>
                                                        <td>Super Scholar</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>14</td>
                                                        <td>NIHARIKA RAJPUT</td>
                                                        <td>91.4</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                        <td>Super Scholar</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>15</td>
                                                        <td>RUBEN DUA</td>
                                                        <td>94</td>
                                                        <td>2019-20 (New Admission)</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>16</td>
                                                        <td>SAKSHAM AGARWAL</td>
                                                        <td>85.8</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>17</td>
                                                        <td>SEEMANTINI RAY</td>
                                                        <td>92.4</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>Super Scholar</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>18</td>
                                                        <td>TANYA MAHAJAN</td>
                                                        <td>EINSTEIN</td>
                                                        <td>ARCHIMEDES</td>
                                                        <td>86</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>Super Scholar</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>19</td>
                                                        <td>ISHANI MUKHERJEE</td>
                                                        <td rowspan="3">SHAKESPEARE</td>
                                                        <td rowspan="3">WORDSWORTH</td>
                                                        <td>85.4</td>
                                                        <td>2019-20, 2018-19,</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>20</td>
                                                        <td>KRITI MALIK</td>
                                                        <td>85</td>
                                                        <td>2019-20, 2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>21</td>
                                                        <td>SUNISHKA SIL</td>
                                                        <td>89.4</td>
                                                        <td>2019-20 (New Admission)</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="7">TOTAL SCHOLARS IN GRADE XI(2019-20) =&nbsp; 21</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Pink Badges</td>
                                                        <td>9</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Blue Badges</td>
                                                        <td>12</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Grey Pockets</td>
                                                        <td>9</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Blue Pockets</td>
                                                        <td>12</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Super Scholars</td>
                                                        <td>12</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>COMPARATIVE ANALYSIS</td>
                                                        <td>2018-19</td>
                                                        <td>2019-20</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Total Strength</td>
                                                        <td>73</td>
                                                        <td>100</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Scholars</td>
                                                        <td>17</td>
                                                        <td>21</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>%</td>
                                                        <td>23</td>
                                                        <td>21</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </tbody></table>
                                            <table cellspacing="0" cellpadding="0">
                                                <tbody><tr>
                                                    <td colspan="9">DETAILS FOR THE SCHOLAR CERTIFICATES : GRADE XII (2019-20)&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                                </tr>
                                                    <tr>
                                                        <td colspan="9">Aggregate 85% and above</td>
                                                    </tr>
                                                    <tr>
                                                        <td rowspan="2">S. N.</td>
                                                        <td rowspan="2">NAMES</td>
                                                        <td rowspan="2">GRADE -XII  &nbsp; (2019-20)</td>
                                                        <td rowspan="2">%</td>
                                                        <td rowspan="2">SESSIONS</td>
                                                        <td colspan="4">STATUS</td>
                                                    </tr>
                                                    <tr>
                                                        <td>SCHOLAR</td>
                                                        <td>BLAZER</td>
                                                        <td>BADGE</td>
                                                        <td>POCKET</td>
                                                    </tr>
                                                    <tr>
                                                        <td>1</td>
                                                        <td>AAKARSH GOYAL</td>
                                                        <td rowspan="24">GALILEO</td>
                                                        <td>94.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>2</td>
                                                        <td>ARNAV NAGPAL</td>
                                                        <td>95.2</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>3</td>
                                                        <td>ADITYA BALLABH</td>
                                                        <td>96</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                        <td>Super Scholar</td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>4</td>
                                                        <td>AMEYA ASHISH DEHADE</td>
                                                        <td>96.4</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16</td>
                                                        <td>Super Scholar</td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>5</td>
                                                        <td>ANGAD SINGH</td>
                                                        <td>86.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>6</td>
                                                        <td>ANIKET SINGH</td>
                                                        <td>96.4</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17</td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>7</td>
                                                        <td>ANSH GROVER</td>
                                                        <td>95.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>8</td>
                                                        <td>ARYAMAN DASH</td>
                                                        <td>93.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>9</td>
                                                        <td>IRIVENTI BHARATH VASISHTA</td>
                                                        <td>92.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>10</td>
                                                        <td>KRITI SINGHAL</td>
                                                        <td>96.6</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15, 2013-14, 2012-13, 2011-12</td>
                                                        <td>Super Scholar</td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>11</td>
                                                        <td>NILAY SINHA</td>
                                                        <td>85.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>12</td>
                                                        <td>OM SINGH</td>
                                                        <td>89.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>13</td>
                                                        <td>PRIKSHIT</td>
                                                        <td>96.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>14</td>
                                                        <td>PRIYA BASIL</td>
                                                        <td>93.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>15</td>
                                                        <td>RAJDEEP DEY</td>
                                                        <td>92.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>16</td>
                                                        <td>SHRIHARI SHATRUGHAN</td>
                                                        <td>94</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>17</td>
                                                        <td>SHRIDHAR SHATRUGHAN</td>
                                                        <td>95</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>18</td>
                                                        <td>SHRITHI KANNAN</td>
                                                        <td>94.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>19</td>
                                                        <td>SONALI GOEL</td>
                                                        <td>96.2</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>Super Scholar</td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>20</td>
                                                        <td>TANISH AGARWAL</td>
                                                        <td>97.4</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15, 2013-14</td>
                                                        <td>Super Scholar</td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>21</td>
                                                        <td>TANISHA AGARWAL</td>
                                                        <td>93.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>22</td>
                                                        <td>TANISHA DHULL</td>
                                                        <td>86.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>23</td>
                                                        <td>VAIBHAV DAS</td>
                                                        <td>90.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>24</td>
                                                        <td>VIBHU DIXIT</td>
                                                        <td>93.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>25</td>
                                                        <td>ADITYA SHARMA</td>
                                                        <td rowspan="15">LEONARDO</td>
                                                        <td>94.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>26</td>
                                                        <td>ANKUSH DHAWAN</td>
                                                        <td>92.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>27</td>
                                                        <td>ANVI GARG</td>
                                                        <td>96.8</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>Super Scholar</td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>28</td>
                                                        <td>ARNAV CHAWLA</td>
                                                        <td>87.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>29</td>
                                                        <td>CHAVI VERMA</td>
                                                        <td>94.4</td>
                                                        <td>2019-20, 2018-19, 2017-18</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>30</td>
                                                        <td>DHANYAMRAJU AALOKA</td>
                                                        <td>91.8</td>
                                                        <td>2019-20, 2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>Super Scholar</td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>31</td>
                                                        <td>KRIVI NATH</td>
                                                        <td>94</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>32</td>
                                                        <td>KUSHAGRA PRATAP SINGH</td>
                                                        <td>89.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>33</td>
                                                        <td>MITULA SAI SUBRAMANIAN</td>
                                                        <td>94.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>34</td>
                                                        <td>MUSKAN VASAL</td>
                                                        <td>88.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>35</td>
                                                        <td>RITVIK MINHAS</td>
                                                        <td>93.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>36</td>
                                                        <td>SANCHIT GUGLANI</td>
                                                        <td>94.8</td>
                                                        <td>2019-20,2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>Super Scholar</td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>37</td>
                                                        <td>SATVIK RAI</td>
                                                        <td>92</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>38</td>
                                                        <td>SHAAN MEHTA</td>
                                                        <td>91.4</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>39</td>
                                                        <td>SUKHMANI SINGH</td>
                                                        <td>94.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>40</td>
                                                        <td>AKSHITA MAKIN</td>
                                                        <td rowspan="12">WORDSWORTH</td>
                                                        <td>93.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>41</td>
                                                        <td>ANANDI RAY</td>
                                                        <td>90.4</td>
                                                        <td>2019-20,2018-19, 2017-18</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>42</td>
                                                        <td>KASHMIRA AJEY SHILEDAR</td>
                                                        <td>87.8</td>
                                                        <td>2019-20,2018-19, 2017-18, 2016-17, 2015-16, 2014-15</td>
                                                        <td>Super Scholar</td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>43</td>
                                                        <td>KHUSHI ANAND</td>
                                                        <td>94.2</td>
                                                        <td>&nbsp;2019-20,2018-19, 2017-18, 2016-17, 2015-16, 2014-15, 2013-14, 2012-13</td>
                                                        <td>Super Scholar</td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>44</td>
                                                        <td>LAKSHITA KHANNA</td>
                                                        <td>90.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>45</td>
                                                        <td>PRANAV GOSWAMY</td>
                                                        <td>96.8</td>
                                                        <td>2019-20,2018-19, 2017-18, 2016-17</td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>46</td>
                                                        <td>PRERNA VIJ</td>
                                                        <td>93.2</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>47</td>
                                                        <td>RHEAA NAIR</td>
                                                        <td>91</td>
                                                        <td>2019-20,2018-19, 2017-18, 2016-17</td>
                                                        <td>&nbsp;</td>
                                                        <td>Blue&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>48</td>
                                                        <td>SHUBHI JAIN</td>
                                                        <td>91.8</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>49</td>
                                                        <td>TANYA SINGH</td>
                                                        <td>92</td>
                                                        <td>2019-20,2018-19</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>50</td>
                                                        <td>VANSHIKA SINGH</td>
                                                        <td>86.6</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td>51</td>
                                                        <td>VRIDHI MUDGAL</td>
                                                        <td>88</td>
                                                        <td>2019-20</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td>Pink&nbsp;</td>
                                                        <td>Grey</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td align="right">10</td>
                                                        <td align="right">4</td>
                                                        <td align="right">10</td>
                                                        <td align="right">37</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6">TOTAL SCHOLARS IN GRADE XII&nbsp; (2019-20) =&nbsp; 51</td>
                                                        <td></td>
                                                        <td align="right">41</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Pink Badges</td>
                                                        <td>41</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Blue Badges</td>
                                                        <td>10</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Grey Pockets</td>
                                                        <td>37</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Blue Pockets</td>
                                                        <td>10</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Blue Blazers</td>
                                                        <td>4</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Super Scholars</td>
                                                        <td>10</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Total Strength</td>
                                                        <td>59</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>Scholars</td>
                                                        <td>51</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>%</td>
                                                        <td>86</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </tbody></table>
                                            <co>
                                            </co><table cellspacing="0" cellpadding="0">
                                                <tbody><tr>
                                                    <th colspan="5">SCHOLAR BADGE STATUS (2019-20)</th>
                                                </tr>

                                                    <tr>
                                                        <td>GRADE</td>
                                                        <td>NO. OF SCHLRS</td>
                                                        <td>CLASS STRGTH</td>
                                                        <td>SCHLR %</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>V</td>
                                                        <td>126</td>
                                                        <td>235</td>
                                                        <td>54</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>VI</td>
                                                        <td>94</td>
                                                        <td>231</td>
                                                        <td>41</td>
                                                        <td rowspan="3">&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>VII</td>
                                                        <td>52</td>
                                                        <td>201</td>
                                                        <td>26</td>
                                                    </tr>
                                                    <tr>
                                                        <td>VIII</td>
                                                        <td>68</td>
                                                        <td>201</td>
                                                        <td>34</td>
                                                    </tr>
                                                    <tr>
                                                        <td>TOTAL 1</td>
                                                        <td>340</td>
                                                        <td>868</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IX</td>
                                                        <td>57</td>
                                                        <td>152</td>
                                                        <td>38</td>
                                                        <td rowspan="4">&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>X</td>
                                                        <td>0</td>
                                                        <td>0</td>
                                                        <td>0</td>
                                                    </tr>
                                                    <tr>
                                                        <td>XI</td>
                                                        <td>21</td>
                                                        <td>100</td>
                                                        <td>21</td>
                                                    </tr>
                                                    <tr>
                                                        <td>XII</td>
                                                        <td>0</td>
                                                        <td>0</td>
                                                        <td>0</td>
                                                    </tr>
                                                    <tr>
                                                        <td>TOTAL 2</td>
                                                        <td>78</td>
                                                        <td>252</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>TOTAL</td>
                                                        <td>758</td>
                                                        <td>1988</td>
                                                        <td>37</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td colspan="3"></td>
                                                    </tr>

                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td>VI-VIII</td>
                                                        <td>IX-XII</td>
                                                        <td>TOTAL</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Pink Badges</td>
                                                        <td>340</td>
                                                        <td>49</td>
                                                        <td>389</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Blue Badges</td>
                                                        <td>0</td>
                                                        <td>29</td>
                                                        <td>29</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Grey Pockets</td>
                                                        <td>301</td>
                                                        <td>43</td>
                                                        <td>344</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Blue Pockets</td>
                                                        <td>0</td>
                                                        <td>29</td>
                                                        <td>29</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Blue Blazers</td>
                                                        <td>39</td>
                                                        <td>6</td>
                                                        <td>45</td>
                                                        <td></td>
                                                    </tr>


                                                    <tr>
                                                        <td colspan="5">SCHOLAR NUMBERS ANALYSIS 2018 Vs 2019</td>
                                                    </tr>

                                                    <tr>
                                                        <td colspan="2">Total Count (2018-19)</td>
                                                        <td></td>
                                                        <td colspan="2">Total Count (2019-20)</td>
                                                    </tr>
                                                    <tr>
                                                        <td>V</td>
                                                        <td>133</td>
                                                        <td></td>
                                                        <td>V</td>
                                                        <td>126</td>
                                                    </tr>
                                                    <tr>
                                                        <td>VI</td>
                                                        <td>55</td>
                                                        <td></td>
                                                        <td>VI</td>
                                                        <td>94</td>
                                                    </tr>
                                                    <tr>
                                                        <td>VII</td>
                                                        <td>69</td>
                                                        <td></td>
                                                        <td>VII</td>
                                                        <td>52</td>
                                                    </tr>
                                                    <tr>
                                                        <td>VIII</td>
                                                        <td>43</td>
                                                        <td></td>
                                                        <td>VIII</td>
                                                        <td>68</td>
                                                    </tr>
                                                    <tr>
                                                        <td>VI to VIII</td>
                                                        <td>300</td>
                                                        <td></td>
                                                        <td>VI to VIII</td>
                                                        <td>340</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Out of</td>
                                                        <td>1021</td>
                                                        <td></td>
                                                        <td>Out of</td>
                                                        <td>868</td>
                                                    </tr>
                                                    <tr>
                                                        <td>%</td>
                                                        <td>29.38295788</td>
                                                        <td></td>
                                                        <td>%</td>
                                                        <td>39.17050691</td>
                                                    </tr>

                                                    <tr>
                                                        <td>IX</td>
                                                        <td>29</td>
                                                        <td></td>
                                                        <td>IX</td>
                                                        <td>57</td>
                                                    </tr>
                                                    <tr>
                                                        <td>X</td>
                                                        <td>89</td>
                                                        <td></td>
                                                        <td>X</td>
                                                        <td>0</td>
                                                    </tr>
                                                    <tr>
                                                        <td>XI</td>
                                                        <td>17</td>
                                                        <td></td>
                                                        <td>XI</td>
                                                        <td>21</td>
                                                    </tr>
                                                    <tr>
                                                        <td>XII</td>
                                                        <td>54</td>
                                                        <td></td>
                                                        <td>XII</td>
                                                        <td>0</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IX to XII</td>
                                                        <td>189</td>
                                                        <td></td>
                                                        <td>IX to XII</td>
                                                        <td>78</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Out of</td>
                                                        <td>422</td>
                                                        <td></td>
                                                        <td>Out of</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>%</td>
                                                        <td>44.78672986</td>
                                                        <td></td>
                                                        <td>%</td>
                                                        <td>#DIV/0!</td>
                                                    </tr>

                                                    <tr>
                                                        <td>TOTAL&nbsp;</td>
                                                        <td>489</td>
                                                        <td>&nbsp;</td>
                                                        <td>TOTAL&nbsp;</td>
                                                        <td>418</td>
                                                    </tr>

                                                    <tr>
                                                        <td></td>
                                                        <td>% Increase =</td>
                                                        <td>&nbsp;</td>
                                                        <td>&nbsp;</td>
                                                        <td></td>
                                                    </tr>

                                                </tbody></table>
                                        </div>
                                    </div>
                                )
                            }

                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}
export default SchoolBadgeHolder